<template>
  <div class="consignment-main-container">
    <div class="menu-container">
      <Menus :menuWidthCollapse="60" class="menu-scroll" style="overflow-y: auto">
        <BoxContainer
          title="Consignment"
          :isCollapsible="true"
          style="width: 100%; padding-top: 15px"
          :isCollapsed="haulageMenuIsCollapsed.Container"
          @collapseArrowClicked="haulageMenuHeaderClicked($event, 'Container')"
        >
          <button class="menu-action" @click="EditCNClicked" :disabled="!editContainerEnabled">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/ContainerNo.png"
              alt="Edit Container #"
            />
            Edit Container #
          </button>
          <button class="menu-action" @click="EditCNClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/icons8-view-64.png"
              alt="View/Create Diversion"
            />
            View/Create Diversion
          </button>
          <button class="menu-action" @click="EditCNClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/RequiredDate.png"
              alt="Edit Required Date"
            />
            Edit Required Date
          </button>
          <button class="menu-action" @click="EditCNClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/PlanDate.png"
              alt="Edit Plan Date"
            />
            Edit Plan Date
          </button>
          <button class="menu-action" @click="EditCNClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/Operator.png"
              alt="Change Operator"
            />
            Change Operator
          </button>
          <button class="menu-action" @click="EditCNClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png"
              alt="Edit Job Type"
            />
            Edit Job Type
          </button>
          <button class="menu-action" @click="AddRemarksClicked" :disabled="cnDetailsFulfill">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/icons8-attach-64.png"
              alt="Remarks"
            />
            Remarks
          </button>
        </BoxContainer>
        <button class="menu-action" style="margin-top: 5px" @click="EditVoyageInfoClicked">
          <img
            class="menu-action-icon"
            src="https://dsmlib.logistics.systems/Icons/Vessel.png"
            alt="Edit Voyage Info"
          />
          Edit Voyage Info
        </button>
        <button class="menu-action" @click="UpdateTrailerClicked">
          <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Trailer.png" alt="Update Trailer" />
          Update Trailer
        </button>
        <button class="menu-action" @click="consignmentPrintJobNo">
          <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Print.png" alt="Print CN" />
          Print CN
        </button>
        <button class="menu-action" @click="consignmentPrintDiversion">
          <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Print.png" alt="Print Diversion" />
          Print Diversion
        </button>
        <button class="menu-action" @click="consignmentPrintDetails" :disabled="cnDetailsFulfill">
          <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Print.png" alt="Print CN Details" />
          Print CN Details
        </button>
        <BoxContainer
          title="RFC"
          :isCollapsible="true"
          style="width: 100%; padding-top: 15px"
          :isCollapsed="haulageMenuIsCollapsed.RFC"
          @collapseArrowClicked="haulageMenuHeaderClicked($event, 'RFC')"
        >
          <button class="menu-action" @click="RFCUpdateMenuButtonClicked" :disabled="!rfcUpdateEnabled">
            <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Ready2.png" alt="RFC update" />
            RFC Update
          </button>
          <button class="menu-action" @click="reverseRFCMenuButtonClicked">
            <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Reverse.png" alt="Reverse RFC" />
            Reverse RFC
          </button>
        </BoxContainer>
        <BoxContainer
          title="Destination"
          :isCollapsible="true"
          style="width: 100%; padding-top: 15px"
          :isCollapsed="haulageMenuIsCollapsed.Destination"
          @collapseArrowClicked="haulageMenuHeaderClicked($event, 'Destination')"
        >
          <button class="menu-action" @click="DestMenuButtonClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/HMSPickUp.png"
              alt="Change Pick-up"
            />
            Change Pick-up
          </button>
          <button class="menu-action" @click="DestMenuButtonClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/HMSDropOff.png"
              alt="Change Drop-off"
            />
            Change Drop-off
          </button>
          <button class="menu-action" @click="DestMenuButtonClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/Terminal.png"
              alt="Change Discharge Port"
            />
            Change Discharge Port
          </button>
        </BoxContainer>
        <BoxContainer
          title="Receive Documents"
          :isCollapsible="true"
          style="width: 100%; padding-top: 15px"
          :isCollapsed="haulageMenuIsCollapsed['Receive Documents']"
          @collapseArrowClicked="haulageMenuHeaderClicked($event, 'Receive Documents')"
        >
          <button class="menu-action" @click="ReceiveDocsClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/GatePassCMO.png"
              alt="Gate Pass/ CMO"
            />
            Gate Pass/ CMO
          </button>
          <button class="menu-action" @click="ReceiveDocsClicked">
            <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Seal.png" alt="Seal" />
            Seal
          </button>
          <button class="menu-action" @click="ReceiveDocsClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/ChequeReceipt.png"
              alt="Cheque/ Receipt"
            />
            Cheque/ Receipt
          </button>
          <button class="menu-action" @click="ReceiveDocsClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/ChequeReceipt.png"
              alt="Bill of Lading (B/L)"
            />
            Bill of Lading (B/L)
          </button>
          <button class="menu-action" @click="ReceiveDocsClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/Fumigation.png"
              alt="Fumigation"
            />
            Fumigation
          </button>
        </BoxContainer>
        <button class="menu-action" style="margin-top: 5px" @click="RequestHoldClicked">
          <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Hold.png" alt="Hold" />
          Request Hold
        </button>
        <button class="menu-action" @click="RequestHoldClicked">
          <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Unhold.png" alt="Unhold" />
          Release Hold
        </button>
        <div class="collapsed-menu" slot="collapse">
          <BoxContainer
            :isCollapsible="true"
            :isCollapsed="haulageMenuIsCollapsed.Container"
            :minWidth="50"
            @collapseArrowClicked="haulageMenuHeaderClicked($event, 'Container')"
            style="padding-top: 15px"
          >
            <button class="menu-action" @click="EditCNClicked" :disabled="!editContainerEnabled">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/ContainerNo.png"
                alt="Edit Container #"
              />
            </button>
            <button class="menu-action" @click="EditCNClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/icons8-view-64.png"
                alt="View/Create Diversion"
              />
            </button>
            <button class="menu-action" @click="EditCNClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/RequiredDate.png"
                alt="Edit Required Date"
              />
            </button>
            <button class="menu-action" @click="EditCNClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/PlanDate.png"
                alt="Edit Plan Date"
              />
            </button>
            <button class="menu-action" @click="EditCNClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/Operator.png"
                alt="Change Operator"
              />
            </button>
            <button class="menu-action" @click="EditCNClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png"
                alt="Edit Job Type"
              />
            </button>
            <button class="menu-action" @click="AddRemarksClicked" :disabled="cnDetailsFulfill">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/icons8-attach-64.png"
                alt="Remarks"
              />
            </button>
          </BoxContainer>
          <button class="menu-action" style="margin-top: 5px" @click="EditVoyageInfoClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/Vessel.png"
              alt="Edit Voyage Info"
            />
          </button>
          <button class="menu-action" @click="UpdateTrailerClicked">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/Trailer.png"
              alt="Update Trailer"
            />
          </button>
          <button class="menu-action" style="margin-top: 5px" @click="consignmentPrintJobNo">
            <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Print.png" alt="Print CN" />
          </button>
          <button class="menu-action" @click="consignmentPrintDiversion">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/Print.png"
              alt="Print Diversion"
            />
          </button>
          <button class="menu-action" @click="consignmentPrintDetails">
            <img
              class="menu-action-icon"
              src="https://dsmlib.logistics.systems/Icons/Print.png"
              alt="Print CN Details"
            />
          </button>
          <BoxContainer
            :isCollapsible="true"
            :isCollapsed="haulageMenuIsCollapsed.RFC"
            :minWidth="50"
            @collapseArrowClicked="haulageMenuHeaderClicked($event, 'RFC')"
            style="padding-top: 15px"
          >
            <button class="menu-action" @click="RFCUpdateMenuButtonClicked" :disabled="!rfcUpdateEnabled">
              <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Ready2.png" alt="RFC update" />
            </button>
            <button class="menu-action" @click="reverseRFCMenuButtonClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/Reverse.png"
                alt="Reverse RFC"
              />
            </button>
          </BoxContainer>
          <BoxContainer
            :isCollapsible="true"
            style="width: 100%; padding-top: 15px"
            :isCollapsed="haulageMenuIsCollapsed.Destination"
            @collapseArrowClicked="haulageMenuHeaderClicked($event, 'Destination')"
          >
            <button class="menu-action" @click="DestMenuButtonClicked">
              <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/HMSPickUp.png" alt="Pick-up" />
            </button>
            <button class="menu-action" @click="DestMenuButtonClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/HMSDropOff.png"
                alt="Drop-off"
              />
            </button>
            <button class="menu-action" @click="DestMenuButtonClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/Terminal.png"
                alt="Change Discharge Port"
              />
            </button>
          </BoxContainer>
          <BoxContainer
            :isCollapsible="true"
            :isCollapsed="haulageMenuIsCollapsed['Receive Documents']"
            :minWidth="50"
            @collapseArrowClicked="haulageMenuHeaderClicked($event, 'Receive Documents')"
            style="padding-top: 15px"
          >
            <button class="menu-action" @click="ReceiveDocsClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/GatePassCMO.png"
                alt="Gate Pass/ CMO"
              />
            </button>
            <button class="menu-action" @click="ReceiveDocsClicked">
              <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Seal.png" alt="Seal" />
            </button>
            <button class="menu-action" @click="ReceiveDocsClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/ChequeReceipt.png"
                alt="Cheque/ Receipt"
              />
            </button>
            <button class="menu-action" @click="ReceiveDocsClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/ChequeReceipt.png"
                alt="Bill of Lading (B/L)"
              />
            </button>
            <button class="menu-action" @click="ReceiveDocsClicked">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/Fumigation.png"
                alt="Fumigation"
              />
            </button>
          </BoxContainer>
          <button class="menu-action" style="margin-top: 5px" @click="RequestHoldClicked">
            <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Hold.png" alt="Hold" />
          </button>
          <button class="menu-action" @click="RequestHoldClicked">
            <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Unhold.png" alt="Unhold" />
          </button>
        </div>
      </Menus>
    </div>
    <div class="main-content">
      <div class="filters-container">
        <div class="filters-summary">
          {{ filtersSummary }}
        </div>
        <ButtonFilter
          buttonText="Change Filters"
          filterPosition="right"
          :filterWidth="330"
          :isOpen.sync="filtersIsOpen"
        >
          <BoxContainer title="Search" :isCheckBox="false" style="margin-bottom: 10px">
            <Dropdown
              :items="filtersSearchByDropdownItems"
              itemKey="Search"
              :selectedObject.sync="filtersSearchByDropdownSelectedObject"
              placeholder="Search By"
              :isRequired="true"
              :errorMessage.sync="filtersSearchByDropdownErrorMessage"
              @selected="filtersSearchByDropdownSelected"
            />
            <Dropdown
              :items="filtersSearchCriteriaDropdownItems"
              itemKey="Criteria"
              :selectedObject.sync="filtersSearchCriteriaDropdownSelectedObject"
              placeholder="Search Criteria"
              :isRequired="true"
              :errorMessage.sync="filtersSearchCriteriaDropdownErrorMessage"
              :isDisabled="filtersSearchCriteriaDropdownIsDisabled"
            />
            <Input
              v-if="filtersSearchValueControlType === 'Input'"
              :inputValue.sync="filtersSearchInputValue"
              :isRequired="true"
              :errorMessage.sync="filtersSearchInputErrorMessage"
              :isDisabled="filtersSearchValueFieldIsDisabled"
              placeholder="Search"
              @keyup="filtersSearchInputKeyup"
            />
            <DateTimePicker
              v-else-if="filtersSearchValueControlType === 'DateTimePicker'"
              :value.sync="filtersSearchDateTimePickerValue"
              :showTime="false"
              :isRequired="true"
              :errorMessage.sync="filtersSearchDateTimePickerErrorMessage"
              :isDisabled="filtersSearchValueFieldIsDisabled"
              placeholder="Search"
            />
          </BoxContainer>
          <Dropdown
            :items="filtersViewOptionsDropdownItems"
            itemKey="ViewOption"
            :selectedObject.sync="filtersViewOptionsDropdownSelectedObject"
            placeholder="View"
            :isRequired="true"
            :errorMessage.sync="filtersViewOptionsDropdownErrorMessage"
          />
          <Input
            :inputValue.sync="filtersMaxRowsInputValue"
            :errorMessage.sync="filtersMaxRowsInputErrorMessage"
            textType="number"
            placeholder="Max Rows"
          />
          <div class="refresh-button-container">
            <button @click="filtersRefreshClicked"> Refresh </button>
          </div>
        </ButtonFilter>
        <div class="last-refreshed">
          {{ lastRefreshedDateTimeFormatted }}
        </div>
      </div>
      <div class="consignments-table-box-container">
        <TableBox
          :tableData="consignmentsTableBoxTableData"
          title="Consignments"
          :selectedRow.sync="consignmentsTableBoxSelectedRow"
          :hideColumns="consignmentsTableBoxHideColumns"
          @rowSelected="consignmentsTableBoxRowSelected"
          :maxSelection="-1"
          :additionalButtons="additionalBtn"
          @buttonClicked="additionalBtnClicked"
          :columnOrderViews.sync="tableBoxColumnOrderViews"
          :columnOrderID="tableBoxColumnOrderID"
          :loading="refreshClicked"
          :selectedIndex="selectedIndex"
        />
      </div>
    </div>
    <RightMenu
      :showMenu.sync="showTripDetails"
      :minWidth="400"
      :defaultWidth="rightMenuOpenWidth"
      :maxWidth="600"
      :width.sync="rightMenuOpenWidth"
    >
      <div class="right-menu">
        <div class="right-menu-body-scroll">
          <ConsignmentDetails
            v-if="showTripDetails && cnDetailsData && cnDetailsData.Details"
            :cnDetails="[cnDetailsData.Details]"
            :isLoading="cnDetailsFulfill"
          />
          <TripDetails :tripDetails="tripDetailsData" />
          <div
            v-if="showTripDetails && cnDetailsData && cnDetailsData.Details && cnDetailsData.Details.SMK_NO"
            class="header"
          >
            <div class="title"> SMK No: {{ cnDetailsData.Details.SMK_NO }} </div>
          </div>
        </div>

        <div class="right-menu-footer">
          <div
            class="message-container"
            :style="messageContainerStyling"
            style="font-weight: bold"
            v-html="radioCallResultMessage"
          />
          <div class="buttons-container">
            <button @click="detailNonRevButtonClicked">Details Non Revenue</button>
            <button @click="radioCallButtonClicked">Update Status</button>
          </div>
        </div>
      </div>
    </RightMenu>
    <RightMenu
      :showMenu.sync="showRightMenu"
      :minWidth="400"
      :defaultWidth="rightMenuOpenWidth"
      :maxWidth="600"
      :width.sync="rightMenuOpenWidth"
    >
      <div class="right-menu-content-container">
        <div class="header-container">
          <div class="header-back-button" @click="rightMenuBackClicked"> ᐊ Consignment Summary - </div>
          <div class="header-title">
            {{ updateStatusTaskClicked ? 'Update Status' : 'Detail Non Revenue Movement' }}
          </div>
        </div>
        <div class="body-container">
          <HMSUpdateStatusTask
            v-if="updateStatusTaskClicked"
            :data="selectedUpdateStatusCN[0]"
            :rightMenuWidth="0"
            :attachmentsChanged.sync="radioCallAttachmentsChanged"
            @statusUpdate="radioCallStatusUpdated"
            @statusReverse="radioCallStatusReversed"
          />
          <AssignV3
            v-if="detailNonRevClicked"
            :show.sync="detailNonRevClicked"
            :assignData.sync="nonRevCN"
            :subShow="true"
            :showHeader="false"
            :nonRev="true"
          />
        </div>
        <div
          v-if="updateStatusTaskClicked"
          class="footer-container"
          style="min-height: 80px; max-height: 80px; background-color: #535cda !important"
        >
          <div
            class="message-container"
            :style="messageContainerStyling"
            style="font-weight: bold"
            v-html="radioCallResultMessage"
          />
        </div>
      </div>
    </RightMenu>
    <PopupV2
      :show="showEditCont"
      :title="'Edit Container Number / Seal Number'"
      :buttons="EditContPopupButtons"
      @buttonClicked="EditContPopupButtonsClicked"
    >
      <div>
        <Input placeholder="Consignment #" :inputValue.sync="oldConsignmentNo" :isDisabled="true" />
        <div style="display: flex; justify-content: space-between; gap: 5px">
          <Input placeholder="Container No" :inputValue.sync="oldContainerNo" :isDisabled="true" />
          <Input placeholder="Seal No" :inputValue.sync="oldSealNo" :isDisabled="true" />
        </div>
        <div style="display: flex; justify-content: space-between; gap: 5px">
          <Input
            placeholder="New Container No"
            :inputValue.sync="newContainerNo"
            :isContainer="true"
            :isRequired="true"
            :errorMessage.sync="ContainerNoErrMsg"
            validator="alphanumeric,25,uppercase"
          />
          <Input placeholder="New Seal No" :inputValue.sync="newSealNo" validator="alphanumeric,20,uppercase" />
        </div>
        <RemarksBox title="Remarks" :maxLength="200" :text.sync="remarks" />
      </div>
    </PopupV2>
    <PopupEntry
      :title="popupTitle"
      :show.sync="showEditCN"
      v-if="showEditCN"
      @save="EditCNSaveClicked"
      :successMessages="popupEntrySuccessMessages"
      :errorMessages="popupEntryErrorMessages"
      :cancelButton="saveClicked ? 'Close' : 'Cancel'"
      :viewMode="saveClicked"
    >
      <div class="popupentry-body">
        <div class="popupentry-content">
          <div v-if="EditCNTitle == 'Edit Plan Date'" class="form-row">
            <div class="input-field">
              <DateTimePicker
                placeholder="Plan Date"
                :value.sync="planDateValue"
                :isDisabled="saveClicked"
                :isRequired="true"
                :errorMessage.sync="PlanDateErrMsg"
                :maxDate="smallDateTimeMaxDate"
                :minDate="smallDateTimeMinValue"
                @dateChanged="checkDate('Plan Date', $event)"
              />
            </div>
            <div class="input-field">
              <Dropdown
                placeholder="Priority"
                :items="priorityDropdownItems"
                itemKey="value"
                :selectedObject.sync="selectedPriority"
                :isDisabled="saveClicked"
              />
            </div>
          </div>

          <div v-if="EditCNTitle == 'Edit Required Date'" class="form-row">
            <div class="input-field">
              <DateTimePicker
                placeholder="New Required Date"
                :value.sync="newReqDateValue"
                :isDisabled="saveClicked"
                :isRequired="true"
                :errorMessage.sync="RequiredDateErrMsg"
                :maxDate="smallDateTimeMaxDate"
                :minDate="smallDateTimeMinValue"
                @dateChanged="checkDate('New Required Date', $event)"
              />
            </div>
            <div class="input-field">
              <Dropdown
                style="flex: 1; width: 200px"
                :items="requiredTimeDescItems"
                itemKey="Description"
                placeholder="Required Time Desc."
                :selectedObject.sync="requiredTimeDescSelectedObject"
                :search.sync="requiredTimeDescSearch"
                :allowFreeText="true"
                validator="text,20"
                :isDisabled="saveClicked"
              />
            </div>
            <div class="input-field">
              <CheckBoxV2 title="Office Hours" :isChecked.sync="officeHrsChecked" :isDisabled="saveClicked" />
            </div>
          </div>

          <div v-if="EditCNTitle == 'Change Operator'" class="form-row">
            <div class="input-field">
              <Input
                placeholder="New Cont. Operator"
                :isRequired="true"
                :inputValue.sync="newContOptInput"
                :isDisabled="saveClicked"
                validator="text,15"
                :errorMessage.sync="operatorErrMsg"
              />
            </div>
          </div>

          <div v-if="EditCNTitle == 'Edit Job Type'" class="form-row">
            <div class="input-field">
              <InputQuery
                placeholder="Job Type"
                :selectedObject.sync="selectedJobType"
                :isRequired="true"
                :isDisabled="saveClicked"
                :items="allJobTypes"
                itemKey="Job Type"
                :errorMessage.sync="jobTypeErrMsg"
              />
            </div>
          </div>

          <div v-if="EditCNTitle == 'Edit Plan Date'" class="form-row">
            <div class="input-field">
              <InputQuery
                placeholder="PM Code"
                :selectedObject.sync="selectedPMCode"
                :isRequired="true"
                :isDisabled="saveClicked"
                :items="PMList"
                itemKey="Code - Name"
                @selected="PMCodeSelected"
                :errorMessage.sync="PMCodeErrMsg"
              />
            </div>
            <div class="input-field">
              <InputQuery
                placeholder="Driver"
                :selectedObject.sync="selectedDriver"
                :isRequired="true"
                :isDisabled="saveClicked"
                :items="driverList"
                itemKey="Code - Name"
                :errorMessage.sync="DriverErrMsg"
              />
            </div>
            <div class="input-field">
              <Dropdown
                placeholder="Team"
                :isDisabled="true"
                :items="teamList"
                itemKey="Team"
                :selectedObject.sync="selectedTeam"
              />
            </div>
            <div class="input-field">
              <Dropdown
                placeholder="Shift"
                :selectedObject.sync="selectedShift"
                :isDisabled="saveClicked"
                :items="shiftList"
                itemKey="ShiftDesc"
              />
            </div>
          </div>
          <div class="form-row">
            <RemarksBox :text.sync="newReqPlanRemarksInput" :maxLength="200" :isDisabled="saveClicked" />
          </div>
        </div>
        <!-- <div v-if="!saveClicked" class="call-to-action-buttons">
          <button @click="EditSelectedRowClicked(EditCNTitle)">Edit</button>
        </div> -->
        <TableBox
          v-if="editCNContentTable"
          class="contacts-table-box"
          :tableData="popupConsignmentList"
          title="Consignments"
          :maxSelection="0"
          :hideColumns="hideColumns"
          :selectedRow.sync="selectedEditRow"
        />
      </div>
    </PopupEntry>
    <PopupEntry
      :title="popupTitle"
      :show.sync="showVoyageInfoPopup"
      v-if="showVoyageInfoPopup"
      @save="EditVoySaveClicked"
      :successMessages="popupEntrySuccessMessages"
      :errorMessages="popupEntryErrorMessages"
      :viewMode="saveClicked"
      :cancelButton="saveClicked ? 'Close' : 'Cancel'"
    >
      <div class="popupentry-body">
        <div class="popupentry-content">
          <div class="form-row">
            <div class="input-field">
              <InputQuery
                placeholder="Ship Call #"
                :selectedObject.sync="selectedSCN"
                :items="SCNList"
                @selected="VesselInfoSelected"
                itemKey="SCN - Terminal"
                :isDisabled="saveClicked"
              />
            </div>
            <div class="input-field">
              <InputQuery
                placeholder="Vessel ID"
                :selectedObject.sync="selectedVesselID"
                :items="vesselList"
                itemKey="Vessel ID"
                :search.sync="vesselIDFreeText"
                :allowFreeText="true"
                :isDisabled="saveClicked"
              />
            </div>
            <div class="input-field">
              <InputQuery
                placeholder="Vessel Name"
                :selectedObject.sync="selectedVesselName"
                :items="vesselList"
                itemKey="Vessel Name"
                :search.sync="vesselNameFreeText"
                :allowFreeText="true"
                :isDisabled="saveClicked"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="input-field" style="width: 400px">
              <Input
                placeholder="Shipping Line"
                :inputValue.sync="shippingLineInput"
                validator="text,50,uppercase"
                :isDisabled="saveClicked"
              />
            </div>
            <div class="input-field" style="width: 500px">
              <InputQuery
                placeholder="Shipping Agent"
                :selectedObject.sync="selectedShippingAgent"
                :items="shippingAgentList"
                itemKey="Code - Name"
                :allowFreeText="true"
                :isDisabled="saveClicked"
              />
            </div>
            <div class="input-field" style="width: 400px">
              <Input
                placeholder="Final Destination"
                :inputValue.sync="finalDestinationInput"
                validator="text,50"
                :isDisabled="saveClicked"
              />
            </div>
            <div class="input-field" style="width: 200px">
              <Input
                placeholder="Booking Ref No"
                :inputValue.sync="bookingRefNoInput"
                validator="text,25"
                :isDisabled="saveClicked"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="input-field">
              <DateTimePicker
                placeholder="ETA"
                :value.sync="ETADateTimeValue"
                :errorMessage.sync="ETAErrMsg"
                :maxDate="smallDateTimeMaxDate"
                :minDate="smallDateTimeMinValue"
                @dateChanged="checkDate('ETA Date Time', $event)"
                :isDisabled="saveClicked"
              />
            </div>
            <div class="input-field">
              <DateTimePicker
                placeholder="ETD"
                :value.sync="ETDDateTimeValue"
                :errorMessage.sync="ETDErrMsg"
                :maxDate="smallDateTimeMaxDate"
                :minDate="smallDateTimeMinValue"
                @dateChanged="checkDate('ETD Date Time', $event)"
                :isDisabled="saveClicked"
              />
            </div>
            <div class="input-field">
              <DateTimePicker
                placeholder="Closing Date"
                :value.sync="closingDateTimeValue"
                :errorMessage.sync="closingDateErrMsg"
                :maxDate="smallDateTimeMaxDate"
                :minDate="smallDateTimeMinValue"
                @dateChanged="checkDate('Closing Date Time', $event)"
                :isDisabled="saveClicked"
              />
            </div>
            <div class="input-field">
              <DateTimePicker
                placeholder="Detention Date"
                :value.sync="detentionDateTimeValue"
                :errorMessage.sync="detentionDateErrMsg"
                :maxDate="smallDateTimeMaxDate"
                :minDate="smallDateTimeMinValue"
                :showTime="false"
                @dateChanged="checkDate('Detention Date Time', $event)"
                :isDisabled="saveClicked"
              />
            </div>
          </div>
          <div class="form-row">
            <RemarksBox :text.sync="newVoyRemark" :maxLength="200" :isDisabled="saveClicked" />
          </div>
        </div>
        <!-- <div v-if="!saveClicked" class="call-to-action-buttons">
          <button @click="EditSelectedRowClicked(popupTitle)">Edit</button>
        </div> -->
        <TableBox
          v-if="editVoyInfoContentTable"
          class="contacts-table-box"
          :tableData="popupConsignmentList"
          title="Consignments"
          :maxSelection="0"
          :hideColumns="hideColumns"
          :selectedRow.sync="selectedEditRow"
        />
      </div>
    </PopupEntry>
    <PopupEntry
      :title="popupTitle"
      :show.sync="showDestInfoPopup"
      v-if="showDestInfoPopup"
      @save="EditDestSaveClicked"
      :successMessages="popupEntrySuccessMessages"
      :errorMessages="popupEntryErrorMessages"
      :viewMode="saveClicked"
      :cancelButton="saveClicked ? 'Close' : 'Cancel'"
    >
      <div class="popupentry-body">
        <div class="popupentry-content">
          <div class="form-row">
            <div class="input-field" style="width: 100%">
              <InputQuery
                :placeholder="popupTitle.replace('Change ', '')"
                :isRequired="true"
                :selectedObject.sync="selectedDest"
                :items="isDischargePort ? portList : destList"
                itemKey="Code - Name"
                :isDisabled="saveClicked"
                :errorMessage.sync="selectDestErrMsg"
              />
            </div>
          </div>
          <div class="form-row">
            <RemarksBox :text.sync="newVoyRemark" :maxLength="200" :isDisabled="saveClicked" />
          </div>
        </div>
        <TableBox
          v-if="showDestInfoPopup"
          class="contacts-table-box"
          :tableData="popupConsignmentList"
          title="Consignments"
          :maxSelection="0"
          :hideColumns="hideColumns"
          :selectedRow.sync="selectedEditRow"
        />
      </div>
    </PopupEntry>
    <PopupEntry
      :title="popupTitle"
      :show.sync="showTrailerPopup"
      v-if="showTrailerPopup"
      @save="UpdateTrailerSaveClicked"
      :successMessages="popupEntrySuccessMessages"
      :errorMessages="popupEntryErrorMessages"
      cancelButton="Cancel"
      saveButton="Update"
    >
      <div class="popupentry-body">
        <div class="popupentry-content">
          <div class="form-row">
            <div class="input-field" style="width: 250px">
              <Dropdown
                placeholder="Trailer No"
                :items="trailerList"
                itemKey="Code - Name"
                :selectedObject.sync="selectedTrailerNo"
                :isRequired="true"
                :errorMessage.sync="selectedTrailerNoErrorMsg"
                @selected="GetTrailerSelected"
              />
            </div>
          </div>
          <div class="form-row" style="height: 750px">
            <TableBox
              v-if="showTrailerPopup"
              :tableData="trHistoryList"
              title="Radio-Call History"
              :loading="refreshClicked"
              :additionalButtons="updateTRBtn"
              @buttonClicked="updateTRBtnClicked"
              :selectedRow.sync="RadioCallHistoryTableBoxSelectedRow"
              @rowSelected="RadioCallHistoryTableBoxRowSelected"
              :hideColumns="['tag_seqno']"
            />
          </div>
          <BoxContainer title="Trailer Update" :isCollapsible="true">
            <div class="form-row">
              <div class="input-field">
                <Dropdown
                  :items="updateTypeList"
                  itemKey="Description"
                  :selectedObject.sync="updateTypeSelected"
                  placeholder="Update Type"
                  :isRequired="true"
                  :errorMessage.sync="updateTypeSelectedErrMsg"
                />
              </div>
              <div class="input-field">
                <Input placeholder="Consignment #" :inputValue.sync="selectedTrailerCN" :isDisabled="true" />
              </div>
              <div class="input-field">
                <Input placeholder="Prime Mover" :inputValue.sync="selectedTrailerPM" :isDisabled="true" />
              </div>
              <div class="input-field">
                <Input placeholder="Driver" :inputValue.sync="selectedTrailerDriver" :isDisabled="true" />
              </div>
              <div class="input-field">
                <DateTimePicker
                  placeholder="Date/ Time"
                  :value.sync="updateTRDateValue"
                  :isRequired="true"
                  :errorMessage.sync="updateTRDateErrMsg"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                  @dateChanged="checkDate('Date/ Time', $event)"
                />
              </div>
            </div>
            <RemarksBox :maxLength="200" :text.sync="updateTrailerRemarks" />
          </BoxContainer>
        </div>
      </div>
    </PopupEntry>
    <PopupEntry
      :title="'Update RFC'"
      :show.sync="showRFCUpdatePopup"
      v-if="showRFCUpdatePopup"
      :saveButton="'Send'"
      @requiredClicked="popupEntryRequiredClicked"
      @save="RFCUpdatePopupButtonClicked"
      :successMessages="popupEntrySuccessMessages"
    >
      <div class="popupentry-body">
        <div v-for="(cons, i) of popupConsignmentList" :key="cons.id" class="popupentry-content">
          <BoxContainer :isCollapsible="true" :title="`${cons['Consignment #']}`">
            <div class="form-row">
              <div class="input-field">
                <Input
                  :inputValue.sync="cons['Consignment #']"
                  placeholder="Consignment #"
                  :isRequired="true"
                  :isDisabled="true"
                />
              </div>
              <div class="input-field">
                <Input
                  :inputValue.sync="cons['Container #']"
                  placeholder="Container #"
                  :isRequired="true"
                  :isDisabled="true"
                />
              </div>
              <div class="input-field">
                <Dropdown
                  :items="RFCUpdatePopupRFCModeDropdownItems"
                  itemKey="RFC Mode"
                  :selectedObject.sync="cons['RFC Mode']"
                  placeholder="RFC Mode"
                  :isRequired="true"
                  :errorMessage.sync="RFCDropdownErrMsgs[i]"
                />
              </div>
              <div class="input-field" style="width: 350px">
                <Input
                  :inputValue.sync="cons['Doc Ref #']"
                  placeholder="Doc Ref #"
                  :isRequired="RFCUpdatePopupDocRefNoIsRequired(cons)"
                  :errorMessage.sync="RFCDocRefNoInputErrMsgs[i]"
                />
              </div>
            </div>
            <div class="form-row">
              <DateTimePicker
                :value.sync="cons['Date Received']"
                placeholder="Date Received"
                :isRequired="true"
                :errorMessage.sync="RFCDateReceivedErrMsgs[i]"
              />
              <div>
                <DateTimePicker
                  :value.sync="cons['Date to Collect']"
                  placeholder="Date to Collect"
                  :isRequired="true"
                  :errorMessage.sync="RFCDateToCollectErrMsgs[i]"
                  style="margin-left: 6px"
                />
              </div>
              <div class="office-hours-checkbox-container">
                <CheckBox :isChecked.sync="cons['Office Hours']" title="Office Hours" />
              </div>
            </div>
            <div class="form-row">
              <div v-if="RFCUpdatePopupShowClosingTime" class="conditional-date-time-picker-container">
                <DateTimePicker :value.sync="cons['Closing Time']" placeholder="Closing Time" />
                <span>{{ RFCUpdatePopupClosingTimeDifference }}</span>
              </div>
              <div
                v-else-if="RFCUpdatePopupShowDetentionDate"
                class="conditional-date-time-picker-container"
                style="margin-left: 6px"
              >
                <DateTimePicker :value.sync="cons['Detention']" placeholder="Detention" :showTime="false" />
                <span>{{ RFCUpdatePopupDetentionDateDifference }}</span>
              </div>
              <div v-if="RFCUpdatePopupShowETATime" class="conditional-date-time-picker-container">
                <DateTimePicker :value.sync="cons['ETA Time']" placeholder="ETA Time" :isDisabled="true" />
                <span>{{ RFCUpdatePopupETATimeDifference }}</span>
              </div>
              <div
                v-else-if="RFCUpdatePopupShowDemurrageDate"
                class="conditional-date-time-picker-container"
                style="margin-left: 6px"
              >
                <DateTimePicker
                  :value.sync="cons['Demurrage']"
                  placeholder="Demurrage"
                  :isDisabled="true"
                  :showTime="false"
                />
                <span>{{ RFCUpdatePopupDemurrageDateDifference }}</span>
              </div>
            </div>
            <div class="form-row">
              <RemarksBox :text.sync="cons['Remarks']" :maxLength="150" />
            </div>
          </BoxContainer>
        </div>
      </div>
    </PopupEntry>
    <PopupEntry
      :title="'Send RFC Acknowledgement'"
      :show.sync="showRFCAcknowledgementPopup"
      v-if="showRFCAcknowledgementPopup"
      :successMessages="popupEntrySuccessMessages"
      :errorMessages="popupEntryErrorMessages"
      :disabledSave="true"
      :cancelButton="'Close'"
    >
      <div class="acknowledgment-container">
        <div class="sidebar">
          <button
            v-for="(cons, i) of consignmentsAcknowledgement"
            :key="cons.id"
            class="consignment-button"
            :disabled="disabledConsignment[i]"
            @click="consignmentsAcknowledgementButtonClicked(cons, i)"
            >{{ cons['Consignment #'] }} ({{ cons['Container #'] }})</button
          >
        </div>
        <div class="consignment-details-main" v-if="consignmentButtonSelected">
          <div class="consignment-details-top">
            <p class="consignment-title">Bill To: {{ consignmentButtonSelected['Bill To'] }}</p>
            <p class="consignment-title">Shipper/Consignee: {{ consignmentButtonSelected['Shipper/Consignee'] }}</p>
          </div>
          <div class="consignment-details-bottom">
            <span class="prompt">Please enter the e-mail addresses that you wish to send an acknowledgement to:</span>
            <div id="to-mails-input-container">
              <EmailInput :mails.sync="RFCAcknowledgementPopupToMails" title="To" :isDisabled="disabledAfterSuccess">
                <button @click="RFCAcknowledgementPopupAddFromContactsClicked('To')" :disabled="disabledAfterSuccess"
                  >Add From Contacts</button
                >
              </EmailInput>
            </div>
            <div class="collapsable-container">
              <div class="header" @click="RFCAcknowledgementPopupCCHeaderLabelClicked">
                <img
                  class="expand-arrow"
                  :style="{ transform: RFCAcknowledgementPopupCCIsExpanded ? 'none' : 'rotate(180deg)' }"
                  src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
                  alt="expand arrow"
                  draggable="false"
                />
                <span class="header-label">{{ RFCAcknowledgementPopupCCHeaderLabel }}</span>
              </div>
              <div
                class="email-input-container"
                :style="{ 'max-height': RFCAcknowledgementPopupCCIsExpanded ? '100px' : '0px' }"
              >
                <EmailInput :mails.sync="RFCAcknowledgementPopupCCMails" title="CC" :isDisabled="disabledAfterSuccess">
                  <button @click="RFCAcknowledgementPopupAddFromContactsClicked('CC')" :disabled="disabledAfterSuccess"
                    >Add From Contacts</button
                  >
                </EmailInput>
              </div>
            </div>
            <div class="collapsable-container">
              <div class="header" @click="RFCAcknowledgementPopupBCCHeaderLabelClicked">
                <img
                  class="expand-arrow"
                  :style="{ transform: RFCAcknowledgementPopupBCCIsExpanded ? 'none' : 'rotate(180deg)' }"
                  src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
                  alt="expand arrow"
                  draggable="false"
                />
                <span class="header-label">{{ RFCAcknowledgementPopupBCCHeaderLabel }}</span>
              </div>
              <div
                class="email-input-container"
                :style="{ 'max-height': RFCAcknowledgementPopupBCCIsExpanded ? '100px' : '0px' }"
              >
                <EmailInput
                  :mails.sync="RFCAcknowledgementPopupBCCMails"
                  title="BCC"
                  :isDisabled="disabledAfterSuccess"
                >
                  <button @click="RFCAcknowledgementPopupAddFromContactsClicked('BCC')" :disabled="disabledAfterSuccess"
                    >Add From Contacts</button
                  >
                </EmailInput>
              </div>
            </div>
            <button
              class="send-email-button"
              @click="RFCAcknowledgementPopupButtonClicked(consignmentButtonSelected)"
              :disabled="disabledAfterSuccess"
              >Send email</button
            >
          </div>
        </div>
      </div>
    </PopupEntry>
    <div v-if="showRFCAcknowledgementContactsPopup" class="rfc-acknowledgement-contacts-popup-container">
      <div class="contacts-popup">
        <TableBox
          class="contacts-table-box"
          :tableData="RFCAcknowledgementContactsPopupTableBoxData"
          :selectedRow.sync="RFCAcknowledgementContactsPopupTableBoxSelectedRow"
          :title="RFCAcknowledgementContactsPopupTableBoxTitle"
          :maxSelection="-1"
        />
        <div class="call-to-action-buttons">
          <button @click="RFCAcknowledgementContactsPopupAddButtonClicked"> Add </button>
          <button @click="RFCAcknowledgementContactsPopupCancelButtonClicked"> Cancel </button>
        </div>
      </div>
    </div>
    <PopupEntry
      :title="popupTitle"
      :show.sync="showDocsType"
      v-if="showDocsType"
      @save="ReceiveDocsTypeSaveClicked"
      :successMessages="popupEntrySuccessMessages"
      :viewMode="saveClicked"
      :cancelButton="saveClicked ? 'Close' : 'Cancel'"
    >
      <div class="popupentry-body">
        <!-- <div v-for="(cons, i) of popupConsignmentList" :key="cons.id" class="popupentry-content">
          <BoxContainer :isCollapsible="true" :title="`${cons['Consignment #']}`">
            <div class="form-row">
              <div class="input-field">
                <Input placeholder="Consignment #" :inputValue.sync="cons['Consignment #']" :isDisabled="true" />
              </div>
              <div class="input-field">
                <Input
                  v-if="docsTypeTitle != 'Receive Cheque/ Receipt' && docsTypeTitle != 'Receive Bill of Lading'"
                  placeholder="Container No"
                  :inputValue.sync="cons['Container #']"
                  :isDisabled="true"
                />
              </div>
              <div class="input-field">
                <RadioButtonSet
                  v-if="docsTypeTitle == 'Receive Cheque/ Receipt'"
                  title="Document Type"
                  labelKey="label"
                  :buttons="docsButtons"
                  :isHorizontal="true"
                  :isRequired="true"
                  :selected.sync="cons['Doc']"
                />
              </div>
              <div class="input-field">
                <Input
                  :placeholder="DocsTypeInputTitle(cons['tag_jobtype'], cons['Doc'])"
                  :inputValue.sync="cons['Docs Type #']"
                  :isRequired="true"
                  :errorMessage.sync="DocsTypeInputErrMsg[i]"
                />
              </div>
              <DateTimePicker
                placeholder="Receive Date Time"
                :value.sync="cons['Receive Date Time']"
                :errorMessage.sync="ReceiveDateErrMsg[i]"
                :isRequired="true"
                :maxDate="smallDateTimeMaxDate"
                :minDate="smallDateTimeMinValue"
                @dateChanged="checkDate('Receive Date Time', $event, i)"
              />

              <div style="margin-left: auto">
                <button @click="DeleteRecClicked(cons)" :disabled="cons['docExist']">Delete Rec</button>
              </div>
            </div>

            <div class="form-row">
              <RemarksBox :text.sync="cons['Rec Remarks']" :maxLength="200" :isDisabled="saveClicked" />
            </div>

            <div class="form-row" style="margin-top: 10px; float: right">
              <div class="input-field">
                <Input placeholder="Updated By" :inputValue.sync="cons['Updated By']" :isDisabled="true" />
              </div>
            </div>
          </BoxContainer>
        </div> -->
        <!-- <div v-for="(cons, i) of popupConsignmentList" :key="cons.id" class="popupentry-content"> -->
        <!-- <BoxContainer :isCollapsible="true" :title="`${cons['Consignment #']}`"> -->
        <div class="popupentry-content">
          <div class="form-row">
            <div class="input-field">
              <RadioButtonSet
                v-if="docsTypeTitle == 'Receive Cheque/ Receipt'"
                title="Document Type"
                labelKey="label"
                :buttons="docsButtons"
                :isHorizontal="true"
                :isRequired="true"
                :selected.sync="docTypeSelected"
                :isDisabled="saveClicked"
              />
            </div>
            <div class="input-field" style="width: 250px">
              <Input
                :placeholder="DocsTypeInputTitle()"
                :inputValue.sync="docNoInput"
                :isRequired="true"
                :errorMessage.sync="DocsTypeInputErrMsg"
                validator="text,25,uppercase"
                :isDisabled="saveClicked"
              />
            </div>
            <DateTimePicker
              placeholder="Receive Date Time"
              :value.sync="receiveDateTimeValue"
              :errorMessage.sync="ReceiveDateErrMsg"
              :isRequired="true"
              :maxDate="smallDateTimeMaxDate"
              :minDate="smallDateTimeMinValue"
              @dateChanged="checkDate('Receive Date Time', $event)"
              :isDisabled="saveClicked"
            />
          </div>
          <div class="form-row">
            <RemarksBox :text.sync="recRemarksInput" :maxLength="200" :isDisabled="saveClicked" />
          </div>
        </div>
        <!-- <div v-if="!saveClicked" class="call-to-action-buttons">
          <button @click="EditSelectedRowClicked(popupTitle)">Edit</button>
        </div> -->
        <TableBox
          v-if="showDocsTypeTable"
          class="contacts-table-box"
          :tableData="popupConsignmentList"
          title="Consignments"
          :maxSelection="0"
          :hideColumns="hideColumns"
          :selectedRow.sync="selectedEditRow"
          :additionalButtons="saveClicked ? [] : deleteRec"
          @buttonClicked="DeleteRecClicked"
        />
      </div>
    </PopupEntry>
    <PopupEntry
      :title="popupTitle"
      :show.sync="showRequestHold"
      v-if="showRequestHold"
      @save="RequestHoldSaveClicked"
      :successMessages="popupEntrySuccessMessages"
      :viewMode="saveClicked"
      :cancelButton="saveClicked ? 'Close' : 'Cancel'"
    >
      <div class="popupentry-body">
        <div v-for="(cons, i) of popupConsignmentList" :key="cons.id" class="popupentry-content">
          <BoxContainer :isCollapsible="true" :title="`${cons['Consignment #']}`">
            <div class="form-row">
              <RemarksBox
                title="Please state reason/remarks:"
                :text.sync="cons['Hold Remarks']"
                :maxLength="200"
                :isDisabled="saveClicked"
                :errorMessage.sync="HoldRemarksErrMsg[i]"
              />
            </div>
          </BoxContainer>
        </div>
      </div>
    </PopupEntry>
    <PopupEntry
      :title="popupTitle"
      :show.sync="showAddRemark"
      v-if="showAddRemark"
      @save="updateJobAdditionalRemarksClicked"
      :successMessages="popupEntrySuccessMessages"
      :errorMessages="popupEntryErrorMessages"
      :cancelButton="saveClicked ? 'Close' : 'Cancel'"
      :viewMode="saveClicked"
    >
      <div class="popupentry-body">
        <div class="popupentry-content">
          <BoxContainer :isCollapsible="false" title="Job Detail" style="width: 100%">
            <div class="form-row">
              <div class="input-field">
                <Input :inputValue.sync="selectedJobNoValue" placeholder="Job No" :isDisabled="true" />
              </div>
              <div class="input-field">
                <Input :inputValue.sync="selectedConsignmentNo" placeholder="Consignment No" :isDisabled="true" />
              </div>
              <div class="input-field">
                <Input :inputValue.sync="selectedJobDateTime" placeholder="Job Date" :isDisabled="true" />
              </div>
              <div class="input-field" style="width: 500px">
                <InputQuery
                  :placeholder="cnDetailsData['Details']['tag_jobtype'] === 'E' ? 'Shipper' : 'Consignee'"
                  :selectedObject.sync="selectedShipper"
                  :items.sync="shipperItems"
                  itemKey="Description"
                  descKey="Customer Name"
                  ref="shipper"
                  :isDisabled="true"
                />
              </div>
            </div>
          </BoxContainer>
          <BoxContainer :isCollapsible="false" title="Job Remarks" style="width: 100%">
            <RemarksBox
              title="Job Remarks"
              :isDisabled="true"
              style="height: 100px"
              :maxLength="200"
              :text.sync="selectedJobRemarks"
            />
            <RemarksBox
              title="Delivery Instruction"
              :isDisabled="saveClicked"
              style="height: 100px"
              :maxLength="200"
              :text.sync="selectedDeliveryInstruction"
            />
          </BoxContainer>
          <BoxContainer
            :isCollapsible="false"
            title="Additional Remarks"
            style="width: 100%; height: calc(100% - 50px)"
          >
            <div class="form-row" style="gap: 10px">
              <RemarksBox
                title="Delivery Remarks"
                :isDisabled="saveClicked"
                style="height: 100px; flex: 1"
                :maxLength="200"
                :text.sync="selectedDeliveryRemarks"
              />
              <div class="input-field" style="display: flex; flex-direction: column; gap: 10px">
                <button @click="queryRemarksClicked('Delivery')" :disabled="saveClicked">
                  <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64.png" height="15" width="15" />
                </button>
                <button @click="updateRemarksClicked('Delivery')" :disabled="saveClicked">Add</button>
              </div>
              <RemarksBox
                title="Collection Remarks"
                :isDisabled="saveClicked"
                style="height: 100px; flex: 1"
                :maxLength="200"
                :text.sync="selectedCollectionRemarks"
              />
              <div class="input-field" style="display: flex; flex-direction: column; gap: 10px">
                <button @click="queryRemarksClicked('Collection')" :disabled="saveClicked">
                  <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64.png" height="15" width="15" />
                </button>
                <button @click="updateRemarksClicked('Collection')" :disabled="saveClicked">Add</button>
              </div>
            </div>
            <div class="form-row" style="height: 100%">
              <TableBox
                v-if="showStatusRemarksTableData"
                :tableData="selectedRemarksStatus"
                title="Status Remarks"
                :selectedRow.sync="remarksStatusTableBoxSelectedRow"
                :hideColumns="['ConsignmentNo', 'seqno']"
                @rowSelected="remarksStatusTableBoxRowSelected"
                :additionalButtons="saveClicked ? [] : [{ text: 'Delete', index: 0, width: 75 }]"
                @buttonClicked="updateRemarksClicked"
                :maxSelection="0"
              />
            </div>
          </BoxContainer>
          <PopupV2
            :show="showRemarkPopup"
            :title="showRemarkTitle"
            @buttonClicked="remarkListPopupButtonClicked"
            :buttons="remarkListPopupBtn"
            width="50%"
            height="80%"
            icon="-"
          >
            <TableBox
              v-if="showRemarkPopup"
              :tableData="popupRemarkLists"
              :title="popupRemarkTableTitle"
              style="width: 100%"
              :isLoading="showRemarkPopup"
              :columnWidth="['500']"
              :selectedRow.sync="popupRemarksTableBoxSelectedRow"
            />
          </PopupV2>
        </div>
      </div>
    </PopupEntry>
    <PopupV2
      :show.sync="showPrintPermissionPopup"
      type="error"
      title="Could Not Print"
      :buttons="printPermissionPopupButtons"
      width="45%"
      @buttonClicked="printPermissionPopupButtonClicked"
    >
      The following consignments could not be printed<br />
      <br />
      <table border="1">
        <tr>
          <th>Consignment No.</th>
          <th>Reason</th>
        </tr>
        <tr v-for="consignment in printPermissionPopupConsignmentReasons" :key="consignment['cnno']">
          <td>{{ consignment['cnno'] }}</td>
          <td>{{ consignment['retmsg'] }}</td>
        </tr>
      </table>
    </PopupV2>
    <PopupV2
      :show="showCreateDiversion"
      height="650px"
      width="75%"
      style="display: flex"
      :title="popupTitle"
      @buttonClicked="diversionButtonClicked"
      :buttons="diversionButtons"
    >
      <div style="height: 100%; width: 100%">
        <div style="height: 100%; width: 100%">
          <!-- loc 1 -->
          <dir style="display: flex; width: 100%; flex-direction: row; padding-left: 0px; margin: 0px">
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <InputQuery
                  placeholder="Diversion Loc 1"
                  :isDisabled="diversionDetails.length >= 1"
                  :items.sync="diversionLocation"
                  itemKey="Destination Code"
                  descKey="Opr Area Code"
                  :selectedObject.sync="selectedDiversionLoc1"
                />
              </div>
              <RemarksBox
                title="Diversion Loc 1"
                :isDisabled="diversionDetails.length >= 1"
                style="height: 100px"
                :maxLength="200"
                :text.sync="diversionLoc1"
              />
            </div>
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <CheckBoxV2
                  :isChecked.sync="internalDiversionLoc1"
                  :isDisabled="diversionDetails.length >= 1"
                  style="margin-left: 5px; width: 100%; place-content: center"
                  title="Internal"
                />
                <div style="display: flex">
                  <button v-if="diversionDetails.length == 1" @click="deleteButtonClicked('1')">
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Cross.png" />
                  </button>
                  <button
                    @click="printButtonClicked(internalDiversionLoc1 ? '1' : '0', cnnoLoc1, '1')"
                    style="margin-left: 5px"
                  >
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Print.png" />
                  </button>
                </div>
              </div>
              <RemarksBox
                :isDisabled="diversionDetails.length >= 1"
                style="height: 100px"
                title="Remarks"
                :maxLength="200"
                :text.sync="remarksDiversionLoc1"
              />
            </div>
          </dir>
          <!-- loc 2 -->
          <dir style="display: flex; width: 100%; flex-direction: row; padding-left: 0px; margin: 0px">
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <InputQuery
                  :isDisabled="diversionDetails.length >= 2 || diversionDetails.length == 0"
                  placeholder="Diversion Loc 2"
                  :items.sync="diversionLocation"
                  itemKey="Destination Code"
                  descKey="Opr Area Code"
                  :selectedObject.sync="selectedDiversionLoc2"
                />
              </div>
              <RemarksBox
                title="Diversion Loc 2"
                :isDisabled="diversionDetails.length >= 2 || diversionDetails.length == 0"
                style="height: 100px"
                :maxLength="200"
                :text.sync="diversionLoc2"
              />
            </div>
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <CheckBoxV2
                  :isChecked.sync="internalDiversionLoc2"
                  :isDisabled="diversionDetails.length >= 2 || diversionDetails.length == 0"
                  style="margin-left: 5px; width: 100%; place-content: center"
                  title="Internal"
                />
                <div style="display: flex">
                  <button v-if="diversionDetails.length == 2" @click="deleteButtonClicked('2')">
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Cross.png" />
                  </button>
                  <button
                    :disabled="!selectedDiversionLoc2 && diversionDetails.length == 0"
                    @click="printButtonClicked(internalDiversionLoc2 ? '1' : '0', cnnoLoc2, '2')"
                    style="margin-left: 5px"
                  >
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Print.png" />
                  </button>
                </div>
              </div>
              <RemarksBox
                :isDisabled="diversionDetails.length >= 2 || diversionDetails.length == 0"
                style="height: 100px"
                title="Remarks"
                :maxLength="200"
                :text.sync="remarksDiversionLoc2"
              />
            </div>
          </dir>
          <!-- loc 3 -->
          <dir style="display: flex; width: 100%; flex-direction: row; padding-left: 0px; margin: 0px">
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <InputQuery
                  :isDisabled="diversionDetails.length >= 3 || diversionDetails.length <= 1"
                  placeholder="Diversion Loc 3"
                  :items.sync="diversionLocation"
                  itemKey="Destination Code"
                  descKey="Opr Area Code"
                  :selectedObject.sync="selectedDiversionLoc3"
                />
              </div>
              <RemarksBox
                title="Diversion Loc 3"
                :isDisabled="diversionDetails.length >= 3 || diversionDetails.length <= 1"
                style="height: 100px"
                :maxLength="200"
                :text.sync="diversionLoc3"
              />
            </div>
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <CheckBoxV2
                  :isDisabled="diversionDetails.length >= 3 || diversionDetails.length <= 1"
                  :isChecked.sync="internalDiversionLoc3"
                  style="margin-left: 5px; width: 100%; place-content: center"
                  title="Internal"
                />
                <div style="display: flex">
                  <button v-if="diversionDetails.length == 3" @click="deleteButtonClicked('3')">
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Cross.png" />
                  </button>
                  <button
                    :disabled="!selectedDiversionLoc3 && diversionDetails.length <= 1"
                    @click="printButtonClicked(internalDiversionLoc3 ? '1' : '0', cnnoLoc3, '3')"
                    style="margin-left: 5px"
                  >
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Print.png" />
                  </button>
                </div>
              </div>
              <RemarksBox
                :isDisabled="diversionDetails.length >= 3 || diversionDetails.length <= 1"
                style="height: 100px"
                title="Remarks"
                :maxLength="200"
                :text.sync="remarksDiversionLoc3"
              />
            </div>
          </dir>
          <!-- loc 4 -->
          <dir style="display: flex; width: 100%; flex-direction: row; padding-left: 0px; margin: 0px">
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <InputQuery
                  :isDisabled="
                    (diversionDetails.length <= 2 && diversionDetails.length > 0) ||
                    cnnoLoc4 != '' ||
                    diversionDetails.length == 0
                  "
                  placeholder="Diversion Loc 4"
                  :items.sync="diversionLocation"
                  itemKey="Destination Code"
                  descKey="Opr Area Code"
                  :selectedObject.sync="selectedDiversionLoc4"
                />
              </div>
              <RemarksBox
                title="Diversion Loc 4"
                :isDisabled="
                  (diversionDetails.length <= 2 && diversionDetails.length > 0) ||
                  cnnoLoc4 != '' ||
                  diversionDetails.length == 0
                "
                style="height: 100px"
                :maxLength="200"
                :text.sync="diversionLoc4"
              />
            </div>
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <CheckBoxV2
                  :isDisabled="
                    (diversionDetails.length <= 2 && diversionDetails.length != 0) ||
                    cnnoLoc4 != '' ||
                    diversionDetails.length == 0
                  "
                  :isChecked.sync="internalDiversionLoc4"
                  style="margin-left: 5px; width: 100%; place-content: center"
                  title="Internal"
                />
                <div style="display: flex">
                  <button v-if="diversionDetails.length == 4" @click="deleteButtonClicked('4')">
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Cross.png" />
                  </button>
                  <button
                    :disabled="!selectedDiversionLoc4"
                    @click="printButtonClicked(internalDiversionLoc4 ? '1' : '0', cnnoLoc4, '4')"
                    style="margin-left: 5px"
                  >
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Print.png" />
                  </button>
                </div>
              </div>
              <RemarksBox
                :isDisabled="
                  (diversionDetails.length <= 2 && diversionDetails.length != 0) ||
                  cnnoLoc4 != '' ||
                  diversionDetails.length == 0
                "
                style="height: 100px"
                title="Remarks"
                :maxLength="200"
                :text.sync="remarksDiversionLoc4"
              />
            </div>
          </dir>
        </div>
      </div>
    </PopupV2>

    <PopupV2
      icon="https://dsmlib.logistics.systems/Icons/Print.png"
      :title="printDiversionTitle"
      :show="showPrintDiversion"
      height="300px"
      width="400px"
      :buttons="printDiversionButtons"
      @buttonClicked="printDiversionPopupClicked"
    >
      <div style="padding: 10px; width: 100%; overflow: hidden">
        <div style="padding: 5px" v-if="showIndividualPrintDiversion">{{
          'Divert ' + printDiversionTitleOri + ' to ' + printDiversionTitleDivert
        }}</div>
        <br />
        <br />
        <CheckBoxV2
          style="margin-left: 5px; width: 100%; place-content: center"
          :isChecked.sync="useOriDest"
          title="Pickup from original destination"
        />
      </div>
    </PopupV2>

    <PopupV2
      type="warning"
      :show="showDeleteDivPopup"
      title="Delete Diversion"
      @buttonClicked="deleteDivButtonClicked"
      :buttons="deletePopupButtons"
    >
      <div>Are you sure you want to delete diversion record ?</div>
      <div>Note: Delete action is not reversible!</div>
      <br />
      <Input
        placeholder="Delete Reaason"
        :inputValue.sync="deleteDivRemarks"
        :isRequired="true"
        :errorMessage.sync="deleteDivError"
      />
    </PopupV2>

    <div v-if="designerV2IsShown" class="designer-v2-container">
      <div class="designer-v2-component-container">
        <DesignerV2
          :show.sync="designerV2IsShown"
          :viewMode="true"
          :reportFile="isDivert ? designerV2ReportFileDiversion : designerV2ReportFile"
          reportFolder="ROTForm"
          :reportData="designerV2ReportData"
          :downloadName="designerV2DownloadName"
          :showBackground.sync="designerV2ShowBackground"
          @afterprint="designerV2AfterPrint"
        />
      </div>
    </div>

    <div v-if="designerV3IsShown" class="designer-v2-container">
      <div class="designer-v2-component-container">
        <DesignerV3
          v-if="designerV3IsShown"
          :reportFiles="designerV3ReportFiles"
          :reportData="designerV3ReportData"
          :sharedData="designerV3SharedData"
          :canToggleBackground="false"
          :canShare="true"
          :shareBehaviour="designerV3ShareBehaviour"
          :canClose="true"
          :downloadName="downloadFileName"
          @closeClicked="designerV3CloseClicked"
          ref="designerV3"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TripDetails from '@/components/TripDetails.vue';
import ConsignmentDetails from '@/components/ConsignmentDetails.vue';
export default {
  components: {
    TripDetails,
    ConsignmentDetails,
  },
  computed: {
    lastRefreshedDateTimeFormatted: function () {
      if (!this.lastRefreshedDateTime) {
        return '';
      }

      return `Last Refreshed ${this.lastRefreshedDateTime.formatString('yyyy-MM-dd HH:mm')}`;
    },
    consignmentsTableBoxHideColumns: function () {
      if (!this.consignmentsTableBoxTableData || this.consignmentsTableBoxTableData.length === 0) {
        return [];
      }

      const keys = Object.keys(this.consignmentsTableBoxTableData[0]);
      return keys.filter((key) => {
        return key.startsWith('tag_');
      }); // hide all columns with names starting with "tag_"
    },
    hideColumns: function (e) {
      if (!this.popupConsignmentList || this.popupConsignmentList.length === 0) {
        return [];
      }

      const keys = Object.keys(this.popupConsignmentList[0]);
      const commonHiddenCols = [
        'Status',
        'Type',
        'Fwdg Agt',
        'Tariff Area',
        'Size',
        'Commodity',
        'Total Cont',
        'B2B',
        'Cust Ref #',
        'Bill To',
        'Shipper/Consignee',
        'Diversion Ct',
        'Consignment No',
        'docExist',
        'SeqNo',
      ];
      const hiddenCol = [...commonHiddenCols];
      const popupTitle = e?.popupTitle || '';

      if (popupTitle.includes('Required Date')) {
        hiddenCol.push('Pick-Up', 'Send To', 'Drop-Off', 'Planned Time', 'Planned Date', 'SCN');
      } else if (popupTitle.includes('Plan Date')) {
        hiddenCol.push('Required Date', 'Required Time', 'Req Time Desc', 'SCN');
      } else if (
        popupTitle.includes('Voyage Info') ||
        popupTitle.includes('Change Operator') ||
        popupTitle.includes('Change Pick-up') ||
        popupTitle.includes('Change Drop-off')
      ) {
        hiddenCol.push('Required Date', 'Required Time', 'Req Time Desc', 'Planned Date', 'Planned Time');
      } else {
        hiddenCol.push(
          'Pick-Up',
          'Send To',
          'Drop-Off',
          'Required Date',
          'Required Time',
          'Req Time Desc',
          'Planned Date',
          'Planned Time',
          'SCN',
        );
      }

      if (this.DocTitle != 'B/L #') hiddenCol.push('B/L #');

      return keys.filter((key) => {
        return key.startsWith('tag_') || hiddenCol.includes(key);
      }); // hide all columns with names starting with "tag_"
    },
    RFCUpdatePopupShowClosingTime: function () {
      if (!this.RFCUpdatePopupJobType || typeof this.RFCUpdatePopupJobType !== 'string') {
        return false; // if it's empty or isn't a string
      }

      return ['1-EXP', 'EXP'].includes(this.RFCUpdatePopupJobType.trim().toUpperCase()); // if it's an export job
    },
    RFCUpdatePopupClosingTimeDifference: function () {
      if (!this.RFCUpdatePopupDateToCollectValue || !this.RFCUpdatePopupClosingTimeValue) {
        return '';
      }

      const difference = this.RFCUpdatePopupDateToCollectValue.getDifference(this.RFCUpdatePopupClosingTimeValue);
      const differenceText = `${difference['days'] * 24 + difference['hours']} hr ${difference['minutes']} min`;

      if (this.RFCUpdatePopupDateToCollectValue <= this.RFCUpdatePopupClosingTimeValue) {
        return differenceText;
      }

      return `-${differenceText}`; // Date.prototype.getDifference returns the absolute difference, need to check sign manually
    },
    RFCUpdatePopupShowDetentionDate: function () {
      if (!this.RFCUpdatePopupJobType || typeof this.RFCUpdatePopupJobType !== 'string') {
        return false; // if it's empty or isn't a string
      }

      return ['1-IMP', 'IMP', 'IMP-EXP'].includes(this.RFCUpdatePopupJobType.trim().toUpperCase()); // if it's an import job
    },
    RFCUpdatePopupDetentionDateDifference: function () {
      if (!this.RFCUpdatePopupDateToCollectValue || !this.RFCUpdatePopupDetentionDateValue) {
        return '';
      }

      const difference = this.RFCUpdatePopupDateToCollectValue.getDifference(this.RFCUpdatePopupDetentionDateValue);
      const differenceText = `${difference['days'] * 24 + difference['hours']} hr ${difference['minutes']} min`;

      if (this.RFCUpdatePopupDateToCollectValue <= this.RFCUpdatePopupDetentionDateValue) {
        return differenceText;
      }

      return `-${differenceText}`; // Date.prototype.getDifference returns the absolute difference, need to check sign manually
    },
    RFCUpdatePopupShowETATime: function () {
      if (!this.RFCUpdatePopupJobType || typeof this.RFCUpdatePopupJobType !== 'string') {
        return false; // if it's empty or isn't a string
      }

      return ['1-EXP', 'EXP'].includes(this.RFCUpdatePopupJobType.trim().toUpperCase()); // if it's an export job
    },
    RFCUpdatePopupETATimeDifference: function () {
      if (!this.RFCUpdatePopupDateToCollectValue || !this.RFCUpdatePopupETATimeValue) {
        return '';
      }

      const difference = this.RFCUpdatePopupDateToCollectValue.getDifference(this.RFCUpdatePopupETATimeValue);
      const differenceText = `${difference['days'] * 24 + difference['hours']} hr ${difference['minutes']} min`;

      if (this.RFCUpdatePopupDateToCollectValue <= this.RFCUpdatePopupETATimeValue) {
        return differenceText;
      }

      return `-${differenceText}`; // Date.prototype.getDifference returns the absolute difference, need to check sign manually
    },
    RFCUpdatePopupShowDemurrageDate: function () {
      if (!this.RFCUpdatePopupJobType || typeof this.RFCUpdatePopupJobType !== 'string') {
        return false; // if it's empty or isn't a string
      }

      return ['1-IMP', 'IMP', 'IMP-EXP'].includes(this.RFCUpdatePopupJobType.trim().toUpperCase()); // if it's an import job
    },
    RFCUpdatePopupDemurrageDateDifference: function () {
      if (!this.RFCUpdatePopupDateToCollectValue || !this.RFCUpdatePopupDemurrageDateValue) {
        return '';
      }

      const difference = this.RFCUpdatePopupDateToCollectValue.getDifference(this.RFCUpdatePopupDemurrageDateValue);
      const differenceText = `${difference['days'] * 24 + difference['hours']} hr ${difference['minutes']} min`;

      if (this.RFCUpdatePopupDateToCollectValue <= this.RFCUpdatePopupDemurrageDateValue) {
        return differenceText;
      }

      return `-${differenceText}`; // Date.prototype.getDifference returns the absolute difference, need to check sign manually
    },
    RFCAcknowledgementPopupCCHeaderLabel: function () {
      return `CC (${this.RFCAcknowledgementPopupCCMails ? this.RFCAcknowledgementPopupCCMails.length : '0'})`;
    },
    RFCAcknowledgementPopupBCCHeaderLabel: function () {
      return `BCC (${this.RFCAcknowledgementPopupBCCMails ? this.RFCAcknowledgementPopupBCCMails.length : '0'})`;
    },
    RFCAcknowledgementContactsPopupTableBoxTitle: function () {
      return `Add ${this.RFCAcknowledgementContactsPopupSelectedEmailInput} Recipients`;
    },
    designerV2DownloadName: function () {
      if (!this.selectedJob || this.selectedJob.length == 0) {
        return 'CN';
      }

      return `CN_${this.selectedJob[0]['Job No']}`;
    },
    isDischargePort: function () {
      return this.popupTitle.trim() == 'Change Discharge Port';
    },
    messageContainerStyling: function () {
      return {
        backgroundColor:
          this.radioCallUpdateSuccess === null ? 'lightyellow'
          : this.radioCallUpdateSuccess === true ? 'lightgreen'
          : 'indianred',
        color: this.radioCallUpdateSuccess === false ? 'white' : 'black',
      };
    },
    showRightMenu: {
      get() {
        return this.updateStatusTaskClicked || this.detailNonRevClicked;
      },
      set(val) {
        // when RightMenu tries to close (val=false), close both
        if (!val) {
          this.updateStatusTaskClicked = false;
          this.detailNonRevClicked = false;
        }
      },
    },
  },
  data: function () {
    return {
      haulageMenuIsCollapsed: {
        Container: false,
        RFC: false,
        'Receive Documents': false,
        Destination: false,
      },
      smallDateTimeMinValue: new Date(2000, 0, 1),
      smallDateTimeMaxDate: new Date(2079, 0, 1),

      filtersSummary: '',
      filtersIsOpen: false,

      filtersSearchByDropdownItems: [],
      filtersSearchByDropdownSelectedObject: null,
      filtersSearchByDropdownErrorMessage: '',

      filtersSearchCriteriaDropdownItems: [],
      filtersSearchCriteriaDropdownSelectedObject: null,
      filtersSearchCriteriaDropdownErrorMessage: '',
      filtersSearchCriteriaDropdownIsDisabled: false,

      filtersSearchValueControlType: 'Input',
      filtersSearchInputValue: '',
      filtersSearchInputErrorMessage: '',
      filtersSearchDateTimePickerValue: null,
      filtersSearchDateTimePickerErrorMessage: '',
      filtersSearchValueFieldIsDisabled: false,

      filtersViewOptionsDropdownItems: [],
      filtersViewOptionsDropdownSelectedObject: null,
      filtersViewOptionsDropdownErrorMessage: '',

      filtersMaxRowsInputValue: '100',
      filtersMaxRowsInputErrorMessage: '',

      lastRefreshedDateTime: null,

      consignmentsTableBoxTableData: [],
      consignmentsTableBoxSelectedRow: [],

      tableBoxColumnOrderViews: [],
      columnOrderViewsByReportName: {},
      tableBoxColumnOrderID: null,
      selectedCN: null,
      rightMenuOpenWidth: 500,

      showTripDetails: false,
      tripDetailsData: null,
      cnDetailsData: null,
      editCNContentTable: true,
      refreshClicked: false,

      showEditCont: false,
      ContainerNoErrMsg: '',
      EditContPopupButtons: [{ text: 'Edit Container #' }, { text: 'Cancel', color: 'lightgrey' }],
      oldConsignmentNo: '',
      oldContainerNo: '',
      oldSealNo: '',
      newContainerNo: '',
      newSealNo: '',
      remarks: '',

      //SAS
      rfcUpdateEnabled: true,
      editContainerEnabled: true,

      // Consignment
      // Required Date
      showEditCN: false,
      selectedEditRow: [],
      newReqDateValue: null,
      requiredTimeDescSelectedObject: null,
      requiredTimeDescSearch: '',
      EditCNTitle: '',
      officeHrsChecked: false,
      newReqPlanRemarksInput: '',
      popupTitle: '',
      requiredTimeDescItems: [
        { Description: '-' },
        { Description: 'Before' },
        { Description: 'After' },
        { Description: 'Exactly' },
        { Description: 'ASAP' },
        { Description: 'Call B4Dly' },
        { Description: 'Morning' },
        { Description: 'Night' },
      ],

      // Plan Date
      priorityDropdownItems: Array.from({ length: 10 }, (_, i) => ({ value: i.toString() })),
      planDateValue: null,
      selectedPriority: null,
      selectedPMCode: null,
      selectedJobType: null,
      selectedDriver: null,
      selectedTeam: null,
      selectedShift: null,
      PMList: [],
      allJobTypes: [],
      driverList: [],
      teamList: [],
      shiftList: [],
      RequiredDateErrMsg: '',
      PlanDateErrMsg: '',
      PMCodeErrMsg: '',
      jobTypeErrMsg: '',
      DriverErrMsg: '',
      saveClicked: false,

      // Cont Operator
      newContOptInput: '',
      operatorErrMsg: '',

      // Remarks
      showAddRemark: false,
      selectedJobNoValue: '',
      selectedJobDateTime: '',
      shipperItems: [],
      selectedShipper: null,
      selectedJobRemarks: '',
      selectedDeliveryInstruction: '',
      selectedRemarksStatus: [],
      remarksStatusTableBoxSelectedRow: [],
      selectedDeliveryRemarks: '',
      selectedCollectionRemarks: '',
      showRemarkPopup: false,
      showRemarkTitle: '',
      remarkListPopupBtn: [{ text: 'Confirm' }, { text: 'Cancel' }],
      popupRemarkLists: [],
      popupRemarkTableTitle: '',
      popupRemarksTableBoxSelectedRow: [],
      showStatusRemarksTableData: false,
      newlyAddedRowIds: new Set(),
      deletedOriginalRows: [],

      // Voy Info
      showVoyageInfoPopup: false,
      editVoyInfoContentTable: true,
      SCNList: [],
      vesselList: [],
      shippingAgentList: [],
      selectedSCN: null,
      selectedVesselID: null,
      selectedVesselName: null,
      shippingLineInput: '',
      selectedShippingAgent: null,
      vesselIDFreeText: '',
      vesselNameFreeText: '',
      bookingRefNoInput: '',
      finalDestinationInput: '',
      ETADateTimeValue: null,
      ETDDateTimeValue: null,
      closingDateTimeValue: null,
      detentionDateTimeValue: null,
      newVoyRemark: '',
      ETAErrMsg: '',
      ETDErrMsg: '',
      closingDateErrMsg: '',
      detentionDateErrMsg: '',

      // Document received
      docType: '',
      docTypeSelected: { label: 'Cheque', keyValue: '0' },
      docNoInput: '',
      recRemarksInput: '',
      receiveDateTimeValue: new Date(),
      DocsTypeInputErrMsg: '',
      ReceiveDateErrMsg: '',
      DocTitle: '',
      deleteRec: [{ text: 'Delete Rec', index: 0, width: 105 }],
      showDocsType: false,
      showDocsTypeTable: false,

      // Print CN
      designerV2ReportFile: [], // initialised in mounted(), it's an array because DesignerV2 supports multiple templates in one report
      designerV2ReportFileDiversion: [], // initialised in mounted(), it's an array because DesignerV2 supports multiple templates in one report
      designerV2ReportData: {},
      printPermissionPopupConsignmentReasons: [],
      designerV2IsShown: false,
      designerV2ShowBackground: false,
      showPrintPermissionPopup: false,
      isDivert: false,
      printPermissionPopupButtons: [{ text: 'OK' }],

      //Print CN Details
      designerV3IsShown: false,
      designerV3ReportFiles: [],
      designerV3ReportData: [],
      designerV3SharedData: {},
      designerV3ShareBehaviour: {
        behaviour: 'uploadAndEmit',
      },
      downloadFileName: '',
      cnDetailsFulfill: true,

      // Destination
      selectedDest: null,
      destList: [],
      portList: [],
      showDestInfoPopup: false,
      selectDestErrMsg: '',

      // Trailer
      showTrailerPopup: false,
      trailerList: [],
      selectedTrailerNo: null,
      selectedTrailerNoErrorMsg: '',
      trHistoryList: [],
      updateTypeList: [
        { Description: 'Job Complete', key: 'JC' },
        { Description: 'Gate In', key: 'IN' },
        { Description: 'Gate Out', key: 'OUT' },
        { Description: 'Others', key: 'OTH' },
      ],
      updateTRBtn: [
        { text: 'View Work Ticket', index: 0, width: 90 },
        { text: 'Delete', index: 1, width: 75 },
      ],
      selectedTrailerCN: '',
      selectedTrailerPM: '',
      selectedTrailerDriver: '',
      RadioCallHistoryTableBoxSelectedRow: [],
      updateTRDateErrMsg: '',
      updateTRDateValue: null,
      updateTypeSelected: null,
      updateTypeSelectedErrMsg: '',
      updateTrailerRemarks: '',
      selectedUpdateStatusCN: null,

      //Diversion
      showCreateDiversion: false,
      showPrintDiversion: false,
      showIndividualPrintDiversion: false,
      diversiontTitle: '',
      diversionLocation: [],
      diversionDetails: [],
      selectedDiversionLoc1: null,
      selectedDiversionLoc2: null,
      selectedDiversionLoc3: null,
      selectedDiversionLoc4: null,
      diversionLoc1: '',
      cnnoLoc1: '',
      diversionLoc2: '',
      cnnoLoc2: '',
      diversionLoc3: '',
      cnnoLoc3: '',
      diversionLoc4: '',
      cnnoLoc4: '',
      internalDiversionLoc1: false,
      internalDiversionLoc2: false,
      internalDiversionLoc3: false,
      internalDiversionLoc4: false,
      remarksDiversionLoc1: '',
      remarksDiversionLoc2: '',
      remarksDiversionLoc3: '',
      remarksDiversionLoc4: '',
      showDeleteDivPopup: false,
      deleteDivRemarks: '',
      deleteDivError: '',
      sequence: '',
      cndiversionList: [],
      deleteDiversionError: '',
      printDiversionTitle: '',
      printDiversionTitleOri: '',
      printDiversionTitleDivert: '',
      jobDetailForDiversion: [],
      useOriDest: false,
      diversionButtons: [{ text: 'Update' }, { text: 'Cancel', color: 'indianred' }],
      printDiversionButtons: [
        { text: 'Print', color: 'lightgray' },
        { text: 'Cancel', color: 'indianred' },
      ],
      sendToItems: [],

      //Delete Popup Diversion
      showDeletePopup: false,
      showDeleteCNPopup: false,
      deletePopupButtons: [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],
      deleteRemarks: '',
      deleteRemarksError: '',
      deleteCNRemarks: '',
      deleteCNRemarksError: '',

      // Right Menu
      // Update Status
      radioCallUpdateSuccess: null,
      updateStatusTaskClicked: false,
      radioCallResultMessage: '',
      radioCallAttachmentsChanged: false,

      //Detail Non Rev
      detailNonRevClicked: false,
      nonRevCN: null,

      showRFCUpdatePopup: false,
      RFCUpdatePopupJobType: '',
      popupConsignmentList: [],
      RFCUpdatePopupRFCModeDropdownItems: [],
      RFCUpdatePopupRFCModeDropdownDefaultRFCMode: null,
      RFCUpdatePopupRFCModeDropdownSelectedItem: null,
      RFCUpdatePopupRFCModeDropdownErrorMessage: '',
      RFCUpdatePopupDocRefNoInputValue: '',
      RFCUpdatePopupDateReceivedValue: new Date(),
      RFCUpdatePopupDateToCollectValue: null,
      RFCUpdatePopupClosingTimeValue: null,
      RFCUpdatePopupDetentionDateValue: null,
      RFCUpdatePopupETATimeValue: null,
      RFCUpdatePopupDemurrageDateValue: null,
      RFCDropdownErrMsgs: [],
      RFCDocRefNoInputErrMsgs: [],
      RFCDateReceivedErrMsgs: [],
      RFCDateToCollectErrMsgs: [],

      showRFCAcknowledgementPopup: false,
      consignmentButtonSelected: null,
      popupEntrySuccessMessages: [],
      popupEntryErrorMessages: [],
      consignmentsAcknowledgement: [],
      RFCAcknowledgementPopupToMails: [],
      RFCAcknowledgementPopupCCIsExpanded: false,
      RFCAcknowledgementPopupCCMails: [],
      RFCAcknowledgementPopupBCCIsExpanded: false,
      RFCAcknowledgementPopupBCCMails: [],
      disabledConsignment: [],
      disabledAfterSuccess: false,

      RFCAcknowledgementContactsPopupSelectedEmailInput: '',
      showRFCAcknowledgementContactsPopup: false,
      RFCAcknowledgementContactsPopupTableBoxData: [],
      RFCAcknowledgementContactsPopupTableBoxSelectedRow: [],
      additionalBtn: [{ text: `<img src="https://dsmlib.logistics.systems/Icons/icons8-task-planning-64.png" width="16" />`, index: 0, ref: "View TAS"}, 
      {text: `<img src="https://dsmlib.logistics.systems/Icons/icons8-user-64.png" width="16" />`, index: 1, ref: "View Job Charges"}],

      docsTypeTitle: '',
      docsButtons: [
        { label: 'Cheque', keyValue: '0' },
        { label: 'Receipt', keyValue: '1' },
      ],
      action: '',

      showRequestHold: false,
      HoldRemarksErrMsg: [],
      loginDetails: null,
      selectedIndex: [],
    };
  },
  props: {},
  methods: {
    haulageMenuHeaderClicked: function (e, title) {
      this.haulageMenuIsCollapsed[title] = e;
    },
    EditCNClicked: async function (e) {
      this.clearField();
      this.filtersIsOpen = false;

      if (!this.consignmentsTableBoxSelectedRow || this.consignmentsTableBoxSelectedRow.length === 0) {
        this.$showAlert('error', 'No Consignment Selected', 'Please select at least one consignment', [{ text: 'OK' }]);
        return;
      }

      if (e.target.innerText.trim() === 'Edit Required Date') {
        this.popupConsignmentList = this.consignmentsTableBoxSelectedRow.map((cons) => {
          return {
            ...cons,
            'Office Hours': cons['tag_officehrs'],
            'Required Date': cons['Required Date'],
            Remarks: '',
            // 'New Required Date': null,
            // 'New Required Time': null,
            // 'New Req Time Desc': '',
            // 'New Office Hours': '',
          };
        });
      } else if (e.target.innerText.trim() === 'Edit Plan Date') {
        this.popupConsignmentList = this.consignmentsTableBoxSelectedRow.map((cons) => {
          return {
            ...cons,
            Priority: cons['tag_priority'],
            'PM Code': cons['tag_pmcode'],
            Driver: cons['tag_driver'],
            Team: cons['tag_team'],
            Shift: cons['tag_shiftid'],
            Remarks: '',
            'Plan Date': null,
            'Plan Time': null,
            // 'New Priority': null,
            // 'New PM Code': null,
            // 'New Driver': null,
            // 'New Team': null,
            // 'New Shift': null,
          };
        });
      } else if (e.target.innerText.trim() === 'Change Operator') {
        this.popupConsignmentList = this.consignmentsTableBoxSelectedRow.map((cons) => {
          return {
            ...cons,
            'Cont Operator': cons['tag_contopt'],
            Remarks: '',
          };
        });
      } else if (e.target.innerText.trim() === 'Edit Job Type') {
        this.$fullscreenLoading('Checking Accounts');
        const selectedRow = this.consignmentsTableBoxSelectedRow;
        const errs = [];
        const results = [];
        const notBilledCons = [];

        for (const cn of selectedRow) {
          const checkAccountJSON = {
            checktype: 'EDIT CN',
            jobno: cn['tag_jobno'],
            cnno: cn['Consignment #'],
            contno: cn['Container #'],
            chargescode: '',
            system: 'HMS',
            chkpayment: '0',
          };
          const CheckAccount = await this.$apiCallV2('/Consignment/CheckAccounts', checkAccountJSON);
          const CheckAccObj = {
            consignmentNo: cn['Consignment #'],
            data: CheckAccount,
          };
          if (CheckAccObj.data[0]['Results'] == 0) {
            if (CheckAccObj.data[0]['editstatus'] === 'BILLED') {
              results.push(CheckAccObj.consignmentNo);
            } else {
              notBilledCons.push(cn);
            }
          } else {
            const errorMsg = CheckAccObj.data[0]['ErrMsg'];
            const consignmentNo = CheckAccObj.consignmentNo;
            errs.push(`Consignment ${consignmentNo}: ${errorMsg}`);
          }
        }

        const messages = [];
        let okClick = false;

        if (results.length > 0) {
          messages.push(`Billing already issued for this consignment. <b>(${results.join(', ')})</b>`);
        }

        if (errs.length > 0) {
          messages.push(...errs);
        }

        if (messages.length > 0) {
          okClick = await this.$showAlert('warning', 'Edit Job Type', messages.join('\n'));
        }

        if (okClick || messages.length == 0) {
          this.popupConsignmentList = notBilledCons.map((cons) => {
            return {
              ...cons,
              'Job Type': cons['tag_contjobtype'] || '',
              Remarks: '',
            };
          });
        }
        this.$fullscreenLoading();
      } else {
        this.popupConsignmentList = this.consignmentsTableBoxSelectedRow.map((cons) => {
          return {
            ...cons,
          };
        });
      }

      const requestBody = {
        consignments: this.popupConsignmentList.map((cons) => cons['Consignment #']).join(','),
      };
      this.$fullscreenLoading('Validating consignment numbers');
      const resultStatus = await this.$apiCallV2('/Consignment/ValidateCN', requestBody);
      this.$fullscreenLoading();
      const cancelledConsignments = Object.entries(resultStatus.results)
        .filter(([_consignmentNumber, status]) => status === '9')
        .map(([consignmentNumber]) => consignmentNumber);

      if (cancelledConsignments.length > 0) {
        const consignmentCount = this.popupConsignmentList.length;
        const consignmentNumbers = cancelledConsignments.join(', ');

        const alertMessage = `${e.target.innerText.trim()} not allowed`;
        const detailMessage =
          consignmentCount === 1 ?
            `Consignment no. <b>${this.popupConsignmentList[0]['Consignment #']}</b> is already cancelled`
          : `Consignment no. <b>${consignmentNumbers}</b> are already cancelled`;

        await this.$showAlert('error', alertMessage, detailMessage, [{ text: 'OK' }]);
        this.popupConsignmentList = this.popupConsignmentList.filter(
          (cons) => !cancelledConsignments.includes(cons['Consignment #']),
        );
      }
      this.popupConsignmentList = this.popupConsignmentList.map((cons, i) => {
        return {
          ...cons,
          '#': i + 1,
        };
      });

      this.populateData(this.popupConsignmentList);

      const requireSingleSelection = () => {
        if (this.consignmentsTableBoxSelectedRow.length > 1) {
          this.$showAlert('error', 'More than 1 record Selected', 'Please select a single record to proceed', [
            { text: 'OK' },
          ]);
          return false;
        }
        return true;
      };

      switch (e.target.innerText.trim().toUpperCase()) {
        case 'EDIT CONTAINER #':
          if (!requireSingleSelection()) break;
          this.showEditCont = true;
          break;
        case 'VIEW/CREATE DIVERSION':
          if (!requireSingleSelection()) break;
          this.EditCNTitle = `Diversion for ${this.consignmentsTableBoxSelectedRow[0]['Consignment #']}`;
          this.diversionDetails = await this.$apiCallV2(
            `/HaulageJob/GetHMSDiversion?jobno=${this.consignmentsTableBoxSelectedRow[0]['tag_jobno']}&cnno=${this.consignmentsTableBoxSelectedRow[0]['Consignment #'] ? this.consignmentsTableBoxSelectedRow[0]['Consignment #'] : ''}`,
          );
          if (this.diversionDetails['0']?.['Results'] == '1') {
            await this.$showAlert('error', 'Unable to View/Create Diversion', this.diversionDetails[0]?.['ErrMsg']);
            break;
          }
          if (this.diversionDetails.length == 4) {
            this.diversionButtons = [
              // { text: 'Update', disabled: true },
              { text: 'Cancel', color: 'indianred' },
            ];
          } else {
            this.diversionButtons = [{ text: 'Update' }, { text: 'Cancel', color: 'indianred' }];
          }
          if (this.diversionDetails.length != 0) {
            this.selectedDiversionLoc1 =
              this.diversionDetails.length > 0 ?
                this.diversionLocation.find((i) => {
                  return i['Destination Code'] == this.diversionDetails[0]['Diversion Dest'];
                })
              : null;
            this.selectedDiversionLoc2 =
              this.diversionDetails.length > 1 ?
                this.diversionLocation.find((i) => {
                  return i['Destination Code'] == this.diversionDetails[1]['Diversion Dest'];
                })
              : null;
            this.selectedDiversionLoc3 =
              this.diversionDetails.length > 2 ?
                this.diversionLocation.find((i) => {
                  return i['Destination Code'] == this.diversionDetails[2]['Diversion Dest'];
                })
              : null;
            this.selectedDiversionLoc4 =
              this.diversionDetails.length > 3 ?
                this.diversionLocation.find((i) => {
                  return i['Destination Code'] == this.diversionDetails[3]['Diversion Dest'];
                })
              : null;
            this.diversionLoc1 = this.diversionDetails.length > 0 ? this.diversionDetails[0]['DiverAddress'] : '';
            this.diversionLoc2 = this.diversionDetails.length > 1 ? this.diversionDetails[1]['DiverAddress'] : '';
            this.diversionLoc3 = this.diversionDetails.length > 2 ? this.diversionDetails[2]['DiverAddress'] : '';
            this.diversionLoc4 = this.diversionDetails.length > 3 ? this.diversionDetails[3]['DiverAddress'] : '';
            this.remarksDiversionLoc1 = this.diversionDetails.length > 0 ? this.diversionDetails[0]['Remarks'] : '';
            this.remarksDiversionLoc2 = this.diversionDetails.length > 1 ? this.diversionDetails[1]['Remarks'] : '';
            this.remarksDiversionLoc3 = this.diversionDetails.length > 2 ? this.diversionDetails[2]['Remarks'] : '';
            this.remarksDiversionLoc4 = this.diversionDetails.length > 3 ? this.diversionDetails[3]['Remarks'] : '';
            this.internalDiversionLoc1 =
              this.diversionDetails.length > 0 ? this.diversionDetails[0]['DeliveryMode'] == 1 : false;
            this.internalDiversionLoc2 =
              this.diversionDetails.length > 1 ? this.diversionDetails[1]['DeliveryMode'] == 1 : false;
            this.internalDiversionLoc3 =
              this.diversionDetails.length > 2 ? this.diversionDetails[2]['DeliveryMode'] == 1 : false;
            this.internalDiversionLoc4 =
              this.diversionDetails.length > 3 ? this.diversionDetails[3]['DeliveryMode'] == 1 : false;
            this.cnnoLoc1 = this.diversionDetails.length > 0 ? this.diversionDetails[0]['Consignment No'] : '';
            this.cnnoLoc2 = this.diversionDetails.length > 1 ? this.diversionDetails[1]['Consignment No'] : '';
            this.cnnoLoc3 = this.diversionDetails.length > 2 ? this.diversionDetails[2]['Consignment No'] : '';
            this.cnnoLoc4 = this.diversionDetails.length > 3 ? this.diversionDetails[3]['Consignment No'] : '';
          }
          this.showCreateDiversion = true;
          break;
        case 'PRINT DIVERSION':
          this.isDivert = true;
          this.showPrintDiversion = false;
          this.showCreateDiversion = false;
          if (this.consignmentsTableBoxSelectedRow.length == 0) {
            await this.$showAlert('error', 'No Job Selected', 'Please select a job to print');
            break;
          } else if (this.consignmentsTableBoxSelectedRow.length > 1) {
            this.$showAlert('error', 'More than 1 record Selected', 'Please select a record to print');
            break;
          } else {
            if (this.jobDetailForDiversion == null || this.jobDetailForDiversion.length == 0)
              // await this.getJobDetailsForDiversion(this.selectedConsignmentNo.trim() != '');
              await this.getJobDetailsForDiversion(this.selectedJob != '');
            if (
              this.jobDetailForDiversion == null ||
              this.jobDetailForDiversion['ConsignmentNote'][0]['CNDiversion'] == undefined
            ) {
              this.$showAlert(
                'info',
                'Record Check',
                `No diversion for selected CDA ${this.consignmentsTableBoxSelectedRow[0]['tag_jobno']}`,
              );
              break;
            }

            if (
              this.isDiversionForCN &&
              this.jobDetailForDiversion['ConsignmentNote'][0]['CNDiversion']['ConsignmentNo'] !=
                this.selectedConsignmentNo
            ) {
              this.$showAlert('info', 'Record Check', `No diversion for selected CDA ${this.selectedConsignmentNo}`);
              break;
            }

            this.$fullscreenLoading('Validating Print Permission');
            const validatePrintBody = {
              // // the rest of the body is populated in the controller
              consignments: this.jobDetailForDiversion['ConsignmentNote'].map((consignmentNote) => {
                return {
                  cnno: consignmentNote['ConsignmentNo'],
                };
              }),
            };

            const validatePrintRes = await this.$apiCallV2('/HaulageJob/ValidatePrint', validatePrintBody);
            this.printPermissionPopupConsignmentReasons = validatePrintRes['consignments'].filter((consignment) => {
              return !consignment['allowprint'];
            });

            if (this.printPermissionPopupConsignmentReasons.length > 0) {
              // if there is at least one consignment that can't be printed
              this.showPrintPermissionPopup = true; // show PopupV2
              this.$fullscreenLoading();
              return; // exit function
            }

            this.$fullscreenLoading('Preparing to Print');
            await this.formatDiversionNotePrintDetails(
              this.designerV2ReportFileDiversion[0],
              this.jobDetailForDiversion,
            ); // will modify the jobDetails object via reference
            this.designerV2ReportData = this.jobDetailForDiversion;
            this.designerV2IsShown = true; // there is a watcher for this data field that sets the SignalR hub to start listening to an event
            this.$fullscreenLoading();
            this.diverpickupori = '0';
            this.diverinternal = '';
            this.diverseqno = '';
            this.cnno = '';
            this.useOriDest = false;
          }
          break;
        case 'EDIT REQUIRED DATE':
          this.showEditCN = true;
          this.EditCNTitle = 'Edit Required Date';
          break;
        case 'PLAN DATE':
        case 'EDIT PLAN DATE':
          this.showEditCN = true;
          this.EditCNTitle = 'Edit Plan Date';
          break;
        case 'CHANGE OPERATOR':
          this.showEditCN = true;
          this.EditCNTitle = 'Change Operator';
          break;
        case 'EDIT JOB TYPE':
          this.showEditCN = true;
          this.EditCNTitle = 'Edit Job Type';
          break;
      }
      this.popupTitle = this.EditCNTitle;
    },
    EditCNSaveClicked: async function () {
      this.clearErrMsgs();
      if (this.FieldCheck(this.EditCNTitle.trim())) {
        return;
      }

      const requestBody = {
        editcn: this.EditCNTitle,
        consignments: this.popupConsignmentList.map((cons) => ({
          // action: cons['Planned Date'] ? 'E' : 'N',
          jobno: cons['tag_jobno'],
          contno: cons['Container #'],
          consignmentno: cons['Consignment #'],
          remarks: this.newReqPlanRemarksInput,
          oldreqdate: cons['Required Date'],
          newreqdate: new Date(this.newReqDateValue).formatString('yyyy-MM-dd') ?? null,
          oldreqtime: cons['Required Time'],
          newreqtime: new Date(this.newReqDateValue).formatString('HHmm') ?? null,
          oldreqdesc: cons['Req Time Desc'],
          newreqdesc: this.requiredTimeDescSelectedObject?.['Description'] == null ? this.requiredTimeDescSearch : null,
          oldofficehrs: cons['Office Hours'],
          newofficehrs: this.officeHrsChecked ? '1' : '0',
          plandate: new Date().formatString('yyyy-MM-dd'),
          timeplanned: new Date().formatString('HHmm'),
          team: this.selectedTeam ? this.selectedTeam['Team'] : null,
          pmcode: this.selectedPMCode ? this.selectedPMCode['PM Code'] : null,
          priority: this.selectedPriority ? this.selectedPriority.value : null,
          duedate: new Date(this.planDateValue).formatString('yyyy-MM-dd'),
          duetime: new Date(this.planDateValue).formatString('HHmm'),
          assignto: this.selectedDriver ? this.selectedDriver['Driver Code'] : null,
          taskseq: this.selectedShift ? this.selectedShift['Shift ID'] : null,
          oldcontopt: cons['Cont Operator'],
          newcontopt: this.newContOptInput ?? null,
          oldjobtype: cons['tag_contjobtype'],
          newjobtype: this.selectedJobType ? this.selectedJobType['Job Type'] : null,
          // basename: this.loginDetails["BaseName"],
        })),
      };

      this.$fullscreenLoading(`Editing ${this.EditCNTitle}`);
      const result = await this.$apiCallV2('/Consignment/EditConsignmentDetails', requestBody);
      this.$fullscreenLoading();

      if (result[0]['Results'] === '1') {
        this.popupEntryErrorMessages.push(result[0]['ErrMsg']);
      } else {
        this.popupEntrySuccessMessages.push('Editted Successfully');
        this.saveClicked = true;
        this.popupTitle = `View ${this.EditCNTitle}`;
        this.filtersRefreshClicked();
      }
    },
    EditVoyageInfoClicked: async function (e) {
      this.clearField();
      this.filtersIsOpen = false;
      this.popupTitle = 'Edit Voyage Info';

      if (!this.consignmentsTableBoxSelectedRow || this.consignmentsTableBoxSelectedRow.length === 0) {
        this.$showAlert('error', 'No Consignment Selected', 'Please select at least one consignment', [{ text: 'OK' }]);
        return;
      }

      this.popupConsignmentList = this.consignmentsTableBoxSelectedRow.map((cons) => {
        return {
          ...cons,
          'Booking Ref No': cons['tag_bookingrefno'],
          'Vessel ID': cons['tag_vesselno'],
          'Vessel Name': cons['tag_vesselname'],
          'Shipping Line': cons['tag_shippingline'],
          'Shipping Agent': cons['tag_shippingagent'],
          'Final Destination': cons['tag_finaldestination'],
          'ETA Date': cons['tag_etadate'],
          'ETA Time': cons['tag_timeeta'],
          'ETD Date': cons['tag_etddate'],
          'ETD Time': cons['tag_timeetd'],
          'Closing Date': cons['tag_closedate'],
          'Closing Time': cons['tag_closetime'],
          'Detention Date': cons['tag_detentiondate'],
          Remarks: '',
          // 'New SCN': '',
          // 'New Booking Ref No': '',
          // 'New Vessel ID': '',
          // 'New Vessel Name': '',
          // 'New Final Destination': '',
          // 'New ETA Date': null,
          // 'New ETA Time': null,
          // 'New ETD Date': null,
          // 'New ETD Time': null,
          // 'New Closing Date': null,
          // 'New Closing Time': null,
          // 'New Detention Date': null,
        };
      });

      const requestBody = {
        consignments: this.popupConsignmentList.map((cons) => cons['Consignment #']).join(','),
      };
      this.$fullscreenLoading('Validating consignment numbers');
      const resultStatus = await this.$apiCallV2('/Consignment/ValidateCN', requestBody);
      this.$fullscreenLoading();
      const cancelledConsignments = Object.entries(resultStatus.results)
        .filter(([_consignmentNumber, status]) => status === '9')
        .map(([consignmentNumber]) => consignmentNumber);

      if (cancelledConsignments.length > 0) {
        const consignmentCount = this.popupConsignmentList.length;
        const consignmentNumbers = cancelledConsignments.join(', ');

        const alertMessage = `${e.target.innerText.trim()} not allowed`;
        const detailMessage =
          consignmentCount === 1 ?
            `Consignment no. <b>${this.popupConsignmentList[0]['Consignment #']}</b> is already cancelled`
          : `Consignment no. <b>${consignmentNumbers}</b> are already cancelled`;

        await this.$showAlert('error', alertMessage, detailMessage, [{ text: 'OK' }]);
        this.popupConsignmentList = this.popupConsignmentList.filter(
          (cons) => !cancelledConsignments.includes(cons['Consignment #']),
        );
      }
      this.popupConsignmentList = this.popupConsignmentList.map((cons, i) => {
        return {
          ...cons,
          '#': i + 1,
        };
      });

      if (this.popupConsignmentList.length > 0) this.showVoyageInfoPopup = true;
    },
    EditVoySaveClicked: async function () {
      this.clearErrMsgs();
      const requestBody = {
        editcn: this.popupTitle,
        consignments: this.popupConsignmentList.map((cons) => ({
          jobno: cons['tag_jobno'],
          consignmentno: cons['Consignment #'],
          oldscn: cons['SCN'],
          newscn: this.selectedSCN ? this.selectedSCN['Ship Call No'] : null,
          oldvesselid: cons['Vessel ID'],
          newvesselid: this.selectedVesselID ? this.selectedVesselID['Vessel ID'] : this.vesselIDFreeText,
          oldvesselname: cons['Vessel Name'],
          newvesselname: this.selectedVesselName ? this.selectedVesselName['Vessel Name'] : this.vesselNameFreeText,
          oldshippingline: cons['Shipping Line'],
          newshippingline: this.shippingLineInput,
          oldshippingagent: cons['Shipping Agent'],
          newshippingagent: this.selectedShippingAgent ? this.selectedShippingAgent['Agent Code'] : null,
          oldfinaldestination: cons['Final Destination'],
          newfinaldestination: this.finalDestinationInput,
          oldbookingrefno: cons['Booking Ref No'],
          newbookingrefno: this.bookingRefNoInput,
          oldetadate: cons['ETA Date'],
          newetadate: this.ETADateTimeValue ? new Date(this.ETADateTimeValue).formatString('yyyy-MM-dd') : null,
          oldetatime: cons['ETA Time'],
          newetatime: this.ETADateTimeValue ? new Date(this.ETADateTimeValue).formatString('HHmm') : null,
          oldetddate: cons['ETD Date'],
          newetddate: this.ETDDateTimeValue ? new Date(this.ETDDateTimeValue).formatString('yyyy-MM-dd') : null,
          oldetdtime: cons['ETD Time'],
          newetdtime: this.ETDDateTimeValue ? new Date(this.ETDDateTimeValue).formatString('HHmm') : null,
          oldclosingdate: cons['Closing Date'],
          newclosingdate:
            this.closingDateTimeValue ? new Date(this.closingDateTimeValue).formatString('yyyy-MM-dd') : null,
          oldclosingtime: cons['Closing Time'],
          newclosingtime: this.closingDateTimeValue ? new Date(this.closingDateTimeValue).formatString('HHmm') : null,
          olddetentiondate: cons['Detention Date'],
          newdetentiondate:
            this.detentionDateTimeValue ? new Date(this.detentionDateTimeValue).formatString('yyyy-MM-dd') : null,
          remarks: this.newVoyRemark,
        })),
      };

      this.$fullscreenLoading(`Editing Voyage Info`);
      const result = await this.$apiCallV2('/Consignment/EditConsignmentDetails', requestBody);
      this.$fullscreenLoading();

      if (result[0]['Results'] === '1') {
        this.popupEntryErrorMessages.push(result[0]['ErrMsg']);
      } else {
        this.popupEntrySuccessMessages.push('Editted Successfully');
        this.saveClicked = true;
        this.popupTitle = `View Voyage Info`;
        this.filtersRefreshClicked();
      }
    },
    UpdateTrailerClicked: function () {
      this.clearField();
      this.filtersIsOpen = false;

      this.popupTitle = 'Update Trailer';
      this.showTrailerPopup = true;
      this.updateTypeSelected = this.updateTypeList[0];
    },
    UpdateTrailerSaveClicked: async function () {
      this.clearErrMsgs();
      if (this.FieldCheck(this.popupTitle.trim())) {
        return;
      }

      const requestBody = {
        action: 'N',
        cn: this.selectedTrailerCN ?? '',
        mvttype: this.updateTypeSelected['key'],
        trcode: this.selectedTrailerNo['Inventory Code'] ?? '',
        driver: this.selectedTrailerDriver ?? '',
        pm: this.selectedTrailerPM ?? '',
        remark: this.updateTrailerRemarks ?? '',
        updatedatetime: new Date(this.updateTRDateValue).formatString('yyyy-MM-dd HH:mm'),
      };

      this.$fullscreenLoading(`Updating Trailer`);
      const result = await this.$apiCallV2('/Consignment/UpdateTrailer', requestBody);
      this.$fullscreenLoading();

      if (result[0]['Results'] === '1') {
        this.popupEntryErrorMessages.push(result[0]['ErrMsg']);
      } else {
        this.popupEntrySuccessMessages.push(result[0]['ErrMsg']);
        this.saveClicked = true;
        this.GetTrailerSelected();
      }
    },
    GetTrailerSelected: async function () {
      if (!this.selectedTrailerNo) {
        this.selectedTrailerNoErrorMsg = 'Trailer No Is Required!';
        return;
      }

      this.refreshClicked = true;
      this.trHistoryList = [];
      this.selectedTrailerCN = '';
      this.trHistoryList = await this.$apiCallV2(
        `/Consignment/GetTrailerHistoryListing?trcode=${this.selectedTrailerNo['Inventory Code']}`,
      );
      this.refreshClicked = false;
    },
    RadioCallHistoryTableBoxRowSelected: function (selectedRow, selected) {
      this.selectedTrailerCN = selected ? selectedRow?.['CN #'] : '';
      this.selectedTrailerPM = selected ? selectedRow?.['PM'] : '';
      this.selectedTrailerDriver = selected ? selectedRow?.['Driver'] : '';
    },
    EditDestSaveClicked: async function () {
      this.clearErrMsgs();
      this.FieldCheck(this.popupTitle.trim());
      const requestBody = {
        editcn: this.popupTitle,
        consignments: this.popupConsignmentList.map((cons) => ({
          jobno: cons['tag_jobno'],
          consignmentno: cons['Consignment #'],
          jobtype: cons['tag_jobtype'],
          isdiversion: cons['Diversion Ct'],
          olddest:
            this.popupTitle.trim() == 'Change Pick-up' ? cons['Pick-Up']
            : this.popupTitle.trim() == 'Change Drop-off' ? cons['Drop-Off']
            : cons['Discharge Port'],
          newdest:
            this.popupTitle.trim() != 'Change Discharge Port' ?
              this.selectedDest['Destination Code']
            : this.selectedDest['Port Code'],
          destname: this.popupTitle.trim() == 'Change Discharge Port' ? this.selectedDest['Port Location'] : null,
          handlingtype: cons['tag_handlingtype'],
          deliverytype: cons['tag_deliverytype'],
          contsize: cons['Size'],
          conttype: cons['Type'],
          cunumber: cons['tag_cu_number'],
          hauliercode: cons['tag_hauliercode'],
          requestno: cons['Request #'],
          base: cons['tag_base'],
          requestdate: cons['tag_requestdate'],
          remarks: this.newVoyRemark,
        })),
      };

      this.$fullscreenLoading(`Editing Voyage Info`);
      const result = await this.$apiCallV2('/Consignment/EditConsignmentDetails', requestBody);
      this.$fullscreenLoading();

      if (result[0]['Results'] === '1') {
        this.popupEntryErrorMessages.push(result[0]['ErrMsg']);
      } else {
        this.popupEntrySuccessMessages.push('Editted Successfully');
        this.saveClicked = true;
        this.popupTitle = `View ${this.popupTitle}`;
        this.filtersRefreshClicked();
      }
    },
    DocsTypeInputTitle: function (jobType) {
      if (this.docsTypeTitle == 'Receive Gate Pass/ CMO') {
        if (jobType == 'E') {
          this.docType = 'CMO';
        } else if (jobType == 'I') {
          this.docType = 'Gate Pass';
        }
        return 'Gate Pass/ CMO #';
      } else if (this.docsTypeTitle == 'Receive Seal') {
        return 'Seal #';
      } else if (this.docsTypeTitle == 'Receive Bill of Lading') {
        return 'B/L #';
      } else if (this.docsTypeTitle == 'Receive Fumigation') {
        return 'Fumigation #';
      }
      return 'Cheque/ Receipt #';
    },
    ReceiveDocsClicked: async function (e) {
      this.clearField();
      this.filtersIsOpen = false;

      if (!this.consignmentsTableBoxSelectedRow || this.consignmentsTableBoxSelectedRow.length === 0) {
        this.$showAlert('error', 'No Consignment Selected', 'Please select at least one consignment', [{ text: 'OK' }]);
        return;
      }

      switch (e.target.innerText.trim().toUpperCase()) {
        case 'GATE PASS/ CMO':
          this.docsTypeTitle = 'Receive Gate Pass/ CMO';
          this.DocTitle = 'Gate Pass/ CMO #';
          break;
        case 'SEAL':
          this.docsTypeTitle = 'Receive Seal';
          this.DocTitle = 'Seal #';
          break;
        case 'CHEQUE/ RECEIPT':
          this.docsTypeTitle = 'Receive Cheque/ Receipt';
          this.DocTitle = 'Cheque/ Receipt #';
          break;
        case 'BILL OF LADING (B/L)':
          this.docsTypeTitle = 'Receive Bill of Lading';
          this.DocTitle = 'B/L #';
          break;
        case 'FUMIGATION':
          this.docsTypeTitle = 'Receive Fumigation';
          this.DocTitle = 'Fumigation #';
          break;
      }

      this.popupConsignmentList = this.consignmentsTableBoxSelectedRow.map((cons) => {
        return {
          ...cons,
          [this.DocTitle]: '',
          'Doc Receive Date': null,
          'Doc Receive Time': null,
          ...(this.DocTitle == 'Cheque/ Receipt #' ? { 'Document Type': '' } : {}),
          Remarks: '',
          // [`New ${this.DocTitle}`]: '',
          // 'New Doc Receive Date': null,
          // 'New Doc Receive Time': null,
          // ...(this.DocTitle == "Cheque/ Receipt #" ? { 'New Document Type': ''} : {}),
        };
      });

      let requestBody = {
        consignments: this.popupConsignmentList.map((cons) => cons['Consignment #']).join(','),
      };

      this.$fullscreenLoading('Validating consignment numbers');
      const resultStatus = await this.$apiCallV2('/Consignment/ValidateCN', requestBody);
      this.$fullscreenLoading();
      const cancelledConsignments = Object.entries(resultStatus.results)
        .filter(([_consignmentNumber, status]) => status === '9')
        .map(([consignmentNumber]) => consignmentNumber);

      if (cancelledConsignments.length > 0) {
        const consignmentCount = this.popupConsignmentList.length;
        const consignmentNumbers = cancelledConsignments.join(', ');

        const alertMessage = `${e.target.innerText.trim()} not allowed`;
        const detailMessage =
          consignmentCount === 1 ?
            `Consignment no. <b>${this.popupConsignmentList[0]['Consignment #']}</b> is already cancelled`
          : `Consignment no. <b>${consignmentNumbers}</b> are already cancelled`;

        await this.$showAlert('error', alertMessage, detailMessage, [{ text: 'OK' }]);
        this.popupConsignmentList = this.popupConsignmentList.filter(
          (cons) => !cancelledConsignments.includes(cons['Consignment #']),
        );
      }
      this.popupConsignmentList = this.popupConsignmentList.map((cons, i) => {
        return {
          ...cons,
          '#': i + 1,
        };
      });

      requestBody = {
        consignments: this.popupConsignmentList.map((cons) => {
          const res = this.DocsTypeInputTitle(cons['tag_jobtype']).replace('#', '');

          return {
            consignmentno: cons['Consignment #'],
            doctype: res == 'Gate Pass/ CMO ' ? this.docType : res,
          };
        }),
      };

      this.$fullscreenLoading('Validating consignment numbers');
      await this.listMerge(requestBody);
      this.$fullscreenLoading();

      if (this.popupConsignmentList.length > 0) {
        this.popupTitle = this.docsTypeTitle;
        this.showDocsType = true;
        this.showDocsTypeTable = true;
      }
    },
    ReceiveDocsTypeSaveClicked: async function () {
      this.clearErrMsgs();
      if (this.FieldCheck(this.EditCNTitle.trim())) {
        return;
      }

      this.showDocsTypeTable = false;
      const requestBody = {
        consignments: this.popupConsignmentList.map((cons) => {
          const res = this.DocsTypeInputTitle(cons['tag_jobtype']).replace('#', '');

          return {
            action:
              this.action == '' ?
                cons['docExist'] ?
                  'E'
                : 'N'
              : this.action,
            jobno: cons['tag_jobno'],
            consignmentno: cons['Consignment #'],
            doctype:
              res.trim() == 'Gate Pass/ CMO' ? this.docType
              : res.includes('Cheque') || res.includes('Receipt') ? cons['New Document Type']
              : res.trim(),
            docno: this.docNoInput,
            docremarks: this.recRemarksInput ?? '',
            recdate: new Date(this.receiveDateTimeValue).formatString('yyyy-MM-dd'),
            rectime: new Date(this.receiveDateTimeValue).formatString('HHmm'),
            contno: cons['Container #'] ?? '',
          };
        }),
      };

      this.$fullscreenLoading(`Editing `);
      const result = await this.$apiCallV2('/Consignment/RecDocsType', requestBody);

      this.$fullscreenLoading('Retrieving Record');
      this.showDocsTypeTable = false;
      await this.listMerge(requestBody);
      this.showDocsTypeTable = true;
      this.$fullscreenLoading('');

      if (result[0]['Results'] === '1') {
        this.popupEntryErrorMessages.push(result[0]['ErrMsg']);
      } else {
        this.popupEntrySuccessMessages.push('Successfully Upload Documents');
        this.saveClicked = true;
        this.showDocsTypeTable = this.saveClicked;
        this.popupTitle = `View ${this.docsTypeTitle}`;
        this.filtersRefreshClicked();
      }
    },
    DeleteRecClicked: async function (_btn, data) {
      const res = this.DocsTypeInputTitle(data['tag_jobtype']).replace('#', '');
      let msg = '';
      let buttons = [];
      if (data[`${res.trim()} #`] == '') {
        msg = 'There is no record to delete for consignment no. <b>' + data['Consignment #'] + '</b>';
      } else {
        msg = 'Are you sure you want to delete the record for consignment no. <b>' + data['Consignment #'] + '</b>?';
        buttons = [
          { text: 'Delete', color: 'red', textColor: 'white' },
          { text: 'Cancel', color: 'lightgray', textColor: 'black' },
        ];
      }

      const deleteRec = await this.$showAlert('warning', 'Delete Record', msg, buttons);

      if (deleteRec == 'Cancel' || deleteRec == 'OK') {
        return;
      }

      this.$fullscreenLoading('Deleting Record');
      let requestBody = {
        consignments: [
          {
            action: 'D',
            jobno: data['tag_jobno'],
            consignmentno: data['Consignment #'],
            doctype:
              res.trim() == 'Gate Pass/ CMO' ? this.docType
              : res.includes('Cheque') || res.includes('Receipt') ? data['New Document Type']
              : res.trim(),
            docno: data[`${res.trim()} #`],
            seqno: data['SeqNo'],
          },
        ],
      };
      await this.$apiCallV2('/Consignment/RecDocsType', requestBody);
      this.$fullscreenLoading('');

      this.$fullscreenLoading('Retrieving Record');
      this.showDocsTypeTable = false;
      requestBody = {
        consignments: [
          {
            consignmentno: data['Consignment #'],
            doctype:
              res.trim() == 'Gate Pass/ CMO' ? this.docType
              : res.includes('Cheque') || res.includes('Receipt') ? data['New Document Type']
              : res.trim(),
          },
        ],
      };
      await this.listMerge(requestBody);
      this.showDocsTypeTable = true;
      this.$fullscreenLoading('');
    },
    RequestHoldClicked: async function (_btn) {
      this.clearField();
      this.filtersIsOpen = false;

      if (_btn.target.innerText.trim().toUpperCase() === 'REQUEST HOLD') {
        this.action = 'H';
      } else if (_btn.target.innerText.trim().toUpperCase() === 'RELEASE HOLD') {
        this.action = 'R';
      }

      if (!this.consignmentsTableBoxSelectedRow || this.consignmentsTableBoxSelectedRow.length === 0) {
        this.$showAlert('error', 'No Consignment Selected', 'Please select at least one consignment', [{ text: 'OK' }]);
        return;
      }

      this.popupConsignmentList = this.consignmentsTableBoxSelectedRow.map((cons) => {
        return {
          ...cons,
        };
      });

      const requestBody = {
        consignments: this.popupConsignmentList.map((cons) => cons['Consignment #']).join(','),
      };

      this.$fullscreenLoading('Validating consignment numbers');
      const resultStatus = await this.$apiCallV2('/Consignment/ValidateRequestHold', requestBody);
      this.$fullscreenLoading();

      if (this.action == 'H') {
        const unallowHoldList = this.popupConsignmentList.filter((item) => {
          return resultStatus.some(
            (result) => result['Consignment No'] == item['Consignment #'] && result['Consignment Details'],
          );
        });

        if (unallowHoldList.length > 0) {
          const alertMessage = 'Cannot hold consignment(s)';
          const detailed = {};
          let detailMessage = '';

          resultStatus.forEach((result) => {
            if (result['Consignment Details'] && result['Consignment Details'].trim() !== '') {
              const cndetail = result['Consignment Details'];
              if (!detailed[cndetail]) {
                detailed[cndetail] = [];
              }
              // include consignments that are in unallowHoldList
              if (unallowHoldList.some((item) => item['Consignment #'] === result['Consignment No'])) {
                detailed[cndetail].push(result['Consignment No']);
              }
            }
          });

          for (const [message, consignments] of Object.entries(detailed)) {
            if (consignments.length > 0) {
              detailMessage += `Consignment No: <b>${consignments.join(', ')}</b>. ${message}<br>`;
            }
          }

          await this.$showAlert('error', alertMessage, detailMessage, [{ text: 'OK' }]);

          // Filter out the unallowed consignments
          this.popupConsignmentList = this.popupConsignmentList.filter(
            (cons) => !unallowHoldList.some((unallowCons) => unallowCons['Consignment #'] === cons['Consignment #']),
          );
        }

        this.popupTitle = 'Request Hold';
        if (this.popupConsignmentList.length > 0) {
          this.showRequestHold = true;
        }
      } else if (this.action == 'R') {
        const unallowReleaseList = this.popupConsignmentList.filter((item) => {
          return item['tag_hold'] == 0;
        });

        if (unallowReleaseList.length > 0) {
          const alertMessage = 'Cannot release consignment(s)';
          const detailed = {};
          let detailMessage = '';

          resultStatus.forEach((result) => {
            if (result['Consignment Details'] && result['Consignment Details'].trim() !== '') {
              const cndetail = result['Consignment Details'];
              if (!detailed[cndetail]) {
                detailed[cndetail] = [];
              }
              // include consignments that are in unallowHoldList
              if (unallowReleaseList.some((item) => item['Consignment #'] === result['Consignment No'])) {
                detailed[cndetail].push(result['Consignment No']);
              }
            }
          });

          // set of consignment no
          const detailedCN = new Set(Object.values(detailed).flat());
          const missingCN = unallowReleaseList
            .filter((item) => !detailedCN.has(item['Consignment #']))
            .map((item) => item['Consignment #']);

          // add default message for missing consignments
          if (missingCN.length > 0) {
            detailed['Consignment not in hold'] = missingCN;
          }

          for (const [message, consignments] of Object.entries(detailed)) {
            if (consignments.length > 0) {
              detailMessage += `Consignment No: <b>${consignments.join(', ')}</b>. ${message}<br>`;
            }
          }

          await this.$showAlert('error', alertMessage, detailMessage, [{ text: 'OK' }]);

          // Filter out the unallowed consignments
          this.popupConsignmentList = this.popupConsignmentList.filter(
            (cons) => !unallowReleaseList.some((unallowCons) => unallowCons['Consignment #'] === cons['Consignment #']),
          );
        }
        this.RequestHoldSaveClicked();
      }
    },
    RequestHoldSaveClicked: async function () {
      this.clearField();
      let error = false;

      if (this.action == 'H') {
        this.popupConsignmentList.forEach((cons, i) => {
          if (!cons['Hold Remarks']) {
            this.HoldRemarksErrMsg[i] = 'Hold remarks is required';
            error = true;
          }
        });

        if (error) {
          return;
        }
      }

      const requestBody = {
        action: this.action,
        consignments: this.popupConsignmentList.map((cons) => ({
          jobno: cons['tag_jobno'],
          consignmentno: cons['Consignment #'],
          remarks: cons['Hold Remarks'],
          contno: cons['Container #'],
        })),
      };

      this.$fullscreenLoading('Reuesting Hold');
      const result = await this.$apiCallV2('/Consignment/RequestHold', requestBody);
      this.$fullscreenLoading();

      if (result[0]['Results'] === '1') {
        this.$showAlert('warning', result[0]['ErrorTitle'], result[0]['ErrMsg'], [{ text: 'OK' }]);
      } else if (result[0]['Results'] === '0') {
        this.popupEntrySuccessMessages.push(result[0]['ErrMsg']);
        this.saveClicked = true;
        this.showEditCont = false;
        this.filtersRefreshClicked();
      }
    },
    EditContPopupButtonsClicked: async function (buttonText) {
      if (buttonText === 'Cancel') {
        this.showEditCont = false;
        return;
      }

      if (this.newContainerNo.trim().length <= 0) {
        this.ContainerNoErrMsg = 'Container No is required';
        return;
      }

      const requestBody = {
        editcn: buttonText,
        jobno: this.consignmentsTableBoxSelectedRow[0]['tag_jobno'],
        consignmentno: this.consignmentsTableBoxSelectedRow[0]['Consignment #'],
        oldcontno: this.oldContainerNo,
        newcontno: this.newContainerNo,
        newsealno: this.newSealNo,
        oldsealno: this.oldSealNo,
        remarks: this.remarks,
      };

      this.$fullscreenLoading('Editing Container #');
      const result = await this.$apiCallV2('/Consignment/EditConsignmentDetails', requestBody);
      this.$fullscreenLoading();

      if (result[0]['Results'] === '1') {
        this.$showAlert('warning', result[0]['ErrorTitle'], result[0]['ErrMsg'], [{ text: 'OK' }]);
      } else if (result[0]['Results'] === '0') {
        this.$showAlert(
          'success',
          result[0]['ErrMsg'],
          `Successfully edited <b>${this.oldContainerNo}</b> to <b>${this.newContainerNo}</b>`,
          [{ text: 'OK' }],
        );
        this.showEditCont = false;
        this.clearField();
        this.filtersRefreshClicked();
      }
    },
    PMCodeSelected: function () {
      this.selectedTeam = this.populateObject(this.teamList, 'Team', this.selectedPMCode?.Team) ?? null;
    },
    VesselInfoSelected: function (e) {
      if (e) {
        this.selectedVesselName = this.populateObject(this.vesselList, 'Vessel Name', e['Vessel Name']);
        this.vesselNameFreeText = this.selectedVesselName ? null : e['Vessel Name'];

        this.selectedVesselID = this.selectedVesselName;
        this.vesselIDFreeText = this.selectedVesselName ? null : e['Vessel ID'];

        this.ETADateTimeValue =
          e['ETA'] ? new Date(e['ETA'].replace(' ', 'T').replace(/(\d{2})(\d{2})$/, '$1:$2:00')) : null;
        this.ETDDateTimeValue =
          e['ETD'] ? new Date(e['ETD'].replace(' ', 'T').replace(/(\d{2})(\d{2})$/, '$1:$2:00')) : null;
        this.closingDateTimeValue =
          e['Closing LCL'] ? new Date(e['Closing LCL'].replace(' ', 'T').replace(/(\d{2})(\d{2})$/, '$1:$2:00'))
          : e['Closing FCL'] ? new Date(e['Closing FCL'].replace(' ', 'T').replace(/(\d{2})(\d{2})$/, '$1:$2:00'))
          : null;
      }
    },
    FieldCheck: function (title) {
      let error = false;

      if (title === 'Edit Plan Date') {
        if (this.checkDate('Plan Date', this.planDateValue)) {
          error = true;
        }

        if (!this.selectedPMCode) {
          this.PMCodeErrMsg = 'PM Code is required';
          error = true;
        }

        if (!this.selectedDriver) {
          this.DriverErrMsg = 'Driver is required';
          error = true;
        }
      } else if (title === 'Edit Required Date') {
        if (this.checkDate('New Required Date', this.newReqDateValue)) {
          error = true;
        }
      } else if (title === 'Change Operator') {
        if (!this.newContOptInput) {
          this.operatorErrMsg = 'Operator is required';
          error = true;
        }
      } else if (title === 'Change Pick-up' || title === 'Change Drop-off' || title === 'Change Discharge Port') {
        if (!this.selectedDest) {
          this.selectDestErrMsg = `${this.popupTitle.replace('Change ', '')} is required`;
          error = true;
        }
      } else if (title === 'Edit Job Type') {
        if (!this.selectedJobType) {
          this.jobTypeErrMsg = 'Job Type is required';
          error = true;
        }
      } else if (title === 'Update Trailer') {
        if (!this.selectedTrailerNo) {
          this.selectedTrailerNoErrorMsg = 'Trailer No Is Required!';
          error = true;
        } else if (this.RadioCallHistoryTableBoxSelectedRow.length == 0) {
          this.$showAlert('warning', 'No Radio-Call History Selected', 'Please select one data', [{ text: 'OK' }]);
          error = true;
        } else {
          if (!this.updateTypeSelected) {
            this.updateTypeSelectedErrMsg = 'Update Type is required';
            error = true;
          }

          if (this.checkDate('Date/ Time', this.updateTRDateValue)) {
            error = true;
          }
        }
      } else {
        if (this.checkDate('Receive Date Time', this.receiveDateTimeValue)) {
          error = true;
        }

        if (!this.docNoInput) {
          this.DocsTypeInputErrMsg = `${this.DocTitle} is required`;
          error = true;
        }
      }

      return error;
    },
    // commented out due to over engineering -- leejq
    // EditSelectedRowClicked: async function (title) {
    //   let error = false;
    //   if (this.selectedEditRow.length === 0) {
    //     this.$showAlert('error', 'No Consignment Selected', 'Please select at least one consignment', [
    //       { text: 'OK' },
    //     ]);
    //     return;
    //   }

    //   if (title === 'Edit Plan Date') {
    //     if(this.checkDate('Plan Date', this.planDateValue)) {
    //       error = true;
    //     }

    //     if (!this.selectedPMCode) {
    //       this.PMCodeErrMsg = 'PM Code is required';
    //       error = true;
    //     }

    //     if (!this.selectedDriver) {
    //       this.DriverErrMsg = 'Driver is required';
    //       error = true;
    //     }
    //   } else if (title === 'Edit Required Date') {
    //     if (this.checkDate('New Required Date', this.newReqDateValue)) {
    //       error = true;
    //     }
    //   } else if (title !== 'Edit Voyage Info') {
    //     if (this.checkDate('Receive Date Time', this.receiveDateTimeValue)) {
    //       error = true;
    //     }

    //     if (!this.docNoInput) {
    //       this.DocsTypeInputErrMsg = `${this.DocTitle} is required`;
    //       error = true;
    //     }
    //   }

    //   if (error) {
    //     return;
    //   }

    //   switch(title){
    //     case "Edit Plan Date":
    //     case "Edit Required Date":
    //       this.editCNContentTable = false;
    //       break;
    //     case "Edit Voyage Info":
    //       this.editVoyInfoContentTable = false;
    //       break;
    //     default:
    //       this.showDocsType = false;
    //       this.showDocsTypeTable = false;
    //       break;
    //   }

    //   console.log('remarks', this.recRemarksInput);

    //   const selectedRowsArray = Array.from(this.selectedEditRow.values());
    //   const temp = new Set(this.popupConsignmentList.map((cons) => cons['Consignment #']));
    //   let updatedList = [];

    //   if (title === 'Edit Plan Date') {
    //     updatedList = this.popupConsignmentList
    //       .map((cons) => {
    //         const matchCN = selectedRowsArray.find((row) => row['Consignment #'] === cons['Consignment #']);
    //         return matchCN ?
    //             {
    //               ...cons,
    //               ...matchCN,
    //               'Plan Date': new Date(this.planDateValue).formatString('yyyy-MM-dd'),
    //               'Plan Time': new Date(this.planDateValue).formatString('HHmm'),
    //               'New Priority': this.selectedPriority['value'],
    //               'New PM Code': this.selectedPMCode['PM Code'],
    //               'New Driver': this.selectedDriver['Driver Code'],
    //               'New Team': this.selectedTeam['Team'],
    //               'New Shift': this.selectedShift['Shift ID'],
    //               'Remarks': this.newReqPlanRemarksInput,
    //               'tag_action': 'N',
    //             }
    //           : cons;
    //       })
    //       .concat(selectedRowsArray.filter((row) => !temp.has(row['Consignment #'])));
    //   } else if (title === 'Edit Required Date') {
    //     updatedList = this.popupConsignmentList
    //       .map((cons) => {
    //         const matchCN = selectedRowsArray.find((row) => row['Consignment #'] === cons['Consignment #']);
    //         return matchCN ?
    //             {
    //               ...cons,
    //               ...matchCN,
    //               'New Required Date': new Date(this.newReqDateValue).formatString('yyyy-MM-dd'),
    //               'New Required Time': new Date(this.newReqDateValue).formatString('HHmm'),
    //               'New Req Time Desc': this.newReqTimeDescInput,
    //               'New Office Hours': this.officeHrsChecked ? 1 : 0,
    //               'Remarks': this.newReqPlanRemarksInput,
    //             }
    //           : cons;
    //       })
    //       .concat(selectedRowsArray.filter((row) => !temp.has(row['Consignment #'])));
    //   } else if (title === 'Edit Voyage Info') {
    //     updatedList = this.popupConsignmentList
    //       .map((cons) => {
    //         const matchCN = selectedRowsArray.find((row) => row['Consignment #'] === cons['Consignment #']);
    //         return matchCN ?
    //             {
    //               ...cons,
    //               ...matchCN,
    //               "New SCN": this.selectedSCN ? this.selectedSCN['Ship Call No'] : null,
    //               'New Vessel ID': this.selectedVesselID ? this.selectedVesselID['Vessel ID'] : null,
    //               'New Vessel Name': this.selectedVesselName ? this.selectedVesselName['Vessel Name'] : this.vesselNameFreeText,
    //               "New Final Destination": this.finalDestinationInput,
    //               "New Booking Ref No": this.bookingRefNoInput,
    //               'New ETA Date': this.ETADateTimeValue ? new Date(this.ETADateTimeValue).formatString('yyyy-MM-dd') : null,
    //               'New ETA Time': this.ETADateTimeValue ? new Date(this.ETADateTimeValue).formatString('HHmm') : null,
    //               'New ETD Date': this.ETDDateTimeValue ? new Date(this.ETDDateTimeValue).formatString('yyyy-MM-dd') : null,
    //               'New ETD Time': this.ETDDateTimeValue ? new Date(this.ETDDateTimeValue).formatString('HHmm') : null,
    //               'New Closing Date': this.closingDateTimeValue ? new Date(this.closingDateTimeValue).formatString('yyyy-MM-dd') : null,
    //               'New Closing Time': this.closingDateTimeValue ? new Date(this.closingDateTimeValue).formatString('HHmm') : null,
    //               'New Detention Date': this.detentionDateTimeValue ? new Date(this.detentionDateTimeValue).formatString('yyyy-MM-dd') : null,
    //               'Remarks': this.newVoyRemark,
    //             }
    //           : cons;
    //       })
    //       .concat(selectedRowsArray.filter((row) => !temp.has(row['Consignment #'])));
    //   } else {
    //     updatedList = this.popupConsignmentList
    //       .map((cons) => {
    //         const matchCN = selectedRowsArray.find((row) => row['Consignment #'] === cons['Consignment #']);
    //         const newDocType = this.DocTitle == "Cheque/ Receipt #" ? { 'New Document Type': this.docTypeSelected?.label ?? '' }: {};
    //         return matchCN ?
    //             {
    //               ...cons,
    //               ...matchCN,
    //               [`New ${this.DocTitle}`]: this.docNoInput,
    //               'New Doc Receive Date': new Date(this.receiveDateTimeValue).formatString('yyyy-MM-dd'),
    //               'New Doc Receive Time': new Date(this.receiveDateTimeValue).formatString('HHmm'),
    //               'Remarks': this.recRemarksInput,
    //               ...newDocType,
    //             }
    //           : cons;
    //       })
    //       .concat(selectedRowsArray.filter((row) => !temp.has(row['Consignment #'])));
    //   }

    //   await this.$nextTick();
    //   this.popupConsignmentList = updatedList;

    //   switch(title){
    //     case "Edit Plan Date":
    //     case "Edit Required Date":
    //       this.editCNContentTable = true;
    //       break;
    //     case "Edit Voyage Info":
    //       this.editVoyInfoContentTable = true;
    //       break;
    //     default:
    //       this.showDocsType = true;
    //       this.showDocsTypeTable = true;
    //       break;
    //   }
    //   this.selectedEditRow = [];
    //   this.clearField();
    // },
    RFCUpdateMenuButtonClicked: async function () {
      this.clearField();
      this.filtersIsOpen = false;

      if (!this.consignmentsTableBoxSelectedRow || this.consignmentsTableBoxSelectedRow.length === 0) {
        this.$showAlert('error', 'No Consignment Selected', 'Please select at least one consignment to update RFC', [
          { text: 'OK' },
        ]);
        return;
      }

      this.popupConsignmentList = this.consignmentsTableBoxSelectedRow.map((cons) => {
        return {
          ...cons,
          'Date Received': new Date(),
          'Date to Collect': new Date(),
          'Office Hours': false,
        };
      });

      this.$fullscreenLoading('Checking RFC Validity');
      const requestBody = {
        consignments: this.popupConsignmentList.map((cons) => cons['Consignment #']).join(','),
      };
      const validateRFCResult = await this.$apiCallV2('/Consignment/ValidateRFCUpdate', requestBody);
      this.$fullscreenLoading();

      const consignmentResults = validateRFCResult.map((item) => {
        const resultArray = JSON.parse(item.Result); // Parse the Result string into an object
        return {
          ConsignmentNo: item.ConsignmentNo,
          Results: resultArray[0].Results,
          ErrMsg: resultArray[0].ErrMsg,
        };
      });

      const notDelivered = [];
      const alreadyCancelled = [];
      const reUpdate = [];
      const unallowMessages = [];
      const allowMessages = [];
      //result 1 = not delivered, result 9 = already cancelled, result 2 = RFC already updated
      for (let i = 0; i < consignmentResults.length; i++) {
        if (consignmentResults[i]['Results'] === 1) {
          notDelivered.push(consignmentResults[i]['ConsignmentNo'].trim());
        } else if (consignmentResults[i]['Results'] === 9) {
          alreadyCancelled.push(consignmentResults[i]['ConsignmentNo'].trim());
        } else if (consignmentResults[i]['Results'] === 2) {
          reUpdate.push(`${consignmentResults[i]['ConsignmentNo'].trim()} - ${consignmentResults[i]['ErrMsg']}`);
        }
      }

      if (notDelivered.length > 0) {
        unallowMessages.push('Consignment no. <b>'.concat(notDelivered.join(', ')) + '</b> not delivered yet');
      }

      if (alreadyCancelled.length > 0) {
        unallowMessages.push('Consignment no. <b>'.concat(alreadyCancelled.join(', ')) + '</b> is already cancelled');
      }

      if (reUpdate.length > 0) {
        allowMessages.push('Consignment no. <b>'.concat(reUpdate.join(', ')) + '</b>');
      }

      if (unallowMessages.length > 0) {
        const messageText = unallowMessages.join('<br>');
        await this.$showAlert('error', 'RFC not allowed', messageText, [{ text: 'OK' }]);
        const filteredConsignments = consignmentResults.filter((cons) => cons.Results != 1);
        this.popupConsignmentList = this.popupConsignmentList.filter((cons) =>
          filteredConsignments.find((consResult) => consResult.ConsignmentNo === cons['Consignment #']),
        );
        if (allowMessages.length === 0) {
          return;
        }
      }

      if (allowMessages.length > 0) {
        allowMessages.push('Are you sure you wish to re-update RFC?');
        const messageText = allowMessages.join('<br>');
        const confirm = await this.$showAlert('warning', 'RFC already updated', messageText, [
          { text: 'Re-update' },
          { text: 'Cancel', textColor: 'white', color: 'gray' },
        ]);

        if (confirm === 'Cancel') {
          return;
        }
      }

      if (
        // if this is the first time the RFC Update popup is being shown
        !this.RFCUpdatePopupRFCModeDropdownItems ||
        this.RFCUpdatePopupRFCModeDropdownItems.length === 0
      ) {
        this.$fullscreenLoading('Getting RFC Modes'); // get RFC Moees from API
        this.RFCUpdatePopupRFCModeDropdownItems = await this.$apiCallV2('/Master/GetListMaster', {
          masterfile: 'RFCMODES',
        });
        this.RFCUpdatePopupRFCModeDropdownDefaultRFCMode = (
          await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=HMS_DEFAULTRFCMODE')
        )?.[0]?.SettingsValue;
        this.$fullscreenLoading();
      }

      // populate PopupV2 fields
      this.RFCUpdatePopupJobType = validateRFCResult['Job Type'];
      this.RFCUpdatePopupConsignmentNoInputValue = validateRFCResult['Consignment #'];
      this.RFCUpdatePopupContainerNoInputValue = validateRFCResult['Container #'];
      switch (this.RFCUpdatePopupRFCModeDropdownDefaultRFCMode) {
        case '0':
          this.RFCUpdatePopupRFCModeDropdownSelectedItem =
            this.RFCUpdatePopupRFCModeDropdownItems?.find((item) => {
              return item['RFC Mode'] === 'Fax';
            }) ?? null;
          break;

        case '1':
          this.RFCUpdatePopupRFCModeDropdownSelectedItem =
            this.RFCUpdatePopupRFCModeDropdownItems?.find((item) => {
              return item['RFC Mode'] === 'Phone';
            }) ?? null;
          break;

        case '2':
          this.RFCUpdatePopupRFCModeDropdownSelectedItem =
            this.RFCUpdatePopupRFCModeDropdownItems?.find((item) => {
              return item['RFC Mode'] === 'Email';
            }) ?? null;
          break;

        case '3':
          this.RFCUpdatePopupRFCModeDropdownSelectedItem =
            this.RFCUpdatePopupRFCModeDropdownItems?.find((item) => {
              return item['RFC Mode'] === 'Others';
            }) ?? null;
          break;
      }
      this.RFCUpdatePopupRFCModeDropdownErrorMessage = '';
      this.RFCUpdatePopupDocRefNoInputValue = '';
      this.RFCUpdatePopupDocRefNoInputErrorMessage = '';

      this.RFCUpdatePopupDateReceivedValue = new Date();
      // this.RFCUpdatePopupDateReceivedErrorMessage = "";
      this.RFCDateReceivedErrMsgs = [];
      if (validateRFCResult['Collection Time Lead'] && !isNaN(parseInt(validateRFCResult['Collection Time Lead']))) {
        this.RFCUpdatePopupDateToCollectValue = new Date(
          new Date().getTime() + parseInt(validateRFCResult['Collection Time Lead']) * 60 * 1000, // convert minutes to milliseconds and add to current datetime
        );
      } else {
        this.RFCUpdatePopupDateToCollectValue = new Date();
      }
      // this.RFCUpdatePopupDateToCollectErrorMessage = "";
      this.RFCDateToCollectErrMsgs = [];
      // this.RFCUpdatePopupOfficeHoursIsChecked = false;

      if (validateRFCResult['Closing Date'] && typeof validateRFCResult['Closing Date'] === 'string') {
        // if not null or blank
        const [date] = validateRFCResult['Closing Date'].split(' ');
        const [year, month, day] = date.split('-');

        if (validateRFCResult['Closing Time'] && typeof validateRFCResult['Closing Time'] === 'string') {
          // if not null or blank
          this.RFCUpdatePopupClosingTimeValue = new Date(
            year,
            parseInt(month) - 1,
            day,
            validateRFCResult['Closing Time'].slice(0, 2),
            validateRFCResult['Closing Time'].slice(2, 4),
          );
        } else {
          this.RFCUpdatePopupClosingTimeValue = new Date(year, parseInt(month) - 1, day, 0, 0);
        }
      }
      if (validateRFCResult['Detention'] && typeof validateRFCResult['Detention'] === 'string') {
        // if not null or blank
        const [date] = validateRFCResult['Detention'].split(' ');
        const [year, month, day] = date.split('-');

        this.RFCUpdatePopupDetentionDateValue = new Date(year, parseInt(month) - 1, day);
      }
      if (validateRFCResult['ETA Date'] && typeof validateRFCResult['ETA Date'] === 'string') {
        // if not null or blank
        const [date] = validateRFCResult['ETA Date'].split(' ');
        const [year, month, day] = date.split('-');

        if (validateRFCResult['ETA Time'] && typeof validateRFCResult['ETA Time'] === 'string') {
          // if not null or blank
          this.RFCUpdatePopupETATimeValue = new Date(
            year,
            parseInt(month) - 1,
            day,
            validateRFCResult['ETA Time'].slice(0, 2),
            validateRFCResult['ETA Time'].slice(2, 4),
          );
        } else {
          this.RFCUpdatePopupETATimeValue = new Date(year, parseInt(month) - 1, day, 0, 0);
        }
      }
      if (validateRFCResult['Demurrage'] && typeof validateRFCResult['Demurrage'] === 'string') {
        const [date] = validateRFCResult['Demurrage'].split(' ');
        const [year, month, day] = date.split('-');

        this.RFCUpdatePopupDemurrageDateValue = new Date(year, parseInt(month) - 1, day);
      }

      this.RFCUpdatePopupRemarksText = '';
      this.showRFCUpdatePopup = true; // show popup
    },
    reverseRFCMenuButtonClicked: async function () {
      this.filtersIsOpen = false;
      if (!this.consignmentsTableBoxSelectedRow || this.consignmentsTableBoxSelectedRow.length === 0) {
        this.$showAlert('error', 'No Consignment Selected', 'Please select at least one consignment to Reverse RFC', [
          { text: 'OK' },
        ]);
        return;
      }

      this.$fullscreenLoading('Checking Reverse RFC Validity');
      const requestBody = {
        consignments: this.consignmentsTableBoxSelectedRow.map((cons) => cons['Consignment #']).join(','),
      };
      const validateRFCReversalResult = await this.$apiCallV2('/Consignment/ValidateRFCReversal', requestBody);
      this.$fullscreenLoading();

      const consignmentResults = validateRFCReversalResult.map((item) => {
        const resultArray = JSON.parse(item.Result); // Parse the Result string into an object
        return {
          ConsignmentNo: item.ConsignmentNo,
          Results: resultArray[0].Results,
          ErrMsg: resultArray[0].ErrMsg,
        };
      });

      const allowMessages = [];
      const unallowMessages = [];
      for (let i = 0; i < consignmentResults.length; i++) {
        if (consignmentResults[i]['Results'] === 1) {
          unallowMessages.push(consignmentResults[i]['ConsignmentNo'].trim());
        } else {
          allowMessages.push(consignmentResults[i]['ConsignmentNo'].trim());
        }
      }

      if (unallowMessages.length > 0) {
        await this.$showAlert(
          'error',
          'Reverse RFC not allowed',
          `Consignment No. <b>${unallowMessages.join(', ')}</b> is not in RFC mode.<br>Please check if it has been detailed.`,
          [{ text: 'OK' }],
        );

        if (allowMessages.length > 0) {
          const reverseRFCConfirmation = await this.$showAlert(
            'warning',
            'Confirm Reverse RFC',
            `Are you sure you want to reverse RFC for<br>consignment no. ${allowMessages.join(', ')}?`,
            [
              { text: 'Yes', color: 'red', textColor: 'white' },
              { text: 'No', color: 'grey', textColor: 'white' },
            ],
          );

          if (reverseRFCConfirmation === 'No') {
            return;
          }
        } else {
          return;
        }
      }

      if (unallowMessages.length == 0 && allowMessages.length > 0) {
        const reverseRFCConfirmation = await this.$showAlert(
          'warning',
          'Confirm Reverse RFC',
          `Are you sure you want to reverse RFC for<br>consignment no. ${allowMessages.join(', ')}?`,
          [
            { text: 'Yes', color: 'red', textColor: 'white' },
            { text: 'No', color: 'grey', textColor: 'white' },
          ],
        );

        if (reverseRFCConfirmation === 'No') {
          return;
        }
      }

      this.$fullscreenLoading('Reversing RFC');
      const reverseRFCResult = await this.$apiCallV2('/Consignment/ReverseRFC', {
        consignments: allowMessages.join(','),
      });
      this.$fullscreenLoading();

      const reverseResult = reverseRFCResult.map((item) => {
        const resultArray = JSON.parse(item.Result); // Parse the Result string into an object
        return {
          ConsignmentNo: item.ConsignmentNo,
          Results: resultArray[0].Results,
          ErrMsg: resultArray[0].ErrMsg,
        };
      });

      const displayedMessages = new Set();
      for (let i = 0; i < reverseResult.length; i++) {
        const result = reverseResult[i]['Results'];
        let message;

        switch (result) {
          case 0:
            message = `RFC for <b>${allowMessages.join(', ')}</b> has been successfully reversed`;
            if (!displayedMessages.has(message)) {
              this.$showAlert('success', 'RFC Reversed', message, [{ text: 'OK' }]);
              displayedMessages.add(message); // Mark this message as displayed

              if (
                this.showTripDetails && // if trip details is shown AND
                this.consignmentsTableBoxSelectedRow && // a tablebox row is selected
                this.consignmentsTableBoxSelectedRow.length > 0
              ) {
                this.$fullscreenLoading('Refreshing Trip Details');
                // this.tripDetailsData = await this.getTripDetails(
                //   this.consignmentsTableBoxSelectedRow[0]['Consignment #'],
                // ); // refresh trip details
                this.rightMenuDetails(this.consignmentsTableBoxSelectedRow[0]['Consignment #']); // refresh trip details
                this.$fullscreenLoading();
              }
            }
            break;

          case 1:
            message = reverseRFCResult[0]['ErrMsg'];
            if (!displayedMessages.has(message)) {
              this.$showAlert('error', 'RFC could not be reversed', message, [{ text: 'OK' }]);
              displayedMessages.add(message); // Mark this message as displayed
            }
            break;
        }
      }
      this.filtersRefreshClicked();
    },
    DestMenuButtonClicked: function (e) {
      this.clearField();
      this.filtersIsOpen = false;
      this.popupTitle = e.target.innerText;

      if (!this.consignmentsTableBoxSelectedRow || this.consignmentsTableBoxSelectedRow.length === 0) {
        this.$showAlert('error', 'No Consignment Selected', 'Please select at least one consignment', [{ text: 'OK' }]);
        return;
      }

      this.popupConsignmentList = this.consignmentsTableBoxSelectedRow.map((cons) => {
        return {
          ...cons,
          'Booking Ref No': cons['tag_bookingrefno'],
          'Discharge Port': cons['tag_dischargeport'],
          'Vessel ID': cons['tag_vesselno'],
          'Vessel Name': cons['tag_vesselname'],
          'Final Destination': cons['tag_finaldestination'],
          'ETA Date': cons['tag_etadate'],
          'ETA Time': cons['tag_timeeta'],
          'ETD Date': cons['tag_etddate'],
          'ETD Time': cons['tag_timeetd'],
          'Closing Date': cons['tag_closedate'],
          'Closing Time': cons['tag_closetime'],
          'Detention Date': cons['tag_detentiondate'],
          Remarks: '',
          // 'New SCN': '',
          // 'New Booking Ref No': '',
          // 'New Vessel ID': '',
          // 'New Vessel Name': '',
          // 'New Final Destination': '',
          // 'New ETA Date': null,
          // 'New ETA Time': null,
          // 'New ETD Date': null,
          // 'New ETD Time': null,
          // 'New Closing Date': null,
          // 'New Closing Time': null,
          // 'New Detention Date': null,
        };
      });

      if (this.popupConsignmentList.length > 0) this.showDestInfoPopup = true;
    },
    AddRemarksClicked: async function () {
      this.clearField();
      this.popupTitle = `Add Remarks`;
      this.filtersIsOpen = false;
      this.showStatusRemarksTableData = true;
      if (this.consignmentsTableBoxSelectedRow.length == 0) {
        await this.$showAlert('error', 'No Consignment Selected', 'Please select a consignment');
        return;
      } else if (this.consignmentsTableBoxSelectedRow.length > 1) {
        this.$showAlert('error', 'More than 1 record Selected', 'Please only select a consignment');
        return;
      }

      this.selectedConsignmentNo = this.consignmentsTableBoxSelectedRow[0]['Consignment #'];
      this.selectedJobNoValue = this.consignmentsTableBoxSelectedRow[0]['tag_jobno'];
      this.selectedJobDateTime =
        this.consignmentsTableBoxSelectedRow[0]['Job Date'] + ' ' + this.consignmentsTableBoxSelectedRow[0]['Job Time'];
      this.selectedShipper = this.shipperItems.find(
        (s) => s['Customer Code'].trim() == this.consignmentsTableBoxSelectedRow[0]['Shipper/Consignee'],
      );
      this.selectedJobRemarks = this.consignmentsTableBoxSelectedRow[0]['tag_jobremarks'];
      this.selectedDeliveryInstruction = this.consignmentsTableBoxSelectedRow[0]['tag_remarks'];
      this.selectedRemarksStatus =
        this.cnDetailsData?.Details?.StatusDetails?.map((item) => ({
          ...item,
          Status:
            item.Status === 'Delivery Remarks' ?
              '<div style="background-color: orange; padding: 5px; border-radius:5px; color: white; pointer-events: none; width: 170px">Delivery Remarks</div>'
            : '<div style="background-color: #1E90FF; padding: 5px; border-radius:5px; color: white; pointer-events: none; width: 170px">Collection Remarks</div>',
        })) ?? [];

      this.showAddRemark = true;
    },
    updateRemarksClicked: async function (_btn, data) {
      this.popupEntryErrorMessages = [];

      const action = _btn.trim();
      if (action === 'Delete') {
        const rowId = data['_rowid'];

        if (!this.newlyAddedRowIds) this.newlyAddedRowIds = new Set();

        if (this.newlyAddedRowIds.has(rowId)) {
          this.newlyAddedRowIds.delete(rowId);
        } else {
          if (!this.deletedOriginalRows) this.deletedOriginalRows = [];
          const deletedRow = this.selectedRemarksStatus.find((r) => r._rowid === rowId);
          if (deletedRow) this.deletedOriginalRows.push(deletedRow);
        }

        this.selectedRemarksStatus = this.selectedRemarksStatus.filter((r) => r._rowid !== rowId);

        this.showStatusRemarksTableData = false;
        await this.$nextTick();
        this.showStatusRemarksTableData = true;
        return;
      }

      const isDelivery = action === 'Delivery';
      const remarkText = isDelivery ? this.selectedDeliveryRemarks : this.selectedCollectionRemarks;

      if (!remarkText || !remarkText.trim()) {
        this.popupEntryErrorMessages.push(`Do not leave ${isDelivery ? 'delivery' : 'collection'} remark empty.`);
        return;
      }

      this.showStatusRemarksTableData = false;

      const lastId = Math.max(0, ...this.selectedRemarksStatus.map((d) => parseInt(d._rowid.replace('row', '')) || 0));

      const newRowId = `row${lastId + 1}`;

      if (!this.newlyAddedRowIds) this.newlyAddedRowIds = new Set();
      this.newlyAddedRowIds.add(newRowId);

      const statusLabel =
        isDelivery ?
          '<div style="background-color: orange; padding: 5px; border-radius:5px; color: white; pointer-events: none; width: 170px">Delivery Remarks</div>'
        : '<div style="background-color: #1E90FF; padding: 5px; border-radius:5px; color: white; pointer-events: none; width: 170px">Collection Remarks</div>';

      this.selectedRemarksStatus.push({
        ConsignmentNo: this.consignmentsTableBoxSelectedRow[0]['Consignment #'],
        Status: statusLabel,
        Remarks: remarkText,
        UserID: this.loginDetails['LoginUserId'],
        'Time Updated': new Date().formatString('yyyy-MM-dd HHmm'),
        _rowid: `row${lastId + 1}`,
      });

      await this.$nextTick();
      this.showStatusRemarksTableData = true;
    },
    updateJobAdditionalRemarksClicked: async function () {
      const toLowerKeys = (obj) =>
        Object.fromEntries(Object.entries(obj).map(([k, v]) => [k.toLowerCase().replace(' ', '_'), v]));

      const postBody = {
        consignmentnote: this.consignmentsTableBoxSelectedRow[0]['Consignment #'],
        jobno: this.consignmentsTableBoxSelectedRow[0]['tag_jobno'],
        containerno: this.consignmentsTableBoxSelectedRow[0]['Container #'],
        delinstruction:
          this.selectedDeliveryInstruction == this.consignmentsTableBoxSelectedRow[0]['tag_remarks'] ?
            ''
          : this.selectedDeliveryInstruction,
        remarks: [
          ...this.selectedRemarksStatus
            .filter((r) => this.newlyAddedRowIds.has(r._rowid))
            .map((r) => ({ ...toLowerKeys(r), action: 'N' })),

          ...this.deletedOriginalRows.map((r) => ({ ...toLowerKeys(r), action: 'D' })),
        ],
      };

      this.$fullscreenLoading('Updating Remarks');
      const result = await this.$apiCallV2('/Consignment/UpdateJobAdditionalRemarks', postBody);
      this.$fullscreenLoading();

      if (result[0]['Results'] === '1') {
        this.popupEntryErrorMessages.push(result[0]['ErrMsg']);
      } else {
        this.popupEntrySuccessMessages.push('Editted Successfully');
        this.saveClicked = true;
        this.popupTitle = `View Remarks`;
        this.filtersRefreshClicked();
      }

      this.showStatusRemarksTableData = false;
      this.$nextTick(() => (this.showStatusRemarksTableData = true));
    },
    queryRemarksClicked: async function (titleClicked) {
      this.clearField();
      this.showRemarkTitle = `Query ${titleClicked} Remarks`;
      this.popupRemarkTableTitle = `${titleClicked} List`;

      const isDelivery = titleClicked == 'Delivery';
      const masterfile = isDelivery ? 'SETTINGSREASONDELIVERY' : 'SETTINGSREASONCOLLECT';

      this.showRemarkPopup = true;
      await this.$sleep(500);
      this.popupRemarkLists = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile,
      });
    },
    remarkListPopupButtonClicked: async function (e) {
      if (e == 'Cancel') {
        this.showRemarkPopup = false;
      }

      await this.$sleep(500);
      if (this.popupRemarkTableTitle.includes('Delivery')) {
        this.selectedDeliveryRemarks = this.popupRemarksTableBoxSelectedRow[0]['Description'];
      } else {
        this.selectedCollectionRemarks = this.popupRemarksTableBoxSelectedRow[0]['Description'];
      }
      this.showRemarkPopup = false;
    },
    getQuickFindField: function (field) {
      return this.$apiCallV2(`/Consignment/QuickFindFilter?field=${field}`);
    },
    filtersSearchByDropdownSelected: function (selectedObject) {
      if (!selectedObject) {
        // if dropdown was cleared
        this.filtersSearchCriteriaDropdownIsDisabled = true;
        this.filtersSearchValueFieldIsDisabled = true;
        return;
      }

      this.filtersSearchValueFieldIsDisabled = false;
      this.filtersSearchValueControlType = selectedObject['ControlType'];
      if (selectedObject['ControlType'].toLowerCase().includes('date')) {
        // if selected searchBy has "date" in it
        this.filtersSearchCriteriaDropdownSelectedObject = // force criteria to be "EQUALS TO"
          this.filtersSearchCriteriaDropdownItems.find((item) => {
            return item['Criteria'].toLowerCase() === 'equals to';
          }) || null;
        this.filtersSearchCriteriaDropdownIsDisabled = true; // disallow selection of other criteria
      } else {
        this.filtersSearchCriteriaDropdownIsDisabled = false;
      }
    },
    filtersSearchInputKeyup: function (keyboardEvent) {
      if (keyboardEvent['key'] === 'Enter') {
        // if user pressed enter on the search input
        this.filtersRefreshClicked(); // call the refresh method
      }
    },
    filtersRefreshClicked: async function () {
      let error = false;

      if (
        !this.filtersSearchByDropdownSelectedObject ||
        Object.keys(this.filtersSearchByDropdownSelectedObject).length === 0
      ) {
        this.filtersSearchByDropdownErrorMessage = 'Search By is required';
        error = true;
      } else {
        switch (
          this.filtersSearchByDropdownSelectedObject['ControlType'] // might add other control types in the future
        ) {
          case 'Input':
            if (!this.filtersSearchInputValue) {
              this.filtersSearchInputErrorMessage = 'Search keyword is required';
              error = true;
            }
            break;

          case 'DateTimePicker':
            if (!this.filtersSearchDateTimePickerValue) {
              this.filtersSearchDateTimePickerErrorMessage = 'Search date is required';
              error = true;
            }
            break;
        }
      }

      if (
        !this.filtersSearchCriteriaDropdownSelectedObject ||
        Object.keys(this.filtersSearchCriteriaDropdownSelectedObject).length === 0
      ) {
        this.filtersSearchCriteriaDropdownErrorMessage = 'Search Criteria is required';
        error = true;
      }

      if (
        !this.filtersViewOptionsDropdownSelectedObject ||
        Object.keys(this.filtersViewOptionsDropdownSelectedObject).length === 0
      ) {
        this.filtersViewOptionsDropdownErrorMessage = 'View Option is required';
        error = true;
      }

      if (this.filtersMaxRowsInputValue && isNaN(parseInt(this.filtersMaxRowsInputValue))) {
        // if something was entered for max rows, but it's not a number
        this.filtersMaxRowsInputErrorMessage = 'Enter numbers only';
        error = true;
      }

      if (error) {
        return;
      }

      // format filters description
      this.filtersSummary = `Search by ${this.filtersSearchByDropdownSelectedObject['Search']} ${this.filtersSearchCriteriaDropdownSelectedObject['Criteria']} `;
      switch (
        this.filtersSearchByDropdownSelectedObject['ControlType'] // might add other control types in the future
      ) {
        case 'Input':
          this.filtersSummary += `${this.filtersSearchInputValue.trim()}, `;
          break;

        case 'DateTimePicker':
          this.filtersSummary += `${this.filtersSearchDateTimePickerValue.formatString('yyyy-MM-dd')}, `;
          break;
      }
      this.filtersSummary += `view ${this.filtersViewOptionsDropdownSelectedObject['ViewOption']} consignments`;
      if (this.filtersMaxRowsInputValue !== '0') {
        this.filtersSummary += `, max ${this.filtersMaxRowsInputValue} records`;
      }

      this.filtersIsOpen = false; // close button filter popup
      this.showTripDetails = false;
      this.consignmentsTableBoxTableData = [];
      this.consignmentsTableBoxSelectedRow = [];

      this.tableBoxColumnOrderViews = [];
      this.tableBoxColumnOrderID = null;
      this.refreshClicked = true;

      const requestBody = {
        searchby: this.filtersSearchByDropdownSelectedObject['Search'],
        criteria: this.filtersSearchCriteriaDropdownSelectedObject['Criteria'],
        viewoption: this.filtersViewOptionsDropdownSelectedObject['ViewOption'],
        top: this.filtersMaxRowsInputValue !== '0' ? this.filtersMaxRowsInputValue : '', // leave blank if 0 is entered
      };

      switch (
        this.filtersSearchByDropdownSelectedObject['ControlType'] // might add other control types in the future
      ) {
        case 'Input':
          requestBody['value'] = this.filtersSearchInputValue;
          break;

        case 'DateTimePicker':
          requestBody['value'] = this.filtersSearchDateTimePickerValue;
          break;
      }

      let response = await this.$apiCallV2('/Consignment/QuickFind', requestBody);
      response = response.map((consignment) => {
        if (consignment['Status'] === 'Canceled') {
          consignment['#'] =
            `<img src="https://dsmlib.logistics.systems/Icons/Cross.png" alt="Canceled" style="height: 20px; width: 20px;"> ${consignment['#']}`;
        } else if (consignment['tag_hold'] === 1) {
          consignment['#'] =
            `<img src="https://dsmlib.logistics.systems/Icons/Hold.png" alt="Hold" style="height: 20px; width: 20px;"> ${consignment['#']}`;
        } else {
          consignment['#'] = `<span style="margin-left: 20px;">${consignment['#']}</span>`;
        }

        if (consignment['B2B'] === 'Yes') {
          consignment['B2B'] =
            `<img src="https://dsmlib.logistics.systems/Icons/icons8-done-64.png" alt="Yes" style="height: 20px; width: 20px;"> Yes`;
        }

        return consignment;
      });

      this.refreshClicked = false;
      this.$nextTick(() => {
        this.lastRefreshedDateTime = new Date();
      });

      const columnOrderID = {
        formname: 'Haulage_Consignments',
        formctrlname: 'Consignments',
      };
      if (!this.columnOrderViewsByReportName['Consignments']) {
        this.columnOrderViewsByReportName['Consignments'] = await this.$apiCallV2(
          '/TableBox/GetColumnOrder',
          columnOrderID,
        );
      }
      this.tableBoxColumnOrderViews = this.columnOrderViewsByReportName['Consignments'];
      this.tableBoxColumnOrderID = columnOrderID;

      this.consignmentsTableBoxTableData = response;
    },
    consignmentsTableBoxRowSelected: function (selectedRow, selected) {
      if (!selected) {
        this.showTripDetails = false;
        return;
      }
      this.selectedCN = selectedRow;

      this.$fullscreenLoading('Getting Trip Details');
      // this.tripDetailsData = await this.getTripDetails(selectedRow['Consignment #']);
      // this.cnDetailsData = await this.getCNDetails(selectedRow['Consignment #']);
      this.rightMenuDetails(selectedRow['Consignment #']);
      this.$fullscreenLoading();
      this.showTripDetails = true;
      this.updateStatusTaskClicked = false;
      this.detailNonRevClicked = false;
    },
    rightMenuDetails: async function (consignmentNo) {
      this.cnDetailsFulfill = true;
      this.tripDetailsData = await this.$apiCallV2(
        `/Consignment/GetQuickFindMovementDetails?consignmentNo=${consignmentNo.trim()}`,
      );
      this.cnDetailsData = await this.$apiCallV2(`/Consignment/GetCNDetails?consignmentNo=${consignmentNo.trim()}`);
      this.cnDetailsFulfill = false;
    },
    RFCUpdatePopupButtonClicked: async function () {
      this.clearField();
      let error = false;

      this.popupConsignmentList.forEach((cons, i) => {
        if (!cons['RFC Mode']) {
          this.RFCDropdownErrMsgs[i] = 'RFC Mode is required!';
          error = true;
        } else {
          this.RFCDropdownErrMsgs[i] = '';
        }

        if (this.RFCUpdatePopupDocRefNoIsRequired(cons) && !cons['Doc Ref #']) {
          this.RFCDocRefNoInputErrMsgs[i] = 'Doc Ref # is required!';
          error = true;
        } else {
          this.RFCDocRefNoInputErrMsgs[i] = '';
        }

        if (!cons['Date Received']) {
          this.RFCDateReceivedErrMsgs[i] = 'Date Received is required!';
          error = true;
        }

        if (!cons['Date to Collect']) {
          this.RFCDateToCollectErrMsgs[i] = 'Date to Collect is required';
          error = true;
        }
      });

      if (error) {
        return; // don't do anything
      }

      if (this.RFCUpdatePopupDateToCollectValue < new Date()) {
        const collectionTimePassedResponse = await this.$showAlert(
          'warning',
          'Date to Collect Passed',
          'The Date to Collect entered has already passed.<br>Are you sure you wish to proceed?',
          [{ text: 'Proceed' }, { text: 'Cancel', color: 'lightgray' }],
        );

        if (collectionTimePassedResponse === 'Cancel') {
          return;
        }
      }

      this.showRFCUpdatePopup = false;
      const requestBody = {
        consignments: this.popupConsignmentList.map((cons) => ({
          datereceived: cons['Date Received'].formatString('yyyy-MM-dd HH:mm'),
          consignmentno: cons['Consignment #'],
          containerno: cons['Container #'],
          closingdatetime: cons['Closing Time'] ? cons['Closing Time'].formatString('yyyy-MM-dd HH:mm') : null,
          detentiondate: cons['Detention'] ? cons['Detention'].formatString('yyyy-MM-dd') : null,
          rfcmode: cons['RFC Mode']['RFC Mode'],
          docrefno: cons['Doc Ref #'],
          datetocollect: cons['Date to Collect'].formatString('yyyy-MM-dd HH:mm'),
          officehours: cons['Office Hours'] ? '1' : '0',
          remarks: cons['Remarks'] ? cons['Remarks'].trim() : null,
        })),
      };

      this.$fullscreenLoading('Updating RFC');
      const RFCUpdateResponse = await this.$apiCallV2('/Consignment/UpdateRFC', requestBody);
      this.$fullscreenLoading();

      const updateResults = RFCUpdateResponse.map((item) => {
        const resultArray = JSON.parse(item.Result); // Parse the Result string into an object
        return {
          ConsignmentNo: item.ConsignmentNo,
          Results: resultArray[0].Results,
          ErrMsg: resultArray[0].ErrMsg,
        };
      });

      const checkResult = [];
      for (const result of updateResults) {
        switch (result.Results) {
          case 0:
            if (!checkResult.includes(result.ConsignmentNo)) {
              checkResult.push(result.ConsignmentNo);
            }
            if (
              this.showTripDetails &&
              this.consignmentsTableBoxSelectedRow &&
              this.consignmentsTableBoxSelectedRow.length > 0
            ) {
              this.$fullscreenLoading('Refreshing Trip Details');
              // this.tripDetailsData = await this.getTripDetails(result.ConsignmentNo);
              this.rightMenuDetails(result.ConsignmentNo);
              this.$fullscreenLoading();
            }
            break;
          case 1:
            this.popupEntryErrorMessages.push(result.ErrMsg);
            break;
          case 2:
            if (!checkResult.includes(result.ConsignmentNo)) {
              checkResult.push(result.ConsignmentNo);
            }
            this.consignmentsAcknowledgement.push(
              this.populateObject(this.consignmentsTableBoxTableData, 'Consignment #', result.ConsignmentNo),
            );
            break;
        }
      }
      if (checkResult.length > 0) {
        this.popupEntrySuccessMessages.push('RFC successfully updated for Consignment No: ' + checkResult.join(', '));
      }
      this.showRFCAcknowledgementPopup = true;
    },
    RFCAcknowledgementPopupAddFromContactsClicked: function (emailInput) {
      this.RFCAcknowledgementContactsPopupSelectedEmailInput = emailInput;
      this.RFCAcknowledgementContactsPopupTableBoxSelectedRow = [];
      this.showRFCAcknowledgementContactsPopup = true;
    },
    RFCAcknowledgementPopupCCHeaderLabelClicked: function () {
      this.RFCAcknowledgementPopupCCIsExpanded = !this.RFCAcknowledgementPopupCCIsExpanded;
    },
    RFCAcknowledgementPopupBCCHeaderLabelClicked: function () {
      this.RFCAcknowledgementPopupBCCIsExpanded = !this.RFCAcknowledgementPopupBCCIsExpanded;
    },
    RFCAcknowledgementPopupButtonClicked: async function (consignmentNo) {
      if (!this.RFCAcknowledgementPopupToMails || this.RFCAcknowledgementPopupToMails.length === 0) {
        this.$showAlert('error', 'No E-Mails Entered', 'Enter at least one valid e-mail in the To section', [
          { text: 'OK' },
        ]);
        return;
      }

      if (
        this.RFCAcknowledgementPopupToMails.some((mail) => {
          return !mail['valid'];
        }) || // if there are invalid To emails OR
        this.RFCAcknowledgementPopupCCMails.some((mail) => {
          return !mail['valid'];
        }) || // if there are invalid CC emails OR
        this.RFCAcknowledgementPopupBCCMails.some((mail) => {
          return !mail['valid'];
        }) // if there are invalid BCC emails
      ) {
        this.$showAlert(
          'error',
          'Invalid E-mail',
          'Please edit or remove the invalid e-mails before sending RFC acknowledgement',
          [{ text: 'OK' }],
        );
        return;
      }

      // this.showRFCAcknowledgementPopup = false;
      this.$fullscreenLoading('Sending RFC Acknowledgement');

      const RFCAcknowledgementResult = await this.$apiCallV2('/Consignment/SendRFCAcknowledgement', {
        consignmentno: consignmentNo['Consignment #'].trim(),
        recipient: this.RFCAcknowledgementPopupToMails.map((mail) => {
          return mail['email'];
        }).join(';'),
        cc: this.RFCAcknowledgementPopupCCMails.map((mail) => {
          return mail['email'];
        }).join(';'),
        bcc: this.RFCAcknowledgementPopupBCCMails.map((mail) => {
          return mail['email'];
        }).join(';'),
      });

      this.$fullscreenLoading();

      if (RFCAcknowledgementResult[0]['RC'] === 0) {
        this.$showAlert('success', 'RFC Acknowledgement Sent', 'RFC Acknowledgement email has been successfully sent', [
          { text: 'OK' },
        ]);
        this.disabledAfterSuccess = true;
        const i = this.consignmentsAcknowledgement.findIndex(
          (cons) => cons['Consignment #'] === consignmentNo['Consignment #'],
        );
        if (i !== -1) {
          this.disabledConsignment[i] = true;
        }
      } else {
        this.$showAlert(
          'error',
          'RFC Acknowledgement Error',
          `RFC Acknowledgement email could not be sent<br>Error Code: ${RFCAcknowledgementResult[0]['RC']}`,
          [{ text: 'OK' }],
        );
      }
    },
    RFCAcknowledgementContactsPopupAddButtonClicked: function () {
      if (
        !this.RFCAcknowledgementContactsPopupTableBoxSelectedRow ||
        this.RFCAcknowledgementContactsPopupTableBoxSelectedRow.length === 0
      ) {
        this.showRFCAcknowledgementContactsPopup = false;
        return;
      }

      let emailsToAdd;

      switch (this.RFCAcknowledgementContactsPopupSelectedEmailInput) {
        case 'To':
          emailsToAdd = this.RFCAcknowledgementContactsPopupTableBoxSelectedRow.map((contact) => {
            return {
              email: contact['Email'],
              valid: true,
            };
          });
          this.RFCAcknowledgementPopupToMails = [...this.RFCAcknowledgementPopupToMails, ...emailsToAdd];
          break;

        case 'CC':
          emailsToAdd = this.RFCAcknowledgementContactsPopupTableBoxSelectedRow.map((contact) => {
            return {
              email: contact['Email'],
              valid: true,
            };
          });
          this.RFCAcknowledgementPopupCCMails = [...this.RFCAcknowledgementPopupCCMails, ...emailsToAdd];
          break;

        case 'BCC':
          emailsToAdd = this.RFCAcknowledgementContactsPopupTableBoxSelectedRow.map((contact) => {
            return {
              email: contact['Email'],
              valid: true,
            };
          });
          this.RFCAcknowledgementPopupBCCMails = [...this.RFCAcknowledgementPopupBCCMails, ...emailsToAdd];
          break;
      }
      this.showRFCAcknowledgementContactsPopup = false;
    },
    RFCAcknowledgementContactsPopupCancelButtonClicked: function () {
      this.showRFCAcknowledgementContactsPopup = false;
    },
    consignmentPrintJobNo: async function () {
      if (this.consignmentsTableBoxSelectedRow.length == 0) {
        await this.$showAlert('error', 'No Consignment Selected', 'Please select a consignment to print');
        return;
      }
      const selectedCNNos = this.consignmentsTableBoxSelectedRow.map((c) => c['Consignment #']);
      // const jobNo = this.consignmentsTableBoxSelectedRow[0]['tag_jobno'];
      const jobNo = this.consignmentsTableBoxSelectedRow.map((j) => j['tag_jobno']);
      const uniqueJobNos = [...new Set(jobNo)];
      await this.printCN(uniqueJobNos, selectedCNNos);
    },
    consignmentPrintDiversion: async function () {
      if (this.consignmentsTableBoxSelectedRow.length == 0) {
        await this.$showAlert('error', 'No Consignment Selected', 'Please select a consignment to print Diversion');
        return;
      }
      this.isDiversionForCN = true;
      this.selectedConsignmentNo = this.consignmentsTableBoxSelectedRow[0]['Consignment #'];
      this.EditCNClicked({ target: { innerText: 'Print Diversion' } });
    },
    printCN: async function (jobNo, cnNos) {
      const jobNos = Array.isArray(jobNo) ? jobNo : [jobNo];

      this.$fullscreenLoading('Getting Job Details');
      const allFormattedJobDetails = [];
      const unprintableJobReasons = [];

      for (const singleJobNo of jobNos) {
        this.$fullscreenLoading(`Getting Job Details for Job: ${singleJobNo}`);
        const jobDetails = (await this.$apiCallV2(`/Consignment/JobDetails?jobno=${singleJobNo}`))['JobDetails']['Job'];

        if (Array.isArray(cnNos) && cnNos.length > 0) {
          jobDetails.ConsignmentNote = jobDetails.ConsignmentNote.filter((c) => cnNos.includes(c.ConsignmentNo));
        }

        this.$fullscreenLoading('Validating Print Permission');
        const validatePrintRequestBody = {
          // // the rest of the body is populated in the controller
          consignments: jobDetails['ConsignmentNote'].map((consignmentNote) => ({
            cnno: consignmentNote['ConsignmentNo'],
          })),
        };
        const validatePrintResponse = await this.$apiCallV2('/Consignment/ValidatePrint', validatePrintRequestBody);
        this.$fullscreenLoading();

        const unprintableConsignments = validatePrintResponse['consignments'].filter(
          (consignment) => !consignment['allowprint'],
        );

        if (unprintableConsignments.length > 0) {
          unprintableJobReasons.push(...unprintableConsignments);

          if (unprintableConsignments.length === validatePrintResponse['consignments'].length) {
            continue;
          } else {
            const unprintableConsignmentNos = unprintableConsignments.map((c) => c.cnno);
            jobDetails.ConsignmentNote = jobDetails.ConsignmentNote.filter(
              (consignment) => !unprintableConsignmentNos.includes(consignment.ConsignmentNo),
            );
          }
        }

        this.$fullscreenLoading('Preparing to Print');
        await this.formatConsignmentNotePrintDetails(this.designerV2ReportFile[0], jobDetails); // will modify the jobDetails object via reference
        allFormattedJobDetails.push(jobDetails);
      }
      if (allFormattedJobDetails.length > 0) {
        this.designerV2ReportFile = new Array(allFormattedJobDetails.length).fill(this.designerV2ReportFile[0]);
        this.designerV2ReportData = allFormattedJobDetails;
        this.designerV2IsShown = true; // there is a watcher for this data field that sets the SignalR hub to start listening to an event
        this.$fullscreenLoading();
      }

      if (unprintableJobReasons.length > 0) {
        this.printPermissionPopupConsignmentReasons = unprintableJobReasons;
        this.showPrintPermissionPopup = true;
      }
    },
    printPermissionPopupButtonClicked: function (_buttonText) {
      this.showPrintPermissionPopup = false;
    },
    formatConsignmentNotePrintDetails: async function (designerReportFile, jobDetails) {
      // will modify the jobDetails object via reference
      switch (
        designerReportFile // different companies CN templates may require the data to be formatted differently
      ) {
        case 'CN_DSM.json':
        case 'CN_EJ.json': // formatting data for CN_EJ.json
        case 'CN_EHL.json': // formatting data for CN_EHL.json
        case 'CN_EHLTEST.json': //for testing only
        case 'CN_FMH.json': {
          // temporarily use EHL's format for FMH, for demonstration purposes
          const destinationDetailsCache = {};
          jobDetails['_vessel'] =
            jobDetails['Vessel No'] ?
              `${jobDetails['Vessel No'].trim()}  ${jobDetails['Vessel Name']?.trim?.()}`
            : jobDetails['Vessel Name']?.trim?.();

          for (const consignment of jobDetails['ConsignmentNote']) {
            // iterate through ConsignmentNote array inside jobDetails
            consignment['_Discharge Port'] = consignment['Discharge Port'];
            // if Discharge Port of ConsignmentNote is not null, then use that, else use Port of Discharge from jobDetails

            consignment['_Consignment No'] = `${consignment['ConsignmentNo']} /${jobDetails['ContDetail'].length}`;
            const qrDetail = `{"CNNO":"${consignment['ConsignmentNo']}"} `;
            consignment['QR'] = await this.$getQRURL(qrDetail, { size: 150, margin: 10 });
            // append total consignments to each consignmentNo

            if (!destinationDetailsCache[consignment['SendTo']]) {
              // if the destination details does not exist in the cache
              destinationDetailsCache[consignment['SendTo']] = (
                await this.$apiCallV2(
                  // call API to get details and store into cache
                  '/Master/GetListMaster',
                  {
                    masterfile: 'SENDTO_DETAILS',
                    // destinationcode: jobDetails["ConsignmentNote"][0]["SendTo"],
                    destinationcode: consignment['SendTo'],
                  },
                )
              )[0];
            }

            const destinationDetails = destinationDetailsCache[consignment['SendTo']];
            consignment['_destination Company'] = destinationDetails['Company']; // append required destination data
            consignment['_destination Addr1'] = destinationDetails['Addr1'];
            consignment['_destination Addr2'] = destinationDetails['Addr2'];
            consignment['_destination Addr3'] = destinationDetails['Addr3'];
            consignment['_destination Addr4'] = destinationDetails['Addr4'];
            consignment['_destination PostCode'] = destinationDetails['PostCode'];
            consignment['_destination City'] = destinationDetails['City'];
            consignment['_destination State'] = destinationDetails['State'];
            consignment['_destination Attn'] = destinationDetails['Attn'];
            consignment['_destination Phone'] =
              destinationDetails['Phone'] ?
                `${destinationDetails['Phone'].trim()}     ${destinationDetails['Phone2']?.trim?.()}`
              : destinationDetails['Phone2']?.trim?.();

            consignment['_requiredTime'] =
              consignment['RequiredTime'] ?
                new Date(consignment['RequiredTime']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
              : '';

            const parsedPrintCount = parseInt(consignment['PrintCount']);
            consignment['_printCount'] =
              isNaN(parsedPrintCount) || parsedPrintCount === 0 ? '' : `REPRINT *${parsedPrintCount}*`;
            // artifically increase print count by 1, and then display on the CN to be printed
            // when the user clicks print, call API to actually increase count by 1 on the database
          }

          if (jobDetails['Job Type'] === 'I') {
            // if an import job was selected
            jobDetails['_Shpr/Csgn Value'] = jobDetails['Consignee Name'];
            jobDetails['_BL No/Shpg Agt Ref Label'] = 'B/L No';
            jobDetails['_BL No/Shpg Agt Ref Value'] = jobDetails['BL No'];
            jobDetails['_ETA Value'] =
              jobDetails['POD ETA'] ?
                new Date(jobDetails['POD ETA']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
              : '';
          } else {
            // if an export job was selected
            jobDetails['_Shpr/Csgn Value'] = jobDetails['Shipper Name'];
            jobDetails['_BL No/Shpg Agt Ref Label'] = 'Shpg Agt Ref';
            jobDetails['_BL No/Shpg Agt Ref Value'] = jobDetails['Booking Ref No'];
            jobDetails['_ETA Value'] =
              jobDetails['POL ETA'] ?
                new Date(jobDetails['POL ETA']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
              : '';
          }

          jobDetails['_vessel Details'] =
            `${jobDetails['Vessel No'] ? jobDetails['Vessel No'] : ''} ${jobDetails['Vessel Name']}`;
          jobDetails['_printTime'] = new Date().formatString(`${this.$store.state['preferredDateFormat']} HH:mm`);
          jobDetails['UserID'] = this.loginDetails['LoginUserId'];
          break;
        }
        // add for other companies in the future once their consignment note templates have been created in Report Designer V2
      }
    },
    designerV2AfterPrint: async function () {
      // won't know if it successfully printed or the user cancelled it
      this.designerV2IsShown = false; // hide DesignerV2, watcher will stop the hub from listening to the ConsignmentNotePrinted event
      for (const reportData of this.designerV2ReportData) {
        //loop through all the report data
        const updatePrintCountRequestBody = {
          // the rest of the body is populated in the controller
          consignments: reportData['ConsignmentNote'].map((consignmentNote) => {
            return {
              jobno: consignmentNote['JobNo'],
              cnno: consignmentNote['ConsignmentNo'],
              cnremark: '', // leave as blank for now
              lastprintcount: parseInt(consignmentNote['PrintCount']) || 0,
            };
          }),
        };
        const updatePrintCountResponse = await this.$apiCallV2(
          '/Consignment/UpdatePrintCount',
          updatePrintCountRequestBody,
        );
        // call API to increase print count for all printed consignments

        if (updatePrintCountResponse !== '') {
          // something went wrong when trying to update print count
          let updatePrintCountErrorMessage = 'An error occured when trying to update print count';
          if (
            Array.isArray(updatePrintCountResponse) && // if API returned a error message
            updatePrintCountResponse[0] &&
            updatePrintCountResponse[0]['ErrMsg']
          ) {
            updatePrintCountErrorMessage = updatePrintCountResponse[0]['ErrMsg']; // use that instead
          }

          this.$showAlert('error', 'Failed to update print count', updatePrintCountErrorMessage, [{ text: 'OK' }]);
        }

        await this.$apiCallV2(
          // call endpoint defined in HaulageJobPageHubController.cs
          `/HaulageJobPageHub/ConsignmentNotePrinted` + // this will emit a SignalR event named "ConsignmentNotePrinted"
            `?coRefname=${this.loginDetails['CoRefname']}` + // which will be listened to by other users that also have the print CN preview open
            `&coCode=${this.loginDetails['CoCode']}` + // if the event was sent by another user in the same company,
            `&jobNo=${this.designerV2ReportData['Job No']}`, // that user will then be forced to get the latest print count and reload the print CN preview
        );
      }
    },
    popupEntryRequiredClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    RFCUpdatePopupDocRefNoIsRequired: function (cons) {
      return cons['RFC Mode']?.['Doc Ref # Required'] === 1;
    },
    populateData: function (data) {
      this.oldConsignmentNo = data[0]['Consignment #'];
      this.oldContainerNo = data[0]['Container #'];
      this.oldSealNo = data[0]['tag_sealno'];
    },
    consignmentsAcknowledgementButtonClicked: function (consignmentNo) {
      this.consignmentButtonSelected = consignmentNo;
      this.RFCAcknowledgementPopupToMails = [];
      this.RFCAcknowledgementPopupCCMails = [];
      this.RFCAcknowledgementPopupBCCMails = [];
      this.RFCAcknowledgementPopupCCIsExpanded = false;
      this.RFCAcknowledgementPopupBCCIsExpanded = false;
      this.disabledAfterSuccess = false;
    },
    populateObject: function (data, key, compare) {
      // To populate object into dropdown or input query
      try {
        return data.find((d) => (d[key]?.trim?.() ?? d[key]) == (compare?.trim?.() ?? compare));
      } catch (error) {
        return null;
      }
    },
    listMerge: async function (requestBody) {
      const recDetails = await this.$apiCallV2('/Consignment/ValidateRecDoc', requestBody);
      const tempList = recDetails.map((cons) => {
        const baseObject = {
          'Consignment No': cons['Consignment No'],
          'Doc Receive Date': cons['Document Details']['ActFinishDate'],
          'Doc Receive Time': cons['Document Details']['ActFinishTime'],
          'Updated By': `${cons['Document Details']['UserID'] ?? ''} ${this.formatDateTime(cons['Document Details']['DateUpdated'], cons['Document Details']['TimeUpdated'])?.formatString('dd/MM/yyyy HH:mm') || ''}`,
          docExist: Boolean(cons['Document Details']),
          SeqNo: cons['Document Details']['SeqNo'] ?? '',
          [this.DocTitle]: cons['Document Details']['DocNo'] ?? '',
        };

        // Conditionally add 'Document Type' if this.DocTitle is "Cheque/ Receipt #"
        if (this.DocTitle === 'Cheque/ Receipt #') {
          baseObject['Document Type'] = cons['Document Details']['Doc'] ?? '';
        }
        return baseObject;
      });

      const tempListMap = new Map(tempList.map((item) => [item['Consignment No'], item]));
      this.popupConsignmentList = this.popupConsignmentList.map((popupItem) => {
        const tempItem = tempListMap.get(popupItem['Consignment #']);

        // merge the data if matching consignment no found in tempList
        if (tempItem) {
          return {
            ...popupItem,
            ...tempItem,
          };
        }

        // return the original popupItem if no match
        return popupItem;
      });
    },
    checkDate: function (field, date) {
      let error = false;
      let errMsg = '';
      this.RequiredDateErrMsg = '';
      this.PlanDateErrMsg = '';
      this.ReceiveDateErrMsg = '';
      this.updateTRDateErrMsg = '';
      if (date != null && date != '') {
        if (date > this.smallDateTimeMaxDate) {
          errMsg = `Please select ${field} earlier than ${this.smallDateTimeMaxDate.formatString('yyyy-MM-dd')}`;
        } else if (date < this.smallDateTimeMinValue) {
          errMsg = `Please select ${field} later than ${this.smallDateTimeMinValue.formatString('yyyy-MM-dd')}`; // Fixed typo
        }
      } else {
        errMsg = `${field} is required`;
      }

      switch (field) {
        case 'New Required Date':
          this.RequiredDateErrMsg = errMsg;
          error = Boolean(errMsg);
          break;
        case 'Plan Date':
          this.PlanDateErrMsg = errMsg;
          error = Boolean(errMsg);
          break;
        case 'Receive Date Time':
          this.ReceiveDateErrMsg = errMsg;
          error = Boolean(errMsg);
          break;
        case 'Date/ Time':
          this.updateTRDateErrMsg = errMsg;
          error = Boolean(errMsg);
          break;
      }
      return error;
    },
    formatDateTime: function (date, time) {
      if (date && time) {
        return new Date(`${date}T${time.slice(0, 2)}:${time.slice(2)}`);
      }
      return null;
    },
    //Open and direct to new tab to show the status task for the specific consignment
    additionalBtnClicked: function (_btn, data) {
      if (_btn.includes('task-planning')){
        const additionalBtnURL = `/Home/${this.$route.params.user}/Status?jobno=${data.tag_jobno}`;
        const resolvedadditionalBtnRoute = this.$router.resolve(additionalBtnURL);
        window.open(resolvedadditionalBtnRoute.href, '_blank'); // open in a new tab
      } else {
        const viewJobChargesURL = `/Home/${this.$route.params.user}/FINAR/Job%20Charges?jobNo=${data.tag_jobno}`;
        const resolvedViewJobChargesRoute = this.$router.resolve(viewJobChargesURL);
        window.open(resolvedViewJobChargesRoute.href, '_blank');
      }
    },
    updateTRBtnClicked: async function (_btn, data) {
      if (_btn.toUpperCase() === 'DELETE') {
        const radioCallHistDelete = await this.$showAlert(
          'warning',
          'Confirm Delete Radio-Call History',
          `Are you sure you want to delete radio-call history <br>consignment no. ${data['CN #']}?`,
          [
            { text: 'Yes', color: 'red', textColor: 'white' },
            { text: 'No', color: 'grey', textColor: 'white' },
          ],
        );

        if (radioCallHistDelete === 'No') {
          return;
        }

        const requestBody = {
          action: 'D',
          cn: data['CN #'],
          mvttype: data['Mvt'],
          seqno: data['tag_seqno'],
        };

        this.$fullscreenLoading(`Updating Trailer`);
        const result = await this.$apiCallV2('/Consignment/UpdateTrailer', requestBody);
        this.$fullscreenLoading();

        if (result[0]['Results'] === '1') {
          this.popupEntryErrorMessages.push(result[0]['ErrMsg']);
        } else {
          this.popupEntrySuccessMessages.push(result[0]['ErrMsg']);
          this.saveClicked = true;
          this.GetTrailerSelected();
        }
      } else {
        const workTicketBtnURL = `/Home/${this.$route.params.user}/Haulage/Movement%20Update?field=Work%20Ticket%20%23&workTicket=${data['Working Ticket #']}`;
        const resolvedWorkTicketBtnRoute = this.$router.resolve(workTicketBtnURL);
        window.open(resolvedWorkTicketBtnRoute.href, '_blank');
      }
    },
    radioCallButtonClicked: async function (_btn) {
      this.selectedUpdateStatusCN = await this.$apiCallV2(
        `/Consignment/UpdateStatusCheck?cn=${this.selectedCN['Consignment #']}`,
      );
      if (this.selectedUpdateStatusCN.length == 0) {
        this.radioCallResultMessage = 'No outstanding status to update';
        return;
      }
      this.radioCallResultMessage = '';
      this.showTripDetails = false;
      this.updateStatusTaskClicked = true;
    },
    radioCallDiscardAttachments: async function () {
      if (this.radioCallAttachmentsChanged) {
        // if there are newly uploaded attachments
        const response = await this.$showAlert(
          // prompt user to find out if they want to discard or not
          'warning',
          'Unsaved Attachments',
          'You have unsaved attachments.<br>Are you sure you want to discard them?',
          [{ text: 'Discard' }, { text: 'Cancel', color: 'lightgray' }],
        );

        return response == 'Discard';
      }

      return true; // there are no newly uploaded attachments
    },
    rightMenuBackClicked: async function () {
      if (!(await this.radioCallDiscardAttachments())) {
        // if user does not want to discard newly uploaded attachments, don't go back to the trip list screen
        return;
      }

      this.updateStatusTaskClicked = false;
      this.detailNonRevClicked = false;
      this.showTripDetails = true;
      this.radioCallResultMessage = '';
      this.radioCallUpdateSuccess = null;
    },
    radioCallStatusUpdated: function (e, data, title, hasSaved) {
      // scenario : 1 failed, 1 succeed will still counted as success
      this.radioCallUpdateSuccess = hasSaved;
      if (hasSaved) {
        this.radioCallResultMessage = `Successfully updated [${title}] status`;
      } else {
        this.radioCallResultMessage = data[0]['ErrMsg'] || data[1]['ErrMsg'];
      }
    },
    radioCallStatusReversed: function (results) {
      // results variable contains responses from API
      const success = [];
      let failure = '';
      for (const r of results) {
        if (r['Response']['Results'] === 0) {
          // reversed successfully
          success.push(r['Reversed Status']);
        } else {
          // reversed unsuccessfully (at most there will only be one, because it stops reversing after the first failure, and it should always be the first element in Results)
          failure = r['Reversed Status'];
        }
      }

      if (failure === '') {
        // no failures
        this.radioCallUpdateSuccess = true;
        this.radioCallResultMessage = `Successfully reversed ${success.join(', ')}`;
      } else {
        // 1 failure (at most only one, because it stops reversing after the first failure)
        this.radioCallUpdateSuccess = false;
        if (success.length == 0) {
          // no successes
          this.radioCallResultMessage = `Failed to reverse ${failure}`;
        } else {
          this.radioCallResultMessage =
            `Failed to reverse some statuses<br/>Success: ${success.join(', ')}<br/>Failure: ${failure}`;
        }
      }
    },
    detailNonRevButtonClicked: function () {
      this.showTripDetails = false;
      this.detailNonRevClicked = true;
      this.nonRevCN = {
        'Consignment #': this.cnDetailsData['Details']['ConsignmentNo'],
        'Container #': this.cnDetailsData['Details']['ContainerNo'],
        Dropoff: this.cnDetailsData['Details']['DropOff'],
        'Sz/Ty': this.cnDetailsData['Details']['ContSizeType'],
        Hdg: this.cnDetailsData['Details']['HandlingType'],
      };
    },
    diversionButtonClicked: async function (e) {
      switch (e) {
        case 'Cancel':
          this.showCreateDiversion = false;
          this.clearField();
          break;
        case 'Update':
          if (this['selectedDiversionLoc' + (this.diversionDetails.length + 1)]) {
            this.$fullscreenLoading('Updating Diversion . . . ');
            const viewJobData = this.$jsonNullToString(
              this.$deepTrimJsonV3(
                (
                  await this.$apiCallV2(
                    `/HaulageJob/JobDetails?jobno=${this.consignmentsTableBoxSelectedRow[0]['tag_jobno']}`,
                  )
                )['JobDetails']['Job'],
              ),
            );
            const cnList = viewJobData['ConsignmentNote'];
            this.selectedSendTo =
              cnList[0]['SendTo'] ?
                this.sendToItems.find((s) => s['Destination Code'].trim() == cnList[0]['SendTo'].trim())
              : null; // = null;
            const dataToPost = {
              action: 'N',
              jobno: this.consignmentsTableBoxSelectedRow[0]['tag_jobno'],
              cnno: this.consignmentsTableBoxSelectedRow[0]['Consignment #'],
              requestno: viewJobData['Request No'],
              oridest: this.selectedSendTo['Destination Code'] ? this.selectedSendTo['Destination Code'] : '',
              oridestarea: this.selectedSendTo['Tariff Area'] ? this.selectedSendTo['Tariff Area'] : '',
              diverdest: this['selectedDiversionLoc' + (this.diversionDetails.length + 1)]['Destination Code'],
              diverarea:
                this['selectedDiversionLoc' + (this.diversionDetails.length + 1)]['Area Code'] ?
                  this['selectedDiversionLoc' + (this.diversionDetails.length + 1)]['Area Code']
                : '',
              internal: this['internalDiversionLoc' + (this.diversionDetails.length + 1)] ? '1' : '0',
              remarks:
                this['remarksDiversionLoc' + (this.diversionDetails.length + 1)] ?
                  this['remarksDiversionLoc' + (this.diversionDetails.length + 1)]
                : '',
              system: '',
              deletereason: '',
              seqno: this.diversionDetails.length + 1,
            };
            const saveDiversion = await this.$apiCallV2('/HaulageJob/SaveHMSDiversion', dataToPost);
            this.$fullscreenLoading();

            if (saveDiversion[0]['Results'] == 0) {
              // this.refreshClicked();

              await this.$showAlert(
                'success',
                'Diversion Updated',
                `Diversion for Consignment # ${this.consignmentsTableBoxSelectedRow[0]['Consignment #']} has been successfully updated.`,
              );
              // this.selectedJob = [];
            } else {
              await this.$showAlert(
                'error',
                'Update Failed',
                `Consignment # ${this.consignmentsTableBoxSelectedRow[0]['Consignment #']} is not updated. <br>Error: ${saveDiversion[0]['ErrMsg']}`,
              );
            }
            this.$nextTick(() => {
              this.showCreateDiversion = false;
              this.EditCNClicked({ target: { innerText: 'View/Create Diversion' } });
            });
          } else {
            await this.$showAlert(
              'error',
              'No Diversion Details Specified',
              'Please specify a diversion destination that you want to update.',
            );
          }

          break;
      }
    },
    getJobDetailsForDiversion: async function () {
      let jobDetail = null;
      this.cndiversionList = [];
      this.jobDetailForDiversion = null;
      this.$fullscreenLoading('Getting Consignment Details . . .');
      jobDetail = (
        await this.$apiCallV2(
          `/HaulageJob/JobDetails?cnno=${this.consignmentsTableBoxSelectedRow[0]['Consignment #']}&diverpickupori=${this.diverpickupori}&diverinternal=${this.diverinternal}&diverseqno=${this.diverseqno}`,
        )
      )['JobDetails']['Job'];
      this.$fullscreenLoading();
      if (jobDetail['ConsignmentNote'][0]['CNDiversion'] == undefined) {
        this.$showAlert(
          'info',
          'Record Check',
          `No diversion for selected CDA ${this.consignmentsTableBoxSelectedRow[0]['Consignment #']}`,
        );
        return;
      }
      this.cndiversionList = jobDetail['ConsignmentNote'][0]['CNDiversion'];
      const qrDetail = `{"CNNO" : "${jobDetail['ConsignmentNote'][0]['CNDiversion']['ConsignmentNo']}"} `;
      jobDetail['ConsignmentNote'][0]['QR'] = await this.$getQRURL(qrDetail, { size: 150, margin: 10 });
      this.jobDetailForDiversion = jobDetail;
    },
    printButtonClicked: async function (diverinternal, cnno, diverseqno) {
      if (diverseqno > this.diversionDetails.length) {
        this.$showAlert('error', 'No data', 'Please add diversion location to print');
        return;
      }
      const temp = parseInt(diverseqno) - 1;
      this.printDiversionTitle = `Print Diversion for ${this.diversionDetails[`${temp}`]['Consignment No']}`;
      // this.diverpickupori = this.useOriDest ? '1' : '0';
      this.diverinternal = diverinternal;
      this.diverseqno = diverseqno;
      this.cnno = cnno;
      await this.getJobDetailsForDiversion();
      this.printDiversionTitleOri =
        this.diverseqno == '1' ?
          this.jobDetailForDiversion['ConsignmentNote'][0]['SendTo']
        : this[`selectedDiversionLoc1`]['Destination Code'];
      this.printDiversionTitleDivert = this.diversionDetails[`${temp}`]['Diversion Dest'];
      this.showIndividualPrintDiversion = true;
      this.showPrintDiversion = true;
    },
    deleteButtonClicked: function (sequence) {
      this.deleteDivError = '';
      this.sequence = sequence;
      this.showDeleteDivPopup = true;
    },
    deleteDivButtonClicked: async function (e) {
      switch (e) {
        case 'Delete':
          if (!this.deleteDivRemarks) {
            this.deleteDivError = 'Please enter your reason to delete!';
          } else {
            this.$fullscreenLoading('Deleting Diversion . . . ');
            const dataToPost = {
              action: 'D',
              jobno: this.consignmentsTableBoxSelectedRow[0]['tag_jobno'],
              cnno: this.isDiversionForCN && this.popupShow ? this.selectedConsignments[0]['Consignment No'] : '',
              system: 'HMS',
              deletereason: this.deleteDivRemarks,
              seqno: this.sequence,
            };
            const deleteDiversion = await this.$apiCallV2('/HaulageJob/SaveHMSDiversion', dataToPost);
            this.showDeleteDivPopup = false;
            this.$fullscreenLoading();
            if (deleteDiversion[0]['Results'] == 0) {
              await this.$showAlert(
                'success',
                'Diversion Deleted',
                `Diversion for Consignment # ${this.consignmentsTableBoxSelectedRow[0]['Consignment #']} has been successfully deleted.`,
              );
              this.deleteDivRemarks = '';
              this.clearField();
            } else {
              await this.$showAlert(
                'error',
                'Diversion is Not Deleted',
                `Consignment # ${this.consignmentsTableBoxSelectedRow[0]['Consignment #']} is not deleted.<br>Error: ${deleteDiversion[0]['ErrMsg']}`,
              );
            }
            this.showCreateDiversion = false;
            this.$nextTick(() => {
              this.EditCNClicked({ target: { innerText: 'View/Create Diversion' } });
              if (this.diversionDetails.length < 4) {
                this.diversionButtons = [{ text: 'Update' }, { text: 'Cancel', color: 'indianred' }];
              }
            });
          }
          break;
        case 'Cancel':
          this.showDeleteDivPopup = false;
      }
    },
    printDiversionPopupClicked: function (e) {
      switch (e) {
        case 'Cancel':
          this.showPrintDiversion = false;
          break;
        case 'Print':
          this.showPrintDiversion = false;
          this.showCreateDiversion = false;
          this.printDiversion();
      }
    },
    printDiversion: async function () {
      this.isDivert = true;
      this.showPrintDiversion = false;
      this.showCreateDiversion = false;
      if (this.consignmentsTableBoxSelectedRow.length == 0) {
        await this.$showAlert('error', 'No Job Selected', 'Please select a job to print');
      } else if (this.consignmentsTableBoxSelectedRow.length > 1) {
        this.$showAlert('error', 'More than 1 record Selected', 'Please select a record to print');
      } else {
        if (this.jobDetailForDiversion == null || this.jobDetailForDiversion.length == 0)
          // await this.getJobDetailsForDiversion(this.selectedConsignmentNo.trim() != '');
          await this.getJobDetailsForDiversion();
        if (
          this.jobDetailForDiversion == null ||
          this.jobDetailForDiversion['ConsignmentNote'][0]['CNDiversion'] == undefined
        ) {
          this.$showAlert(
            'info',
            'Record Check',
            `No diversion for selected CDA ${this.consignmentsTableBoxSelectedRow[0]['tag_jobno']}`,
          );
          return;
        }

        if (
          this.isDiversionForCN &&
          this.popupShow &&
          this.jobDetailForDiversion['ConsignmentNote'][0]['CNDiversion']['ConsignmentNo'] != this.selectedConsignmentNo
        ) {
          this.$showAlert('info', 'Record Check', `No diversion for selected CDA ${this.selectedConsignmentNo}`);
          return;
        }

        this.$fullscreenLoading('Validating Print Permission');
        const validatePrintBody = {
          // // the rest of the body is populated in the controller
          consignments: this.jobDetailForDiversion['ConsignmentNote'].map((consignmentNote) => {
            return {
              cnno: consignmentNote['ConsignmentNo'],
            };
          }),
        };

        const validatePrintRes = await this.$apiCallV2('/HaulageJob/ValidatePrint', validatePrintBody);
        this.printPermissionPopupConsignmentReasons = validatePrintRes['consignments'].filter((consignment) => {
          return !consignment['allowprint'];
        });

        if (this.printPermissionPopupConsignmentReasons.length > 0) {
          // if there is at least one consignment that can't be printed
          this.showPrintPermissionPopup = true; // show PopupV2
          this.$fullscreenLoading();
          return; // exit function
        }

        this.$fullscreenLoading('Preparing to Print');
        await this.formatDiversionNotePrintDetails(this.designerV2ReportFileDiversion[0], this.jobDetailForDiversion); // will modify the jobDetails object via reference
        this.designerV2ReportData = this.jobDetailForDiversion;
        this.designerV2IsShown = true; // there is a watcher for this data field that sets the SignalR hub to start listening to an event
        this.$fullscreenLoading();
        this.diverpickupori = '0';
        this.diverinternal = '';
        this.diverseqno = '';
        this.cnno = '';
        this.useOriDest = false;
      }
    },
    formatDiversionNotePrintDetails: function (designerReportFile, jobDetails) {
      // will modify the jobDetails object via reference
      switch (
        designerReportFile // different companies CN templates may require the data to be formatted differently
      ) {
        case 'CNDiversion_DSM.json':
        case 'CNDiversion_EHLTEST.json':
        case 'CNDiversion_EJ.json': // formatting data for CNDiversion_EJ.json
        case 'CNDiversion_EHL.json': // formatting data for CNDiversion_EHL.json
        case 'CNDiversion_FMH.json': // temporarily use EHL's format for FMH, for demonstration purposes
          jobDetails['_vessel'] =
            jobDetails['Vessel No'] ?
              `${jobDetails['Vessel No'].trim()}  ${jobDetails['Vessel Name']?.trim?.()}`
            : jobDetails['Vessel Name']?.trim?.();

          for (const consignment of jobDetails['ConsignmentNote']) {
            // iterate through ConsignmentNote array inside jobDetails
            consignment['_Discharge Port'] = consignment['Discharge Port'];
            // if Discharge Port of ConsignmentNote is not null, then use that, else use Port of Discharge from jobDetails

            consignment['_Consignment No'] = `${consignment['ConsignmentNo']} /${jobDetails['ConsignmentNote'].length}`;
            consignment['_divert Pickup'] = this.cndiversionList['DiverPickup'];
            consignment['_divert Info'] = this.cndiversionList['DiversionInfo'];
            consignment['_destination Company'] = this.cndiversionList['DestCompany']; // append required destination data
            consignment['_destination Addr1'] = this.cndiversionList['DestAddr1'];
            consignment['_destination Addr2'] = this.cndiversionList['DestAddr2'];
            consignment['_destination Addr3'] = this.cndiversionList['DestAddr3'];
            consignment['_destination Addr4'] = this.cndiversionList['DestAddr4'];
            consignment['_destination PostCode'] = this.cndiversionList['DestPostCod'];
            consignment['_destination City'] = this.cndiversionList['DestCity'];
            consignment['_destination State'] = this.cndiversionList['DestState'];
            consignment['_destination Attn'] = this.cndiversionList['DestAttn'];
            consignment['_destination Phone'] =
              this.cndiversionList['DestPhone'] ?
                `${this.cndiversionList['DestPhone'].trim()}     ${this.cndiversionList['DestPhone2']?.trim?.()}`
              : this.cndiversionList['DestPhone2']?.trim?.();

            consignment['_requiredTime'] =
              consignment['RequiredTime'] ?
                new Date(consignment['RequiredTime']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
              : '';

            const parsedPrintCount = parseInt(consignment['PrintCount']);
            consignment['_printCount'] =
              isNaN(parsedPrintCount) || parsedPrintCount === 0 ? '' : `REPRINT *${parsedPrintCount}*`;
            // artifically increase print count by 1, and then display on the CN to be printed
            // when the user clicks print, call API to actually increase count by 1 on the database
          }

          if (jobDetails['Job Type'] === 'I') {
            // if an import job was selected
            jobDetails['_Shpr/Csgn Value'] = jobDetails['Consignee Name'];
            jobDetails['_BL No/Shpg Agt Ref Label'] = 'B/L No';
            jobDetails['_BL No/Shpg Agt Ref Value'] = jobDetails['BL No'];
            jobDetails['_ETA Value'] =
              jobDetails['POD ETA'] ?
                new Date(jobDetails['POD ETA']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
              : '';
          } else {
            // if an export job was selected
            jobDetails['_Shpr/Csgn Value'] = jobDetails['Shipper Name'];
            jobDetails['_BL No/Shpg Agt Ref Label'] = 'Shpg Agt Ref';
            jobDetails['_BL No/Shpg Agt Ref Value'] = jobDetails['Booking Ref No'];
            jobDetails['_ETA Value'] =
              jobDetails['POL ETA'] ?
                new Date(jobDetails['POL ETA']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
              : '';
          }
          jobDetails['_vessel Details'] =
            `${jobDetails['Vessel No'] ? jobDetails['Vessel No'] : ''} ${jobDetails['Vessel Name']}`;
          jobDetails['_printTime'] = new Date().formatString(`${this.$store.state['preferredDateFormat']} HH:mm`);
          jobDetails['UserID'] = this.loginDetails['LoginUserId'];
          break;

        // add for other companies in the future once their consignment note templates have been created in Report Designer V2
      }
    },
    consignmentPrintDetails: function (_pointerEvent) {
      if (!this.consignmentsTableBoxSelectedRow || this.consignmentsTableBoxSelectedRow.length === 0) {
        this.$showAlert('error', 'No Consignment Selected', 'Please select at least one consignment to preview', [
          { text: 'OK' },
        ]);
        return;
      }

      this.designerV3ReportFiles = ['CNDetails.json'];
      const cnDetailsData = this.cnDetailsData['Details'];
      const formatdate = (d, f) => (d && d !== '-' ? new Date(d).formatString(f) : '-');
      const reportData = {
        coName: this.loginDetails['CoName'],
        consignmentNo: cnDetailsData['ConsignmentNo'],
        printDateTime: new Date().formatString('yyyy-MM-dd HH:mm:ss'),

        containerNo: cnDetailsData['ContainerNo'],
        requestNo: cnDetailsData['RequestNo'],
        totalCont: cnDetailsData['TotalCount'],
        sealNo: cnDetailsData['SealNo'],
        sizeType: cnDetailsData['ContSizeType'],
        jobDate: formatdate(cnDetailsData['RequestDate'], 'yyyy-MM-dd HH:mm'),
        billTo: cnDetailsData['BillTo'],
        billToName: cnDetailsData['BillToName'],
        customerLabel: cnDetailsData['JobTypeHeader'] === 'E' ? 'Shipper' : 'Consignee',
        cu_number: cnDetailsData['ShprCsgnCode'],
        cu_name: cnDetailsData['ShprCsgnName'],
        jobType: cnDetailsData['JobType'],
        pickUp: cnDetailsData['PickUp'],
        pickUpName: cnDetailsData['PickUpName'],
        dropOff: cnDetailsData['DropOff'],
        dropOffName: cnDetailsData['DropOffName'],

        destinationCode: cnDetailsData['SendToCode'],
        destinationName: cnDetailsData['SendToCompany'],
        addr1: cnDetailsData['SendToAddr1'],
        addr2: cnDetailsData['SendToAddr2'],
        addr3: cnDetailsData['SendToAddr3'],
        addr4: cnDetailsData['SendToAddr4'],
        phone: cnDetailsData['Phone1'],
        phone2: cnDetailsData['Phone2'],
        fax: cnDetailsData['Fax1'],
        fax2: cnDetailsData['Fax2'],
        attn: cnDetailsData['ContactPerson'] ?? cnDetailsData['ContactEmail'],
        CHAMAreaCode: cnDetailsData['SendToArea'],
        offload:
          cnDetailsData['OffLoad'] == 1 ? 'YES'
          : cnDetailsData['OffLoad'] == 0 ? 'NO'
          : '',
        trip: cnDetailsData['Trip'],

        VoyNo: cnDetailsData['VoyNo'],
        Ship_ID: cnDetailsData['SCN'],
        Vessel_No: cnDetailsData['VesselNo'],
        Vessel_Name: cnDetailsData['VesselName'],
        ShipLine: cnDetailsData['ShipLine'],
        Ag_Name: cnDetailsData['Ag_Name'],
        Frt_Name: cnDetailsData['Frt_Name'],
        ETA_Date: formatdate(cnDetailsData['ETADate'], 'yyyy-MM-dd'),
        ETA_Time: formatdate(cnDetailsData['ETADate'], 'HH:mm'),
        POT: cnDetailsData['POT'],
        TranshipPort: cnDetailsData['TranshipPort'],
        POD: cnDetailsData['POD'],
        DischargePort: cnDetailsData['DischargePort'],
        BookingRefNo: cnDetailsData['BookingRefNo'],
        ETD_Date: formatdate(cnDetailsData['ETDDate'], 'yyyy-MM-dd'),
        ETD_Time: formatdate(cnDetailsData['ETDDate'], 'HH:mm'),
        FinalDestination: cnDetailsData['Final_Destination'],
        LeftLabel: cnDetailsData['JobTypeHeader'] === 'E' ? 'Closing Date/ Time' : 'Demurrage Date',
        LeftValue: cnDetailsData['JobTypeHeader'] === 'E' ? formatdate(cnDetailsData['CloseDate'], 'yyyy-MM-dd HH:mm') : formatdate(cnDetailsData['DateDemurrage'], 'yyyy-MM-dd'),
        RightLabel: cnDetailsData['JobTypeHeader'] === 'E' ? '' : 'Detention Date',
        RightValue: cnDetailsData['JobTypeHeader'] === 'E' ? '' : formatdate(cnDetailsData['DateDetention'], 'yyyy-MM-dd'),
        remarks: cnDetailsData['JobRemarks'],

        RequiredDate: formatdate(cnDetailsData['RequiredDate'], 'yyyy-MM-dd'),
        RequiredTime: formatdate(cnDetailsData['RequiredDate'], 'HH:mm'),
        ReqTimeDesc: cnDetailsData['ReqTimeDesc'],
        Handling: cnDetailsData['HandlingType'],
        Delivery: cnDetailsData['DeliveryType'],
        Fumigation: cnDetailsData['Fumigation'] == 'Y' ? 'YES' : 'NO',
        HaulageRate: `RM ${cnDetailsData['HaulageRate']}`,
        Commodity: cnDetailsData['Commodity'],
        ContRemarks: cnDetailsData['CNRemarks'],
        movementDetail: (cnDetailsData['MovementDetails'] || []).map((mvt, i) => {
            return { ...mvt, Seq: i + 1 }; 
        }),

        AdvisedDelTime: this.tripDetailsData[0] ? this.tripDetailsData[0]['Advised Date'] : '',
        RequiredDelTime: this.tripDetailsData[0] ? this.tripDetailsData[0]['Required Date'] : '',
        EventDelTime: this.tripDetailsData[0] ? this.tripDetailsData[0]['Event Date'] : '',
        AdvisedColTime: this.tripDetailsData[1] ? this.tripDetailsData[1]['Advised Date'] : '',
        RequiredColTime: this.tripDetailsData[1] ? this.tripDetailsData[1]['Required Date'] : '',
        EventColTime: this.tripDetailsData[1] ? this.tripDetailsData[1]['Event Date'] : '',

        _isDiversion1: (cnDetailsData['Diversion'] || []).length > 0,
        _isDiversion2: (cnDetailsData['Diversion'] || []).length > 2,
      };

      (cnDetailsData['Diversion'] || []).forEach((div, index) => {
        const n = index + 1;
        reportData[`Diversion${n}`] = div ? `Diversion ${n}` : '';
        reportData[`Div${n}`] = div ? div.DiverDest : '';
        reportData[`Div${n}Company`] = div ? div.Company : '';
        reportData[`Div${n}Addr`] =
          div ?
            (() => {
              const addrParts = [div.Addr1, div.Addr2, div.Addr3].filter(Boolean);
              let address = addrParts.join('<br>');
              const locationParts = [div.PostCode, div.City, div.State].filter(Boolean);
              if (locationParts.length) {
                address += (address ? '<br>' : '') + locationParts.join(', ');
              }
              return address;
            })()
          : '';

        reportData[`Div${n}PhoneLabel`] = div ? 'TEL' : '';
        reportData[`Div${n}PhoneValue`] = div ? div.Phone : '';
        reportData[`Div${n}AttnLabel`] = div ? 'ATTN' : '';
        reportData[`Div${n}AttnValue`] = div ? `${div.Attn} (${div.Phone2})` : '';
      });

      this.designerV3ReportData = [reportData];
      this.designerV3SharedData = reportData;
      this.downloadFileName = `${cnDetailsData['ConsignmentNo']}_${new Date().formatString('yyyyMMddHHmm')}`;
      this.designerV3IsShown = true;
    },
    designerV3CloseClicked: function () {
      this.designerV3SharedData = {};
      this.designerV3IsShown = false;
    },
    remarksStatusTableBoxRowSelected: function (selectedRow) {
      if (selectedRow.Status.includes('Delivery Remarks')) {
        this.selectedDeliveryRemarks = selectedRow['Remarks'];
      } else {
        this.selectedCollectionRemarks = selectedRow['Remarks'];
      }
    },
    // To clear update status variables
    checkRightMenuOpen: function () {
      if (!this.showTripDetails && !this.updateStatusTaskClicked) {
        this.radioCallResultMessage = '';
        this.radioCallUpdateSuccess = null;
      }
    },
    clearErrMsgs: function () {
      this.RFCDropdownErrMsgs = [];
      this.RFCDocRefNoInputErrMsgs = [];
      this.RFCDateReceivedErrMsgs = [];
      this.RFCDateToCollectErrMsgs = [];
      this.popupEntrySuccessMessages = [];
      this.popupEntryErrorMessages = [];
      this.ContainerNoErrMsg = '';
      this.RequiredDateErrMsg = '';
      this.PlanDateErrMsg = '';
      this.PMCodeErrMsg = '';
      this.DriverErrMsg = '';
      this.operatorErrMsg = '';
      this.selectDestErrMsg = '';
      this.HoldRemarksErrMsg = [];
      this.DocsTypeInputErrMsg = '';
      this.ReceiveDateErrMsg = '';
      this.selectedEditRow = [];
      this.jobTypeErrMsg = '';
      this.jobTypeErrMsg = '';
      this.updateTRDateErrMsg = '';
      this.radioCallResultMessage = '';
      this.selectedTrailerNoErrorMsg= '';
    },
    clearField: function () {
      this.clearErrMsgs();
      this.saveClicked = false;
      this.disabledConsignment = [];
      this.consignmentsAcknowledgement = [];
      this.consignmentButtonSelected = null;
      this.newContainerNo = '';
      this.newSealNo = '';
      this.newContOptInput = '';
      this.selectedJobType = null;
      this.remarks = '';

      // Required Date
      this.newReqDateValue = null;
      this.requiredTimeDescSelectedObject = null;
      this.requiredTimeDescSearch = '';
      this.officeHrsChecked = false;
      this.newReqPlanRemarksInput = '';

      // Plan Date
      this.planDateValue = null;
      this.selectedShift = null;
      this.selectedTeam = null;
      this.selectedPMCode = null;
      this.selectedDriver = null;
      this.selectedPriority = null;

      // Remarks
      this.selectedDeliveryInstruction = '';
      this.showRemarkPopup = false;
      this.popupRemarkLists = [];
      this.newlyAddedRowIds = new Set();
      this.deletedOriginalRows = [];
      this.selectedDeliveryRemarks = '';
      this.selectedCollectionRemarks = '';

      // Voy Info
      this.selectedSCN = null;
      this.selectedVesselID = null;
      this.selectedVesselName = null;
      this.vesselIDFreeText = '';
      this.vesselNameFreeText = '';
      this.shippingLineInput = '';
      this.selectedShippingAgent = null;
      this.finalDestinationInput = '';
      this.bookingRefNoInput = '';
      this.ETADateTimeValue = null;
      this.ETDDateTimeValue = null;
      this.closingDateTimeValue = null;
      this.detentionDateTimeValue = null;
      this.selectedDropOff = null;
      this.newVoyRemark = '';

      // Document received
      this.docTypeSelected = { label: 'Cheque', keyValue: '0' };
      this.docNoInput = '';
      this.recRemarksInput = '';
      this.receiveDateTimeValue = new Date();

      // Destination
      this.selectedDest = null;

      // Trailer
      this.trHistoryList = [];
      this.selectedTrailerNo = null;
      this.RadioCallHistoryTableBoxSelectedRow = [];

      //Right Menu
      this.radioCallUpdateSuccess = null;

      //Diversion
      this.diverpickupori = '0';
      this.diverinternal = '';
      this.diverseqno = '';
      this.cnno = '';
      this.selectedDiversionLoc1 = null;
      this.selectedDiversionLoc2 = null;
      this.selectedDiversionLoc3 = null;
      this.selectedDiversionLoc4 = null;
      this.diversionLoc1 = '';
      this.cnnoLoc1 = '';
      this.diversionLoc2 = '';
      this.cnnoLoc2 = '';
      this.diversionLoc3 = '';
      this.cnnoLoc3 = '';
      this.diversionLoc4 = '';
      this.cnnoLoc4 = '';
      this.internalDiversionLoc1 = false;
      this.internalDiversionLoc2 = false;
      this.internalDiversionLoc3 = false;
      this.internalDiversionLoc4 = false;
      this.remarksDiversionLoc1 = '';
      this.remarksDiversionLoc2 = '';
      this.remarksDiversionLoc3 = '';
      this.remarksDiversionLoc4 = '';
      this.jobDetailForDiversion = null;
    },
  },
  async mounted() {
    const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=HMS&page=Quick Find`);
    sasControl.forEach((k) => {
      if (k.Control === 'cmdRFC') {
        this.rfcUpdateEnabled = k.PropertiesValue === 'True';
      }
      if (k.Control === 'cmdUpdateContNo') {
        this.editContainerEnabled = k.PropertiesValue === 'True';
      }
    });

    const mountedPromises = [];
    let totalPromisesFulfilledCount = 0;

    mountedPromises.push(
      this.$apiCallV2('/Login/GetDetails').then((result) => {
        this.loginDetails = result;
        this.designerV2ReportFile = [`CN_${this.loginDetails['CoRefname']}.json`]; // Wrap in an array. For now, this page only uses one template per CN
        this.designerV2ReportFileDiversion = [`CNDiversion_${this.loginDetails['CoRefname']}.json`]; // Wrap in an array. For now, this page only uses one template per CN
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.getQuickFindField('searchby').then((results) => {
        this.filtersSearchByDropdownItems = results;

        if (results && results.length > 0) {
          if(this.$route.query['cnno']){
            this.filtersSearchByDropdownSelectedObject = this.filtersSearchByDropdownItems.find((i) => {
              return i['Search'] == 'Consignment #';
            });
            this.filtersSearchValueControlType = this.filtersSearchByDropdownSelectedObject.ControlType;
          } else {
            this.filtersSearchByDropdownSelectedObject = results[0]; // default to first search by field
            this.filtersSearchValueControlType = results[0].ControlType;
          }
        }

        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.getQuickFindField('criteria').then((results) => {
        this.filtersSearchCriteriaDropdownItems = results;

        if(results && results.length > 0){
          if(this.$route.query['cnno']){
            this.filtersSearchCriteriaDropdownSelectedObject = this.filtersSearchCriteriaDropdownItems.find((i) => {
              return i['Criteria'] == 'EQUALS TO';
            });
          }else{
            this.filtersSearchCriteriaDropdownSelectedObject = this.filtersSearchCriteriaDropdownItems[0]; // default to first criteria
          }
        }
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.getQuickFindField('viewoption').then((results) => {
        this.filtersViewOptionsDropdownItems = results;

        if (results && results.length > 0) {
          this.filtersViewOptionsDropdownSelectedObject = this.filtersViewOptionsDropdownItems[0]; // default to first view option
        }
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'PMCODE' }).then((result) => {
        this.PMList = result.map((pm) => ({
          ...pm,
          'Code - Name': `${pm['PM Code']} - ${pm['PM Number']}`,
        }));
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'jobtype', module: 'HMS' }).then((result) => {
        this.allJobTypes = result;
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTDRIVER' }).then((result) => {
        this.driverList = result.map((driver) => ({
          ...driver,
          'Code - Name': `${driver['Driver Code']} - ${driver['Driver Name']}`,
        }));
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'HMSTEAM' }).then((result) => {
        this.teamList = result;
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTSHIFT' }).then((result) => {
        this.shiftList = result;
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SHIPCALLNO' }).then((result) => {
        this.SCNList = result;
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'VESSELID' }).then((result) => {
        this.vesselList = result;
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'DESTINATION' }).then((result) => {
        this.destList = result.map((dest) => ({
          ...dest,
          'Code - Name': `${dest['Destination Code']} - ${dest['Company']}`,
        }));
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'port' }).then((result) => {
        this.portList = result.map((port) => ({
          ...port,
          'Code - Name': `${port['Port Code']} - ${port['Port Location']}`,
        }));
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'shippingagent' }).then((result) => {
        this.shippingAgentList = result.map((item) => {
          return {
            ...item,
            'Code - Name': `${item['Agent Code']} - ${item['Agent Name']}`,
          };
        });
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'VEHICLE' }).then((result) => {
        this.trailerList = result.map((item) => {
          return {
            ...item,
            'Code - Name': `${item['Inventory #']} - ${item['Inventory Code']}`,
          };
        });
        this.trailerList = this.trailerList.filter(
          (item) =>
            item.Category?.trim().toUpperCase().includes('TRAILER') ||
            item.Category?.trim().toUpperCase().includes('SIDE LOADER'),
        );
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'destination', module: 'HMS' }).then((result) => {
        this.diversionLocation = result;
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SENDTO_ALL' }).then((result) => {
        const trimmedResult = this.$deepTrimJsonV3(result);
        this.sendToItems = trimmedResult.map((item) => {
          return {
            ...item,
            Description: `${item['Destination Code']} - ${item['Company']}`,
          };
        });
        this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    
    // mountedPromises.push(
    //   this.$apiCallV2('/Login/GetDetails').then((result) => {
    //     this.loginDetails = result;
    //     this.designerV2ReportFile = [`CN_${this.loginDetails['CoRefname']}.json`]; // Wrap in an array. For now, this page only uses one template per CN
    //     this.designerV2ReportFileDiversion = [`CNDiversion_${this.loginDetails['CoRefname']}.json`]; // Wrap in an array. For now, this page only uses one template per CN
    //     this.$topLoading(++totalPromisesFulfilledCount / mountedPromises.length);
    //   }),
    // );
    
    await Promise.allSettled(mountedPromises);

    if (this.$route.query['cnno']) {
      Promise.allSettled(mountedPromises).then(async (_promiseOutcomes) => {
        this.filtersSearchInputValue = this.$route.query['cnno'].trim();
        await this.filtersRefreshClicked();
        this.consignmentsTableBoxRowSelected(this.consignmentsTableBoxTableData[0], true);
        await this.$sleep(500);
        this.consignmentsTableBoxSelectedRow = [this.consignmentsTableBoxTableData[0]];
        this.selectedIndex = [0];
      });
    }
  },
  watch: {
    showTripDetails: 'checkRightMenuOpen',
    updateStatusTaskClicked: 'checkRightMenuOpen',

    selectedDiversionLoc1: function (val) {
      if (val && this.diversionDetails.length == 0) {
        this.diversionLoc1 = val['Address'];
      }
    },
    selectedDiversionLoc2: function (val) {
      if (val && this.diversionDetails.length == 1) {
        this.diversionLoc2 = val['Address'];
      }
    },
    selectedDiversionLoc3: function (val) {
      if (val && this.diversionDetails.length == 2) {
        this.diversionLoc3 = val['Address'];
      }
    },
    selectedDiversionLoc4: function (val) {
      if (val && this.diversionDetails.length == 3) {
        this.diversionLoc4 = val['Address'];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.menu-action {
  margin-bottom: 5px;
  display: block;
  text-align: left;
  width: 100%;

  > .menu-action-icon {
    height: 20px;
    width: 20px;
  }
}

.menu-scroll::-webkit-scrollbar {
  display: none;
}

.consignment-main-container {
  padding: 10px 10px 10px 45px;
  display: flex;
  flex-direction: row;
  font-size: 12px;

  > .designer-v2-container {
    position: fixed;
    top: $top-nav-height;
    left: 0;
    height: calc(100% - #{$top-nav-height});
    width: 100%;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);

    > .designer-v2-component-container {
      height: 95%;
      width: 90%;
    }
  }

  > .menu-container {
    margin-right: 5px;

    .collapsed-menu {
      // for the most part, the styling is the same for both menus
      margin-top: 5px;
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }

  > .main-content {
    margin-right: 5px;
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    > .filters-container {
      margin-bottom: 5px;
      border-radius: 5px;
      width: 100%;
      background-color: white;
      padding: 5px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;

      > .filters-summary,
      .last-refreshed {
        margin: 0 5px 0 5px;
      }

      .refresh-button-container {
        display: flex;
        justify-content: flex-end;
      }
    }

    > .consignments-table-box-container {
      background-color: white;
      height: 100%;
      border-radius: 5px;
      padding: 5px;
      overflow: hidden;
    }
  }

  .popupentry-body {
    scroll-behavior: auto;
    overflow-y: auto;
    height: 100%;
    display: flex;
    flex-direction: column;

    > .popupentry-content {
      padding: 5px;

      ::v-deep {
        // deep needed to target the content class inside the PopupV2 component
        .content {
          // NOT the content class for slot, but content class inside PopupV2 itself
          overflow: visible;
        }
      }

      .form-row {
        display: flex;
        flex-direction: row;
        padding: 0 5px 0 5px;

        > .input-field {
          margin-right: 6px;
        }

        > .office-hours-checkbox-container {
          margin-left: 10px;
          display: flex;
          align-items: center;
        }

        > .conditional-date-time-picker-container {
          display: flex;
          flex-direction: row;

          > span {
            margin-left: 10px;
          }
        }
      }
    }

    > .contacts-table-box {
      overflow: hidden;
      flex: 1;
    }

    > .call-to-action-buttons {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      padding: 5px 0 5px 0;

      > button {
        margin: 0 3px 0 3px;
      }
    }
  }

  > .rfc-acknowledgement-popup {
    .prompt {
      margin-bottom: 3px;
    }

    #to-mails-input-container {
      margin-bottom: 5px;
    }

    .collapsable-container {
      margin-bottom: 3px;

      > .header {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        user-select: none;

        > .expand-arrow {
          transition: transform 0.3s;
        }
      }

      > .email-input-container {
        overflow: hidden;
        transition: max-height 0.3s;
      }
    }
  }

  > .rfc-acknowledgement-contacts-popup-container {
    position: fixed;
    top: $top-nav-height;
    left: 0;
    height: calc(100% - #{$top-nav-height});
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100000;

    > .contacts-popup {
      height: 40%;
      width: 50%;
      padding: 5px;
      border-radius: 5px;
      background-color: white;
      display: flex;
      flex-direction: column;

      > .contacts-table-box {
        overflow: hidden;
      }

      > .call-to-action-buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding-top: 5px;

        > button {
          margin: 0 3px 0 3px;
        }
      }
    }
  }

  .acknowledgment-container {
    display: flex;
    height: 100%;

    > .sidebar {
      width: 25%;
      border-right: 2px solid rgb(180, 180, 180);
      padding-right: 5px;

      > .consignment-button {
        width: 100%;
        margin: 5px 0 5px 0;
        padding: 10px 0;
      }
    }

    > .consignment-details-main {
      margin-left: 10px;
      width: 100%;

      > .consignment-details-top {
        flex-grow: 1;

        > .consignment-title {
          margin: 5px;
        }
      }

      > .consignment-details-bottom {
        flex-grow: 1;
        margin: 20px 5px;

        > .prompt {
          margin-bottom: 3px;
        }

        #to-mails-input-container {
          margin-bottom: 5px;
        }

        .collapsable-container {
          margin-bottom: 3px;

          > .header {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            user-select: none;

            > .expand-arrow {
              transition: transform 0.3s;
            }
          }

          > .email-input-container {
            overflow: hidden;
            transition: max-height 0.3s;
          }
        }

        > .send-email-button {
          float: right;
          margin-top: 10px;
          padding: 15px;
        }
      }
    }
  }
}

.right-menu {
  display: flex;
  flex-direction: column;
  height: 100%;

  > .right-menu-body-scroll {
    flex: 1;
    overflow-y: auto;

    > .header {
      margin-top: 5px;
      border-radius: 5px;
      height: 30px;
      width: 100%;
      background-color: #535cda;
      padding-left: 5px;
      display: flex;
      align-items: center;

      > .title {
        color: white;
        font-weight: bold;
      }
    }
  }

  > .right-menu-footer {
    width: 100%;
    background-color: #535cda;
    height: 100px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 5px;
    position: relative;
    transition: 0.3s;
    min-height: 100px;
    justify-content: flex-end;

    > * {
      border-radius: 2.5px;
      background-color: white;
      width: 100%;
      height: 100%;
    }

    > .message-container {
      flex: 2;
      overflow: auto;
      padding: 5px;
      transition: 0.3s;
      position: absolute;
      left: 5px;
      bottom: 5px;
      max-height: calc(100% - 10px);
      height: 100%;
      max-width: calc(100% - 170px);
      width: 100%;
      z-index: 99;
      background: lightyellow;

      > * > * {
        > a {
          /* color: black; */
          cursor: pointer;
          padding: 2px;
          text-decoration: underline;
          color: blue;
        }
        a:hover {
          text-decoration: underline;
          background-color: yellow;
        }

        a:active {
          text-decoration: underline;
          background-color: royalblue;
        }
      }
    }
    > .buttons-container {
      flex: 1;
      display: flex;
      min-width: 160px;
      max-width: 160px;
      justify-content: space-around;
      /* align-items: space-around; */
      flex-direction: column;
      background-color: #535cda;

      > * {
        display: flex;
        justify-content: space-around;
        align-items: center;
        text-align: center;
        margin-left: 5px;

        > img {
          height: 25px;
          width: 25px;
          margin-right: 5px;
        }
      }
    }
  }
}

.right-menu-content-container {
  background-color: white;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 98;

  > * {
    width: 100%;
    padding: 5px;
    display: flex;
  }

  > .header-container {
    min-height: 30px;
    max-height: 30px;
    width: 100%;
    background-color: #535cda !important;
    // background-color: #f24a01;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-radius: 5px 5px 0 0;
    margin-bottom: 5px;

    > .header-back-button {
      padding-left: 5px;
      padding-right: 10px;
      cursor: pointer;
    }

    > .header-title {
      width: calc(100% - 30px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
    }
  }

  > .body-container {
    height: 100%;
    background-color: #eaeaea;
    overflow: auto;
  }

  > .footer-container {
    min-height: 50px;
    max-height: 50px;
    background-color: #eaeaea;
    align-items: center;
    border-top: 1px solid rgba(64, 64, 64, 0.5);
    width: 100%;

    > .message-container {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      padding: 5px;
      overflow: auto;
    }
  }
}
</style>
